(function ($) {
    $.fn.CMNPopup = function (options) {
        var defaults = { top: 100, overlay: 0.5, pvUrl: undefined, data: {}, popUpHeader: "", popUpDescription: "", headerSubtitle: "", icon: "", async: true, closeButton: undefined, popLevel: 0, onClose: undefined, onLoad: undefined, modalContent: undefined, isClearCheckBox: true, isAddShow: true };
        options = $.extend(defaults, options);

        let modalId = $(this).attr('id');

        // save the button that is triggering this modal, so we can set focus back to it after modal is closed (for a11y)
        let triggerBtn = options.triggerBtnId ? $('#' + options.triggerBtnId) : this.context.activeElement;

        var overlay = $("<div id='lean_overlay_" + options.popLevel + "'></div>");

        $("div[id='lean_overlay_" + options.popLevel + "']").remove();
        $("body").append(overlay);
        $("#lean_overlay_" + options.popLevel).css({ "display": "block", opacity: 0, "z-index": 9000 + ((options.popLevel * 1000) + 1) });
        $("#lean_overlay_" + options.popLevel).fadeTo(10, options.overlay);
        var OnClosePop = options.onClose;
        return this.each(function () {
            var o = options;
            var modal_id = $(this);
            let windowWidth = $(window).width();
            let leftPx;
            let modalWidth;

            if (o.closeButton != undefined) {
                $(modal_id).off('click', o.closeButton).on('click', o.closeButton, closeFun);
            }
            $(modal_id).off('click', '#closePopUp').on('click', '#closePopUp', closeFun);

            function closeFun() {
                if (o.allowCloseCallback && !o.allowCloseCallback()) {
                    DevUtils.logDebug(' allowCloseCallback function [' + o.allowCloseCallback.name + '()] not allowing close of modal', 'jQueryExtensions.closeFun()');
                    return;
                }

                close_modal(modal_id);
                if (!$("#_PartialViewtableContainer").is(':visible')) {
                    if (options.isClearCheckBox) {
                        //we have added "not("#IPAcknowledge")" under below because in PH Ip section no need to clear checkbox
                        $(".k-grid input[type='checkbox']").not(".IPAcknowledge,.ADTAcknowledge,.clschkFullCarePlan,.clschkFullCarePlanHead,.clsConfigUsers,.clsWFMandatorychk,.clschkServicePlan,.clsHierarchyChkBx,.clsRefralChkMember,.clsChkCPSignOff,.chkboxNonPrimaryAuth,.clschkHealthNotes,.clschkHealthNotesHead, .clschkFCPBarrier,.clschkFCPBarriersHead, .clschkFCPStrength, .clschkFCPStrengthsHead, .clschkFCPCareTeam, .clschkFCPCareTeamHead").removeAttr("checked");
                        $('.clsViewAuthReport').prop('disabled', true);  // disabled create packet when multiple tab's popup close in Auth summary grid
                        if ($('#hMenGdCP').is(':visible')) {
                            $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
                        }//in careplan section contextmenu is displaying even after checkbox is unchecked
                        if ($('.clsChkCrPlTmCrPlHead').is(':checked')) {
                            $('.clsChkCrPlTmCrPlHead').removeAttr("checked");
                        }
                        if ($("#divOpenCompGrid").is(':visible')) {
                            $(".divClsOpenComplaintsMALMenu.ContextChkMenu").hide();
                        }
                        if ($("#divOpenAuthGrid").is(':visible')) {
                            $(".divClsOpenAuthorizationMALMenu.ContextChkMenu").hide();
                        }
                    }
                    if (options.isAddShow)
                        $('.Add').show();
                    CustomAssignBtnVisibility();
                    if ($('.MyCareplan').length > 0) {
                        $('.HGMenu').hide();
                        $('.MyCareplan').show();
                    };
                    if ($('#HeaDiaCodeGrid').is(':visible')) {
                        ShowHideButtons();
                    }
                    if ($('.Appointments').length > 0) {
                        $('.HGMenu').hide();
                    };
                    if ($('#hdnCrPlTmCrPlEditCrPlId').val() == "") {
                        $('#btnTmCrPlNotesAdd').show();
                    }
                    else {
                        $('#btnTmCrPlNotesAdd').hide();
                    }
                    if ($(".hideAddIDTPer").length > 0 && $('#gvIDTPercentage .clschkIDTPercentage').length > 0)
                        $(".hideAddIDTPer").hide();
                    //prod-2543 
                    if ($('#dllCTActive').length > 0 && $('#dllCTActive').val() == '0')
                        $('.crtmAdd').hide();
                    // clearing the field if activity window is closed.
                    if ($('#activityForm').length == 0)
                        $('#bulkPatientIdAddActivity').val('');
                    // Visits Section View Popup Closing
                    if ($('#ddlEMR').length > 0 && ($('#ddlEMR').val() == '-1' || $('#ddlEMR').val() == '1')) {
                        $('#btnAddVisit').hide();
                    }

                    if ($('#ddlTypeOfAppointment').length > 0) {
                        CarePlanId = "";
                    }
                    if ($('#ddlSearchCareTeamType option:selected').text() == "PCP History") {
                        $('.crtmAdd').hide();
                    }
                    if ($("#AppServicePlan").length > 0 && $("#selectEpisodeAccessed").val() != 0) {
                        $('.clsbtnSpAddNew').hide();
                    }
                    if ($("#GuidingCareExternalOpportunitiesGrid:visible").length > 0) { $('#btnActivateMemberCareOpp').hide(); }

                    if ($("#TmCrPlRecAndCurGroupGrid").length > 0 && $(".clsChkCrPlTmCrPlGrid:checked").not('.clsChkCPSignOff').length === 0) {
                        $('#btnCrPlTmCrPlMyCarePlan').show();
                        $('.cplAdd').show();
                    }
                    if ($('#txtCrPlTmGoal').is(':visible') && $('#txtCrPlTmGoal').length > 0) {  // add goal popup close in team care plan.
                        $('#btnCrPlTmAddGoal').hide();
                    }
                    if ($('.clsManualtxtInterventionName').is(':visible') && $('.clsManualtxtInterventionName').length > 0) {  // add Intervention popup close in team care plan.
                        $('.clsAddManualIntrv').hide();
                    }
                    if (options.closeButton === '#btnMngeTermPopUpclose') {
                        btnCPOExpandAllRowsClick('#btnCPOExpandAllRows');
                    }

                    if ($("#TmCrPlBarrierGrid").length > 0) {
                        $('#btnEditGB').hide();
                        $('#btnAddGB').show();
                        $('#btnDeleteGB').hide();
                        $('#btnGBInProgressAll').hide();
                        $('#btnGBResolveAll').hide();
                    }

                    if ($("#TmCrPlStrengthGrid").length > 0) {
                        $('.btnEditSt').hide();
                        $('.btnDeleteSt').hide();
                        $('.btnAddSt').show();
                    }

                    if ($('#PatientRiskInformation .clsRiskInformation:checked').length === 0) {
                        $('#btnAddRiskShowPharmReport').show();
                        $('#btnEditRiskShowPharmReport').hide();
                        $('#btnDeleteRiskShowPharmReport').hide();
                    }

                    if ($("#UnifiedMedicationsList, #UnifiedMedicationsDetailsGrid").length > 0) {
                        showHideMedicationButtons();
                    }
                }

                if ($("#btnEditMyCP").length > 0) {
                    $("#btnEditMyCP").show();
                }
                if ($('#hdnPageName').length > 0) {
                    $('#hdnPageName').val('');
                }
            }
            loader(1);
            if (o.pvUrl && o.pvUrl != '') {
                DevUtils.logDebug('*** [' + modalId + '] CMNPopup 1 called ***', '$.fn.CMNPopup()', options, 'green');
                $.ajax({
                    url: o.pvUrl,
                    data: o.data,
                    async: o.async,
                    type: "GET",
                    error: function () {
                        $("#lean_overlay_" + o.popLevel).fadeOut(500);
                        CustomAlert('Error occurred!');
                        loader(0);
                    },
                    success: function (result) {
                        enhanceModal($(modal_id), o);

                        var _modal = $(modal_id)
                        _modal.AhsSetHtml(result);
                        modalWidth = $(modal_id).outerWidth();
                        leftPx = (windowWidth - modalWidth) / 2;  // center modal horizontally
                        _modal.find('.portletHead').remove();

                        _modal.prepend('<div class="portletHead" id="portletHeadHand"><span class="ah-modal-title"><h1 id="' + $(modal_id).attr('id') + '_h1">' + o.popUpHeader + '</h1></span><div style="float:right;"><a id="anchCollapse" style="display:none;" class="DbImgPopIn" title="Collapse" onclick="ResizeMyCalendarPopup(this,0);"></a>&nbsp;<a class="dbExpBtn" title="Expand" id="anchExpand" style="display:none;" onclick="ResizeMyCalendarPopup(this,1);"></a>&nbsp;<button id="closePopUp" class="ah-btn-close-modal" aria-label="close"><i class="far fa-times" aria-hidden="true"></i></button> </div>');
                        _modal.css({ "display": "block", "position": "fixed", "z-index": 9001 + ((o.popLevel * 1000) + 2), "left": leftPx + "px", "top": o.top + "px" });

                        _modal.fadeTo(0, 1, function () {
                            setTimeout(() => {
                                A11yModal.initA11yModal(modalId, options.a11yFocusableElements);
                                modalDrag(modal_id);
                                resizePopupKendoGrid('#' + modalId);
                            });
                        });

                        if (o.onLoad != undefined)
                            o.onLoad();
                        loader(0);
                    }
                });
            }
            else if (o.modalContent != undefined) {
                DevUtils.logDebug('*** [' + modalId + '] CMNPopup 2 called ***', '$.fn.CMNPopup()', options, 'green');
                $(modal_id).html('').html(o.modalContent);

                enhanceModal($(modal_id), o);

                modalWidth = $(modal_id).outerWidth();
                leftPx = (windowWidth - modalWidth) / 2;  // center modal horizontally
                $(modal_id).find('.portletHead').remove();

                $(modal_id).prepend('<div class="portletHead"><span class="ah-modal-title"><h1 id="' + $(modal_id).attr('id') + '_h1">' + o.popUpHeader + '</h1></span><button id="closePopUp" class="ah-btn-close-modal" aria-label="close"><i class="far fa-times" aria-hidden="true"></i></button></div>');
                $(modal_id).css({ "display": "block", "position": "fixed", "z-index": 9001 + ((o.popLevel * 1000) + 2), "left": leftPx + "px", "top": o.top + "px" });

                $(modal_id).fadeTo(200, 1, A11yModal.initA11yModal(modalId, options.a11yFocusableElements));
                resizePopupKendoGrid('#' + modalId);

                if (o.onLoad != undefined)
                    o.onLoad();
                loader(0);
            }
            else {
                DevUtils.logDebug('*** [' + modalId + '] CMNPopup 3 called ***', '$.fn.CMNPopup()', options, 'green');
                enhanceModal($(modal_id), o);

                modalWidth = $(modal_id).outerWidth();
                leftPx = (windowWidth - modalWidth) / 2;  // center modal horizontally
                $(modal_id).find('.portletHead').remove();
                $(modal_id).prepend('<div class="portletHead" id="portletHeadHand"><span class="ah-modal-title"><h1 id="' + $(modal_id).attr('id') + '_h1">' + o.popUpHeader + '</h1></span><button id="closePopUp" class="ah-btn-close-modal" aria-label="close"><i class="far fa-times" aria-hidden="true"></i></button> </div>');
                $(modal_id).css({ "display": "block", "position": "fixed", "z-index": 9001 + ((o.popLevel * 1000) + 2), "left": leftPx + "px", "top": o.top + "px" });
                $(modal_id).fadeTo(200, 1, A11yModal.initA11yModal(modalId, options.a11yFocusableElements));
                modalDrag(modal_id);
                resizePopupKendoGrid('#' + modalId);

                if (o.onLoad !== undefined) {
                    o.onLoad();
                }
                loader(0);
            }
            HideScroll();
        });
        function close_modal(modal_id) {
            $("#lean_overlay_" + options.popLevel).fadeOut(500);

            $(modal_id).removeAttr('style').css({ "display": "none" });
            if (($(modal_id).find("#selectActivityType").length === 1 || $(modal_id).find('#divHierarchyLevel').length === 1
                || $(modal_id).find('.clsClearMainContentView').length === 1 || $(modal_id).find('#CareOrganisationsGrid').length === 1) && ToValue(options.pvUrl, '') !== '') {
                $('#' + $(modal_id).attr('id')).html('');
                if (enableDomLogs) {
                    DomUtils.logDomData("Pop Up Close");
                }
            }// WHY IS THIS ONLY BEING CALLED IN A FEW SPECIFIC USE CASES??
            if (OnClosePop != undefined) {
                if (enableDomLogs) {
                    DomUtils.logDomData("Pop Up Close");
                }
                OnClosePop(true);
            }
            // CSC GCPROD-56195 forceful display:none if display:block
            if ($('#lean_overlay_' + options.popLevel).is(':visible')) {
                $("#lean_overlay_" + options.popLevel).css({ "display": "none" });
            }
            setTimeout(function () {
                resetOverlayScroll();
            }, 550);

            // for a11y, set focus back to the triggering button of the modal
            A11yUtil.setFocus(triggerBtn);

            // for a11y, remove any alert banners on the dialog so they don't come back if the dialog is reopened
            A11yAlerts.remove($(modal_id).attr('id'));

            // need to remove the width class for if/when the dialog is reused (popUpDialog1, popUpDialog2, etc. IDs are reused a lot)
            $(modal_id).removeClass(MODAL_WIDTH.XSMALL);
            $(modal_id).removeClass(MODAL_WIDTH.SMALL);
            $(modal_id).removeClass(MODAL_WIDTH.MEDIUM);
            $(modal_id).removeClass(MODAL_WIDTH.LARGE);
            $(modal_id).removeClass(MODAL_WIDTH.LARGE_FIXED);
            $(modal_id).removeClass(MODAL_WIDTH.SEMI_LARGE);
            if (ToValue(options.pvUrl, '') !== '') {
                $('#' + $(modal_id).attr('id')).html('');
                if (enableDomLogs) {
                    DomUtils.logDomData("Pop Up Close");
                }
            }

            A11yModal.closeModal();
        }

        /* function to upgrade modals to new style */
        function enhanceModal(modalElem, options) {
            let modalId = $(modalElem).attr('id');

            $(modalElem).addClass('ah-modal');
            $(modalElem).attr('aria-labelledby', modalId + '_h1');

            // set standard width (at some point we may to default to small, medium or large)
            $(modalElem).addClass(options.modalWidth ? options.modalWidth : '');

            setTimeout(() => {
                // add subtitle if present
                if (options.headerSubtitle) {
                    $(modalElem).find('.portletHead .ah-modal-title').after('<span class="ah-modal-subtitle"><h2 id="' + modalId + '_h2">' + options.headerSubtitle + '</h2></span>');
                }

                // add icon if present
                if (options.icon) {
                    $(modalElem).find('.portletHead .ah-modal-title #popUpDialog5_h1').before(options.icon);
                }
            }, 10);
        }
    }
})(jQuery);

(function ($) {
    $.fn.aToolTip = function (options) {
        /**
            setup default settings
        */
        var defaults = {
            // no need to change/override
            closeTipBtn: 'aToolTipCloseBtn',
            toolTipId: 'aToolTip',
            // ok to override
            fixed: false,
            clickIt: false,
            inSpeed: 200,
            outSpeed: 100,
            tipContent: '',
            toolTipClass: 'defaultTheme',
            xOffset: 5,
            yOffset: 5,
            onShow: null,
            onHide: null,
            dataItemName: 'toolTip'
        },
            // This makes it so the users custom options overrides the default ones
            settings = $.extend({}, defaults, options);

        return this.each(function () {
            var obj = $(this);
            /**
                Decide weather to use a title attr as the tooltip content
            */
            if (obj.attr('data-toolTip')) {
                var tipContent = obj.attr('data-toolTip');
            }
            else if (obj.attr('title')) {
                // set the tooltip content/text to be the obj title attribute
                var tipContent = obj.attr('title');
            } else {
                // if no title attribute set it to the tipContent option in settings
                var tipContent = settings.tipContent;
            }

            /**
                Build the markup for aToolTip
            */
            var buildaToolTip = function () {
                $('#' + settings.toolTipId).remove();
                $('body').append("<div id='" + settings.toolTipId + "' class='" + settings.toolTipClass + "'><p class='aToolTipContent'>" + tipContent + "</p></div>");

                if (tipContent && settings.clickIt) {
                    $('#' + settings.toolTipId + ' p.aToolTipContent')
                        .append("<a id='" + settings.closeTipBtn + "' href='#' alt='close'>close</a>");
                }
            },
                /**
                    Position aToolTip
                */
                positionaToolTip = function () {
                    var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
                    var soTop = (obj.offset().top - $('#' + settings.toolTipId).outerHeight() - settings.yOffset);
                    var soLeft = (obj.offset().left + obj.outerWidth() + settings.xOffset);
                    $('#' + settings.toolTipId).css({
                        top: ((soTop < 0) ? (obj.offset().top + settings.yOffset) : soTop + settings.yOffset) + 'px',
                        left: ((soLeft + $('#' + settings.toolTipId).outerWidth() + 20 > winWidth) ? (obj.offset().left - $('#' + settings.toolTipId).outerWidth() - settings.xOffset) : soLeft) + 'px'
                    })
                        .stop().fadeIn(settings.inSpeed, function () {
                            if ($.isFunction(settings.onShow)) {
                                settings.onShow(obj);
                            }
                        });
                },
                /**
                    Remove aToolTip
                */
                removeaToolTip = function () {
                    // Fade out
                    $('#' + settings.toolTipId).stop().fadeOut(settings.outSpeed, function () {
                        $(this).remove();
                        if ($.isFunction(settings.onHide)) {
                            settings.onHide(obj);
                        }
                    });
                };

            initaToolTip = function () {
                if (settings.tipContent != '') {
                    buildaToolTip();
                    positionaToolTip();
                }
            }
            /**
                Decide what kind of tooltips to display
            */
            // Regular aToolTip
            if (tipContent && !settings.clickIt) {
                // Activate on hover	
                obj.hover(function () {
                    // remove already existing tooltip
                    $('#' + settings.toolTipId).remove();
                    obj.attr({ title: '' });
                    buildaToolTip();
                    positionaToolTip();
                }, function () {
                    removeaToolTip();
                });
            }

            // Click activated aToolTip
            if (tipContent && settings.clickIt) {
                // Activate on click	
                obj.click(function (el) {
                    // remove already existing tooltip
                    $('#' + settings.toolTipId).remove();
                    obj.attr({ title: '' });
                    buildaToolTip();
                    positionaToolTip();
                    // Click to close tooltip
                    $('#' + settings.closeTipBtn).click(function () {
                        removeaToolTip();
                        return false;
                    });
                    return false;
                });
            }

            // Follow mouse if enabled
            if (!settings.fixed && !settings.clickIt) {
                // Activate on mousemove
                obj.mousemove(function (el) {
                    var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
                    var soTop = (el.pageY - $('#' + settings.toolTipId).outerHeight() - settings.yOffset);
                    var soLeft = (el.pageX + settings.xOffset);
                    $('#' + settings.toolTipId).css({
                        top: ((soTop < 0) ? (el.pageY + settings.yOffset) : soTop + settings.yOffset) + 'px',
                        left: ((soLeft + $('#' + settings.toolTipId).outerWidth() + 20 > winWidth) ? (el.pageX - $('#' + settings.toolTipId).outerWidth() - settings.xOffset) : soLeft) + 'px',
                    })
                });
            }

            //Initiates aToolTip
            initaToolTip();

        }); // END: return this
    };
})(jQuery);



$(function () {
    if (!('placeholder' in document.createElement('input'))) {
        $("[placeholder]").focus(function () {
            if (this.value == $(this).attr("placeholder"))
                this.value = '';
            $(this).removeClass('empty');
        })
            .blur(function () {
                if (this.value == "")
                    this.value = $(this).addClass('empty').attr("placeholder");
                else
                    $(this).removeClass('empty');
            })
            .blur();
    }

});

$(window).resize(function () {
    if (window.top.isFullDashBoard) {
        if (zoomvar == $(document.body).css('zoom') && window.outerHeight > 700 && $("#MvcDbLoadCtrl").is(":visible")) {
            $(".k-grid,.k-scheduler,.k-chart").each(function () {
                var gridId = $(this)[0].id;
                setDashboardGrids(gridId);
            });
        }
        zoomvar = $(document.body).css('zoom');
        var oChat = $("#_myAlertsPartialViewContainer").find(".k-chart");
        var oReqRecGrid = $('#_requestReceivedPartialViewContainer').find('.k-grid:visible');
        if ($("#MvcDbLoadCtrl").is(":visible") && oChat.length > 0 && oReqRecGrid.length > 0) {
            if ($('.classDivHeader .DbImgPopIn:visible').length > 0) {
                $('.classDivHeader .DbImgPopIn:visible').trigger('click');
                if (oChat.is(':visible')) {
                    oChat.css("height", intialAltGridHeight);
                    oChat.data("kendoChart").refresh();
                }
                else {
                    oReqRecGrid.css("height", intialAltGridHeight);
                    $('#_myAlertsPartialViewContainer').find('.k-grid').data("kendoGrid").resize();
                }
                oReqRecGrid.css("height", intialReqGridHeight);
                oReqRecGrid.data("kendoGrid").resize();
            }
            else {
                if (oChat.is(':visible')) {
                    oChat.data("kendoChart").refresh();
                }
                else {
                    $('#_myAlertsPartialViewContainer').find('.k-grid').data("kendoGrid").resize();
                }
                oReqRecGrid.data("kendoGrid").resize();
                $('#_myMemberPartialViewContainer').find('.k-grid:visible').data("kendoGrid").resize();
                $('#MyCalenderDiv #scheduler').data("kendoScheduler").refresh();
            }
        }
    }
});

/**
 * Initializes the Work Queue Count Information tooltip on the specified container element.
 * @param {string} containerId - The ID of the container element for the tooltip (default: 'divWqCountInfo').
 */
function initWqCountInfoTooltip(containerId) {
    containerId = containerId || 'divWqCountInfo';
    var wqCountInfoTooltipConfig = {
        tooltipText: 'This count includes only referrals sent directly by a user. Referrals originating from a work queue do not display here.',
        width: TOOLTIP_WIDTH.MEDIUM,
        pointerDirection: TOOLTIP_POINTER_DIRECTION.TOP
    };
    new A11yTooltipInstance(containerId, 'Work Queue Count Information', wqCountInfoTooltipConfig);
}

$(document).off('click', '.clsBtnReqRejViewCarePlan').on('click', '.clsBtnReqRejViewCarePlan', function () {
    loader(1);
    var pidval = $(this).attr('id').split('_')[1];
    //loadDropDown(baseURL + '/Home/BindPatientAccessed?patId=' + x1, 'selectPatientAccessed');
    var patvalobj = { patId: pidval }
    var PAccddl = $("#selectPatientAccessed").data("kendoDropDownList");
    PAccddl.dataSource.read(patvalobj);
    PAccddl.value(pidval);
    $('#closePopUp').trigger('click');
    if (pidval == '' || pidval == 'undefined' || pidval == null) {
        CustomAlert('Invalid patient, Please select patient')
    } else {
        ClickFirePlan(pidval);
    }
});
$(document).off('click', '#btnReqRejAck').on('click', '#btnReqRejAck', function () {
    if (!$(this).hasClass("ReqRecAck")) { return false; }
    var selChkBx = $('#ReqRejGrid').find('input[type="checkbox"]:checked.clsRejectedChkMember');
    var appIds = ""
    $.each(selChkBx, function (key, item) {
        if ($(item).is(':checked')) {
            appIds += $(item).attr('Id').split('_')[1] + ",";
        }
    });
    if (appIds == "") {
        CustomAlert('Please select at least one record');
    }
    else {
        appIds = appIds.substr(0, appIds.length - 1);
        $.ajax({
            type: "GET",
            url: baseURL + "/RequestRejectedDashboard/UpdateAppStatusAck",
            dataType: "json",
            data: {
                'careStaffId': getMemberId().MemberId,
                'appIds': appIds,
                'ackFlag': true
            },
            success: function (data) {
                if (data.success) {
                    $('#btnRequestReceivedSearch').trigger('click');
                }
            }
        });
    }
});
$(document).off('click', '#divAppointmentMenuView_,#divAppointmentMenuReject_').on('click', '#divAppointmentMenuView_,#divAppointmentMenuReject_', function () {
    var chkboxes = $('#ReqRecGrid').find('input[type="checkbox"]:checked.clsRefralChkMember');
    if ($(this).attr('id') == 'divAppointmentMenuView_')
        slcId = 0;
    else if ($(this).attr('id') == 'divAppointmentMenuReject_')
        slcId = 6;
    if (chkboxes.length == 1 || $('#divAppointmentMenuRefral_').is(':visible') === true) {
        var patientIdFromCheckbox;
        if ($(chkboxes[0]).attr('id') && $(chkboxes[0]).attr('id').split('_')[1]) {
            patientIdFromCheckbox = $('#chkAppointment_' + $(chkboxes[0]).attr('id').split('_')[1]).data('patientid');
        }       
        var patientId = patientIdFromCheckbox ? patientIdFromCheckbox : $('#hdnRequestReceivedRulePatientId').val();
        //appId = $(chkboxes[0]).attr('id') != undefined ? $(chkboxes[0]).attr('id').split('_')[1] : $('.GearIconCls.clsRefralMemberApp').attr('id').split('_')[1];
        appId = $(chkboxes[0]).attr('id') != undefined ? $(chkboxes[0]).attr('id').split('_')[1] : $('#hdnAppointmentId').val();
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/RequestReceivedDashboard/UpdateAppointment?appointmentId=" + appId + "&timeDictionaryObj=" + escape(timeZone) + "&patientid=" + patientId,
            onLoad: function () {
                onLoadUpdateAppointment(slcId);
                if ($('#HdnIsViewReqRecCMAPIsPh').val() != 'True') {
                    $("#btnUpdateAppointmentUpdatePopup").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_APPOINTMENTS", Id: "btnUpdateAppointmentUpdatePopup", IsFrom: "Edit", IsRemoveElement: true });

                }
                else
                    $("#btnUpdateAppointmentUpdatePopup").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_APPOINTMENT", Id: "btnUpdateAppointmentUpdatePopup", IsFrom: "Edit", IsRemoveElement: true });

            },
            closeButton: '#btnCloseAppointmentUpdatePopup',
            popUpHeader: "Update Appointment",
        });
    }
    chkboxes.removeAttr('checked');
    $('.ContextChkMenu').hide();
});
$(document).off('click', '.clsRefralChkMember').on('click', '.clsRefralChkMember', function () {
    var chkboxes;
    var pos;
    var IsAuthportalActivity;
    var isMALReqRec = isMAL || reqRecAndRejMAL;
    var authId;
    var patientId;
    var isMdPhysician;
    var activityId;
    var complaintId;
    if (isMALReqRec) {
        $('.divClsRefralMemberMenu').hide();
        var $grid = "";
        $grid = isMALReqRec ? $('#ReqRecGridMAL') : $('#ReqRecGrid');
        //if ($.trim($('#panelTitle,#requestHeaderName').text()) == 'Request Rejected') $grid = $('#ReqRejGrid')
        var gridid = isMALReqRec ? '#RequestReceivedGridDiv' : '#_requestReceivedPartialViewContainer';
        if ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) {
            gridid = '#memberGrid';
        }
        requestReferTypeMALGlobal = $('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text();
        var refTypeGlobal = isMALReqRec ? requestReferTypeMALGlobal : requestReferTypeGlobal;
        chkboxes = $grid.find('input[type="checkbox"]:checked.clsRefralChkMember');
        if (!$(this).hasClass('clsRejectedChkMember')) { ClearAllContextMenu('divRequestReceivedGrid'); };
        if (chkboxes.length == $grid.find('input[type="checkbox"].clsRefralChkMember').length) {
            $grid.find('input[type="checkbox"].clsRefralChkMembercol').prop('checked', true);
        }
        else {
            $grid.find('input[type="checkbox"].clsRefralChkMembercol').prop('checked', false);
        }
        if (chkboxes.length == 1) {
            pos = $(chkboxes[0]).offset();
            pos.top = setPstnCntxtMenu(chkboxes[0]);
            if (refTypeGlobal === "Appointment") {
                $(gridid + (isMALReqRec ? ' #divAppointmentMenuRefralMAL_' : ' #divAppointmentMenuRefral_')).show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            }
            else if (refTypeGlobal == "Care Plan") {
                $(gridid + (isMALReqRec ? ' #divCarePlanMenuRefralMAL_' : ' #divCarePlanMenuRefral_')).show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
                var isSensitive = $(this).attr('data-issensitive');
                if (isSensitive != undefined) {
                    isSensitive == "true" ? $('#divCarePlanMenuViewMAL_').hide() : $('#divCarePlanMenuViewMAL_').show();
                }
            }
            else if (refTypeGlobal.toLowerCase() === "messages" || (refTypeGlobal.toLowerCase() === "faxes" && $("#selMessageTypeRRcMAL").val() !== 'true')) {
                    $(gridid + (isMALReqRec ? ' #divMessageMenuRefralMAL_' : ' #divMessageMenuRefral_')).show().css('left', pos.left + "px").css('top', ((pos.top + 19) - $(window).scrollTop()) + "px");
            }
            else {
                if (refTypeGlobal.toLowerCase() !== "faxes") {
                    $(gridid + (isMALReqRec ? ' #divMemberMenuRefralMAL_' : ' #divMemberMenuRefral_')).show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
                }
            }

            if (refTypeGlobal == "UM Auth") {
                var IsProviderAuth = $(chkboxes).attr('data-isproviderauth');
                if (IsProviderAuth != undefined && IsProviderAuth == "true") { $('.divClsMemberMenuRejectMAL').hide(); } else { $('.divClsMemberMenuRejectMAL').show(); }
            }
            if (refTypeGlobal === "UM Activity") {
                IsAuthportalActivity = $(chkboxes).attr('data-isauthportalactivity');
                if (!$.fn.isNullOrEmpty(IsAuthportalActivity) && IsAuthportalActivity === "true") {
                    $('.divClsMemberMenuRejectMAL').hide();
                }
                else {
                    $('.divClsMemberMenuRejectMAL').show();
                }
                authId = $(chkboxes).attr('data-AuthId');
                patientId = $(chkboxes).attr('data-PatientId');
                isMdPhysician = $(chkboxes).attr('data-ismdphysician');
                let ParentActivityLogId = $(chkboxes).attr('data-parentactivitylogid');
                let authredirect = $(chkboxes).attr('data-authredirect');
                let IsPerform = $(chkboxes).attr('data-isPerform');
                activityId = $(chkboxes).attr('data-logid');
                let activityTypeName = $(chkboxes).attr('data-activitytypename');
                if (!$.fn.isNullOrEmpty(ParentActivityLogId) && activityTypeName.toLowerCase() === "additional information requested") {
                    $('#hdnActivityId').val(activityId);
                    $('#hdnParentActivityId').val(ParentActivityLogId);
                    $('#hdnActivityTypeName').val(activityTypeName);
                    $('#hdnIsPerform').val(IsPerform);
                    $('#hdnauthredirect').val(authredirect);
                }
                else {
                    $("#hdnAuthId").val(authId);
                    $("#hdnPatientId").val(patientId);
                    $("#hdnActivityId").val(activityId);
                }
                $('#divMemberMenuRefralMAL_').attr('data-authId', authId);
                $('#divMemberMenuRefralMAL_').attr('data-patientId', patientId);
                $('#divMemberMenuRefralMAL_').attr('data-logid', activityId);

                if (isNewMdrReview && (isMdPhysician === "true" || (activityTypeName.toLowerCase() === "additional information requested") && !$.fn.isNullOrEmpty(ParentActivityLogId))) {
                    //show
                    $("#divMemberMenuMALAcceptandPerform_").show();
                }
                else {
                    $("#divMemberMenuMALAcceptandPerform_").hide();
                }
            }
            if (refTypeGlobal === "AG Activity") {
                let isAcceptPerform = $(chkboxes).attr('data-isAcceptPerform');
                 complaintId = $(chkboxes).attr('data-complaintid');
                 patientId = $(chkboxes).attr('data-patientId');
                 activityId = $(chkboxes).attr('data-logid');
                let ParentActivityLogId = $(chkboxes).attr('data-parentactivitylogid');
                let activityTypeName = $(chkboxes).attr('data-activitytypename');
                if ((isNewAgMdrReview && isAcceptPerform === "true") || (!$.fn.isNullOrEmpty(ParentActivityLogId) && activityTypeName.toLowerCase() === "additional information requested")) {
                    $("#hdnComplaintId").val(complaintId);
                    $("#hdnPatientId").val(patientId);
                    $('#hdnActivityId').val(activityId);
                    $('#hdnParentActivityId').val(ParentActivityLogId);
                    $('#hdnActivityTypeName').val(activityTypeName);
                    $("#divMemberMenuMALAcceptandPerform_").show();
                }
                else {
                    $("#divMemberMenuMALAcceptandPerform_").hide();
                }
            }
        }
        else {
            $('.ContextChkMenu').hide();
        }
    }
    else {
        requestReferTypeGlobal = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
        var IsSensitive = $(this).attr('data-issensitive');
        $('.divClsRefralMemberMenu').hide();
        chkboxes = $('#ReqRecGrid').find('input[type="checkbox"]:checked.clsRefralChkMember');
        if (chkboxes.length == $('#ReqRecGrid').find('input[type="checkbox"].clsRefralChkMember').length) {
            $('#ReqRecGrid').find('input[type="checkbox"].clsRefralChkMembercol').prop('checked', true);
            $(this).parent().find('input[type=checkbox] #ReferelChkAll').prop('checked', true);
        }
        else {
            $('#ReqRecGrid').find('input[type="checkbox"].clsRefralChkMembercol').prop('checked', false);
        }
        if (chkboxes.length == 1) {
            pos = $(chkboxes[0]).offset();
            pos.top = setPstnCntxtMenu(chkboxes[0]);
            if (requestReferTypeGlobal == "Appointment") {
                AttchChildToParentOnScroll('divAppointmentMenuRefral_', pos);

            }
            else if (requestReferTypeGlobal == "Care Plan") {
                if (PHNavID == '' && !isProviderUser) {
                    AttchChildToParentOnScroll('divCarePlanMenuRefral_', pos);
                }

            }
            else if (requestReferTypeGlobal.toLowerCase() === "messages" || (requestReferTypeGlobal.toLowerCase() === "faxes" && $("#selMessageType").val() !== 'true')) {
                $('#divMessageMenuRefral_').show().css('left', pos.left + "px").css('top', ((pos.top + 19) - $(window).scrollTop()) + "px");
            }
            else if (requestReferTypeGlobal == "UM Auth") {
                var IsProviderAuth = $(chkboxes).attr('data-isproviderauth');
                if (IsProviderAuth != undefined && IsProviderAuth == "true") { $('.divClsMemberMenuReject').hide(); } else { $('.divClsMemberMenuReject').show(); }
                AttchChildToParentOnScroll('divMemberMenuRefral_', pos);
            }
            else if (requestReferTypeGlobal === "UM Activity") {
                IsAuthportalActivity = $(chkboxes).attr('data-isauthportalactivity');
                if (!$.fn.isNullOrEmpty(IsAuthportalActivity) && IsAuthportalActivity === "true") {
                    $('.divClsMemberMenuReject').hide();
                } else {
                    $('.divClsMemberMenuReject').show();
                }
                authId = $(chkboxes).attr('data-AuthId');
                patientId = $(chkboxes).attr('data-PatientId');
                isMdPhysician = $(chkboxes).attr('data-ismdphysician');
                let ParentActivityLogId = $(chkboxes).attr('data-parentactivitylogid');
                let authredirect = $(chkboxes).attr('data-authredirect');
                let IsPerform = $(chkboxes).attr('data-isPerform');
                let activityTypeName = $(chkboxes).attr('data-activitytypename');
                activityId = $(chkboxes).attr('data-logid');
                if (!$.fn.isNullOrEmpty(ParentActivityLogId) && activityTypeName.toLowerCase() === "additional information requested") {
                    $('#hdnActivityId').val(activityId);
                    $('#hdnParentActivityId').val(ParentActivityLogId);
                    $('#hdnActivityTypeName').val(activityTypeName);
                    $('#hdnIsPerform').val(IsPerform);
                    $('#hdnauthredirect').val(authredirect);
                }
                else {
                    $("#hdnAuthId").val(authId);
                    $("#hdnPatientId").val(patientId);
                    $("#hdnActivityId").val(activityId);
                }
                AttchChildToParentOnScroll('divMemberMenuRefral_', pos);
                $('#divMemberMenuRefral_').attr('data-authId', authId);
                $('#divMemberMenuRefral_').attr('data-patientId', patientId);
                $('#divMemberMenuRefral_').attr('data-logid', activityId);


                if (isNewMdrReview && (isMdPhysician === "true" || (!$.fn.isNullOrEmpty(ParentActivityLogId) && activityTypeName.toLowerCase() === "additional information requested"))) {
                    //show
                    $("#divMemberMenuAcceptandPerform_").show();
                }
                else {
                    $("#divMemberMenuAcceptandPerform_").hide();
                }
            }
            else if (requestReferTypeGlobal === "AG Activity") {
                let isAcceptPerform = $(chkboxes).attr('data-isAcceptPerform');
                 complaintId = $(chkboxes).attr('data-complaintid');
                 patientId = $(chkboxes).attr('data-patientId');
                 activityId = $(chkboxes).attr('data-logid');
                let ParentActivityLogId = $(chkboxes).attr('data-parentactivitylogid');
                let activityTypeName = $(chkboxes).attr('data-activitytypename');
                AttchChildToParentOnScroll('divMemberMenuRefral_', pos);
                if ((isNewAgMdrReview && isAcceptPerform === "true") || (!$.fn.isNullOrEmpty(ParentActivityLogId) && activityTypeName.toLowerCase() === "additional information requested")) {
                    $("#hdnComplaintId").val(complaintId);
                    $("#hdnPatientId").val(patientId);
                    $('#hdnActivityId').val(activityId);
                    $('#hdnParentActivityId').val(ParentActivityLogId);
                    $('#hdnActivityTypeName').val(activityTypeName);
                    $("#divMemberMenuAcceptandPerform_").show();
                }
                else {
                    $("#divMemberMenuAcceptandPerform_").hide();
                }
            }
            else {
                if (PHNavID === '' && !isProviderUser && requestReferTypeGlobal.toLowerCase() !== "faxes" ) {
                    AttchChildToParentOnScroll('divMemberMenuRefral_', pos);
                }

            }
            if (IsSensitive != undefined) {
                IsSensitive == "true" ? $('.divClsCarePlanMenuView').hide() : $('.divClsCarePlanMenuView').show();
            }
        }
        else {
            $('.ContextChkMenu').hide();
        }
        if ((requestReferTypeGlobal == "Activity") && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
            var chkActivityCount = 0;
            var listCheckBox = $('.clsRefralChkMember:checked');
            var listCheckBoxUnchecked = $('.clsRefralChkMember:not(:checked)');
            $.each(listCheckBox, function (key, item) {
                if ($(item).is(':checked')) {
                    chkActivityCount++;
                }
            });
            if (chkActivityCount > 1) {
                $("#btnRequestReceivedAccept").css("display", "block");
                $.each(listCheckBox, function (key, item) {
                    if ($(item).is(':checked')) {
                        gearIconID = 'GearIconCls_' + $(item).data('referenceid');
                        $('#' + gearIconID).attr("disabled", true);
                    }
                });
            }
            else {
                $("#btnRequestReceivedAccept").css("display", "none");
                $('.GearIconCls').removeAttr("disabled");
            }
            $.each(listCheckBoxUnchecked, function (key, item) {
                gearIconID = 'GearIconCls_' + $(item).data('referenceid');
                $('#' + gearIconID).removeAttr("disabled");
            });
        }
    }
});

$(document).off('click', '.clsRefralChkMembercol').on('click', '.clsRefralChkMembercol', function () {
    $('input[type="checkbox"]:not(:disabled).clsRefralChkMember').prop('checked', $(this).prop('checked'));
    var $grid = $(isMAL?'#ReqRecGridMAL':'#ReqRecGrid');
    var chkboxes = $grid.find('input[type="checkbox"]:checked.clsRefralChkMember');
    var enbledChkBoxes = $grid.find('input[type="checkbox"]:not(:disabled).clsRefralChkMember');
    requestType = $(isMAL ? '#selectRequestReceivedReferTypeMAL' : '#selectRequestReceivedReferType').data("kendoDropDownList").text();
    ClearAllContextMenu('divRequestReceivedGrid');
    $('.divClsRefralMemberMenu').hide();
    $('.divClsRefralCarePlanMenu').hide();
    if ($(this).is(':checked') && (chkboxes.length === 1 || enbledChkBoxes.length === 1)) {
        var pos = $(chkboxes[0]).offset();
        pos.top = setPstnCntxtMenu(chkboxes[0]);

        if ((requestType === "Activity") || (requestType === "Member") || (requestType === "UM Activity") || (requestType === "AG Activity") || (requestType === "AG Complaint") || (requestType === "UM Auth")) {
            $(isMAL ? '#divMemberMenuRefralMAL_' : '#divMemberMenuRefral_').show().css({ 'left': (pos.left + 15) + "px", 'top': (pos.top - $(window).scrollTop()) + "px" });
            $(isMAL?'#divCarePlanMenuRefralMAL_' : '#divCarePlanMenuRefral_').hide();
        }
        else if (requestType == "Care Plan") {
            $(isMAL ? '#divCarePlanMenuRefralMAL_' : '#divCarePlanMenuRefral_').show().css({ 'left': (pos.left + 15) + "px", 'top': (pos.top-$(window).scrollTop()) + "px" });
            $(isMAL ? '#divMemberMenuRefralMAL_' : '#divMemberMenuRefral_').hide();
        }
        else if (requestType == "Care Plan Review") {
            var hideIDs = isMAL ? '#divCarePlanMenuRefralMAL_, #divMemberMenuRefralMAL_' : '#divCarePlanMenuRefral_,#divMemberMenuRefral_';
            $(hideIDs).hide();
        }
    }
    else {
    }
    if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) {
        if (requestType == "Activity") {
            if ($("#ReferelChkAll").prop('checked') == true && chkboxes.length > 0) {
                $("#btnRequestReceivedAccept").css("display", "block");
                $.each(chkboxes, function (key, item) {
                    if ($(item).is(':checked')) {
                        gearIconID = 'GearIconCls_' + $(item).data('referenceid');
                        $('#' + gearIconID).attr("disabled", true);
                    }
                });
            }
            else {
                $("#btnRequestReceivedAccept").css("display", "none");
                $('.GearIconCls').removeAttr("disabled");
            }
        }
    }
});

$(document).off('click', '.authRedirectUMPageCls').on('click', '.authRedirectUMPageCls', function () {
    var lstAuthRedVals = $(this).data('authredirect').split('|');
    SetAuthDatanew(lstAuthRedVals[0], lstAuthRedVals[1], lstAuthRedVals[2], lstAuthRedVals[3], lstAuthRedVals[4], lstAuthRedVals[5]);
});

$(document).off('click', '#btnSendRequestRejectComments').on('click', '#btnSendRequestRejectComments', function () {
    loader(1);
    var idrejection = $('#hdnSendRequestRejectCommentsRejectionId').val();
    var requestReferTypeGlobalLatest = isMAL ? requestReferTypeMALGlobal : requestReferTypeGlobal;
    var ruleEventSource = "";
    var rulePatientId = $('#hdnRequestReceivedRulePatientId').val();
    if ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) {
        rulePatientId = $('#chkMember_' + idrejection).data('patientid');
    }
    if (requestReferTypeGlobalLatest === "Activity") {
        ruleEventSource = "RRCMACTIVITYREJECT";
    } else if (requestReferTypeGlobalLatest === "Member") {
        ruleEventSource = "RRCMMEMBERREJECT";
    } else {
        ruleEventSource = "";
    }
    //To Implement UM Activity Reject Functionality
    if (requestReferTypeGlobal != "WLMActMem") {
        var queueId = $('#chkUMActivity_' + idrejection).data('queueid');
        var logId = $('#chkUMActivity_' + idrejection).data('logid');
    }
    var reasonForRejection = escapeHtml($('#txtareaRequestRejectComments').val());
    var confidentialNoteTypeId = 0;
    reasonForRejection = reasonForRejection.replace(/</g, '‹');
    $('#divtxtareaReqRjctComments').find('.validationMessage').remove();
    $('#tdRequestFrom').find('.validationMessage').remove();
    if ($("#ddlRequestFrom").is(':visible')) {
        if ($('#ddlRequestFrom').val() == "-1") {
            $('#tdRequestFrom').append('<span class="validationMessage"  style="color:red">*</span>');
            loader(0);
            return false;
        }
    }
    else if (!$('#rejectRequestFrom #spnRequestRejectCommentsRequestFrom').is(':visible') && (requestReferTypeGlobalLatest === "UM Auth" || requestReferTypeGlobalLatest === "UM Activity") && $.fn.isNullOrEmpty($('#hdnRequestFrom').val())) {
        $('#tdRequestFrom').append('<span class="validationMessage"  style="color:red">*</span>');
        loader(0);
        return false;
    }

    if ($.trim($('#txtareaRequestRejectComments').val()) == "") {
        $('#divtxtareaReqRjctComments').append('<span class="validationMessage" style="color:red">*</span>'); loader(0);
        return false;
    }
    var authRedirect = $('#hdnSendRequestRejectCommentsRejectionAuthRedirect').val();
    var referTo = (!$("#ddlRequestFrom").is(':visible') && (requestReferTypeGlobalLatest === "UM Auth" || requestReferTypeGlobalLatest === "UM Activity")) ? $('#hdnRequestFrom').val() :$('#ddlRequestFrom').val();
    if ($('#divReqRjctIsConfidential').is(":visible"))
        confidentialNoteTypeId = $('input[name=rdoRequestRejectIsConfidential]:checked').val();
    $('#RequestRejectIsConfidential').html('');
    //var url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + idrejection + "&reasonForRejection=" + reasonForRejection + "&referTo=" + referTo;;
    var tmpisexternalactivity = $("#hdnIsExternalActivity").val();
    var tmpisexternalactivityPatinetId = $("#hdnIsExternalActivityPatientID").val();
    var url = baseURL + "/Home/RequestReject";
    var data = {
        referType: requestReferTypeGlobalLatest,
        Id: idrejection,
        reasonForRejection: reasonForRejection,
        referTo: referTo,
        isexternalactivity: tmpisexternalactivity,
        confidentialNoteTypeId: confidentialNoteTypeId,
        isexternalactivityPatinetId: tmpisexternalactivityPatinetId,
        patientId: rulePatientId,
    };
    if (requestReferTypeGlobal == "WLMActMem") {
        queueId = $('#hdnqueueIds').val();
        var followUpId = $('#hdnpatientFollowUpIds').val();
        confidentialNoteTypeId = null;
        if ($('#divReqRjctIsConfidential').is(":visible")) {
            confidentialNoteTypeId = $('input[name=rdoRequestRejectIsConfidential]:checked').val();
        }

        if ($('#ddlPActReferTypeCM').val() == 'Activity') {
            idrejection = "";
        }
        url = baseURL + "/RequestRejectedDashboard/WLMCMReject";
        data = {
            gcFlagId: 4,
            patientFollowUpIds: followUpId,
            queueIds: queueId,
            referenceIds: idrejection,
            reason: reasonForRejection,
            confidentialNoteTypeId: confidentialNoteTypeId,
        };
    }
    else if (requestReferTypeGlobalLatest == "UM Auth") {
        //url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + idrejection + "&reasonForRejection=" + reasonForRejection + '&authRedirect=' + authRedirect + "&referTo=" + referTo;;
        data = {
            referType: requestReferTypeGlobalLatest,
            Id: idrejection,
            reasonForRejection: reasonForRejection,
            authRedirect: authRedirect,
            referTo: referTo,
            patientId: rulePatientId,
        };
        ruleEventSource = "RRUMAUTHREJECT";
    }
    else if (requestReferTypeGlobalLatest == "UM Activity") {
        //  url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + idrejection + "&reasonForRejection=" + reasonForRejection + '&queueId=' + queueId + '&logId=' + logId + "&referTo=" + referTo;;
        data = {
            referType: requestReferTypeGlobalLatest,
            Id: idrejection,
            reasonForRejection: reasonForRejection,
            queueId: queueId,
            logId: logId,
            referTo: referTo,
            patientId: rulePatientId,
        };
        ruleEventSource = "RRUMACTIVITYREJECT";
    }
    else if (requestReferTypeGlobalLatest == "AG Complaint") {
        var refid = $('#hdnRequestReceivedComplaintReferenceIds').val();
        var tmpComplaintRedirect = $.fn.replaceAndEscapeHtmlExt($('#hdnSendRequestRejectCommentsRejectionComplaintRedirect').val());
        // url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + refid + "&reasonForRejection=" + encodeURIComponent(reasonForRejection) + '&ComplaintRedirect=' + ComplaintRedirect + "&referTo=" + referTo;
        data = {
            referType: requestReferTypeGlobalLatest,
            Id: refid,
            reasonForRejection: reasonForRejection,
            ComplaintRedirect: tmpComplaintRedirect,
            referTo: referTo,
            patientId: rulePatientId,
        };
    }
    else if (requestReferTypeGlobalLatest == "AG Activity") {
        var refid = $('#hdnRequestReceivedComplaintReferenceIds').val();
        var tmpComplaintId = $('#hdnRequestReceivedComplaintRecordIds').val();
        // url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + refid + "&reasonForRejection=" + encodeURIComponent(reasonForRejection) + '&ComplaintId=' + $('#hdnRequestReceivedComplaintRecordIds').val() + "&referTo=" + referTo;
        data = {
            referType: requestReferTypeGlobalLatest,
            Id: refid,
            reasonForRejection: reasonForRejection,
            ComplaintId: tmpComplaintId,
            referTo: referTo,
            patientId: rulePatientId,
        };
    }
    else if (requestReferTypeGlobalLatest == "MS Activity") {
        //url = baseURL + "/Home/RequestReject?referType=" + requestReferTypeGlobalLatest + "&Id=" + idrejection + "&reasonForRejection=" + encodeURIComponent(reasonForRejection);
        data = {
            referType: requestReferTypeGlobalLatest,
            Id: idrejection,
            reasonForRejection: reasonForRejection,
            patientId: rulePatientId,
        };
    }

    if ($.fn.setValueOnUndefinedOrNull(referTo, "-1") !== "-1") {
        url = baseURL + "/Home/RequestRejectWhenCareStaffInActivated";
    }

    $.ajax({
        type: "POST",
        url: url,
        data: data,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                if (ruleEventSource !== "") {
                    var ficoObject = { eventSource: ruleEventSource, parentConrolId: "", moduleName: "CM", eventType: "POST", patientId: rulePatientId, isAsync: true };
                    var response = ficoRealTimeValidation(ficoObject);
                    CheckValidationMessages(response);
                }
                // $('#btnRequestReceivedSearch').trigger('click');
                $('#closePopUp').trigger('click');
                if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))
                    CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Success');
                else
                    CustomAlert(data.msg);
                if ($("#id1frame").contents().find('[id*=btnImgRRec]').length > 0) {
                    $("#id1frame").contents().find('[id*=btnImgRRec]').trigger('click');
                }
                if ($('#ReceivedAppoinmentCount').attr('id'))
                    FillRequestCountFreek();
                if ($("#btnRequestReceivedSearch" + (isMAL ? 'MAL' : '')).length > 0)
                    $('#btnRequestReceivedSearch' + (isMAL ? 'MAL' : '')).trigger('click');
                if (isMAL) { $('#btnRequestRejectedSearchMAL').trigger('click'); }
                $('#btnCloseRequestRejectComments').trigger('click');
            }
            else {
                if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))
                    CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Error');
                else
                    $('#divRequestRejectCommentsPopupMsg').AhsSetHtml(data.msg).css('color', 'red');
            }
            if ($('#ddlPActReferTypeCM').val() == 'Activity' && $('#ddlPActModule').val() == "1") {
                $("#CMPendingActivitiesGrid").data("kendoGrid").dataSource.page(1);
            }
            else if ($('#ddlPActReferTypeCM').val() == 'Member' && $('#ddlPActModule').val() == "1") {
                $("#CMMyMembersGrid").data("kendoGrid").dataSource.page(1);
            }
            loader(0);
        }
    });
});
$(document).off('click', '.divClsMemberMenuReject').on('click', '.divClsMemberMenuReject', function () {
    // requestReferTypeGlobal = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();//Converting Kendo DropDown   
    var statusId = 0;
    var refModule = 'CM';
    $('span.validationMessage').remove();
    $("#rejectRequestFrom").show();
    $("#rejectCareMember").show();
    var referenceId = getReferreceId('requestReceived') || $('#divMemberMenuRefral_').attr('data-Id');
    $('#hdnRequestReceivedRulePatientId').val($('#chkMember_' + referenceId).data('patientid'));
    $('#hdnSendRequestRejectCommentsRejectionId').val(referenceId);
    $('#hdnSendRequestRejectCommentsRejectionAuthRedirect').val($('#chkMember_' + referenceId).data('authredirect') || $('#divMemberMenuRefral_').attr('data-authredirect'));
    $('#divRequestRejectCommentsPopup').CMNPopup({
        popUpHeader: "Reason for Rejection",
        closeButton: '#btnCloseRequestRejectComments',
        onClose: function () {
            $("#hdnRequestFrom").val('');
            $("#hdnIsExternalActivity").val('');
            $("#hdnRequestReceivedRulePatientId").val('');
            $("#hdnIsExternalActivityPatientID").val('');
            $('.clsRefralChkMember').prop('checked', false);
            if (ToValue(PHNavID, '') !== '') {
                $('#btnRequestReceivedAccept').hide();
            }
            $('.GearIconCls').removeAttr("disabled");
            $('.GearIconClshover').removeClass('GearIconClshover');
            let requestFromAutoComplete = $("#rejectRequestFrom #txtRequestFrom").data("kendoAutoComplete");
            if (requestFromAutoComplete !== undefined && requestFromAutoComplete !== null) {
                requestFromAutoComplete.destroy();
                requestFromAutoComplete.wrapper.remove();
            }
        }
    });
    $('#divRequestRejectCommentsPopup textarea').val('');
    if (!isProvider && !($("#hdnIsExternalActivity").val())) {
        $('#divRequestRejectCommentsPopup #divReqRjctIsConfidential').show();
        $('#RequestRejectIsConfidential').html('');
        bindConfidentialTypeRadioButton('RequestRejectIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
    }
    else {
        $('#divRequestRejectCommentsPopup #divReqRjctIsConfidential').hide();
    }
    if (!isProvider && $('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() == 'Activity')
        $('#divRequestRejectCommentsPopup #divReqRjctIsConfidential').show();
    else
        $('#divRequestRejectCommentsPopup #divReqRjctIsConfidential').hide();
    if (requestReferTypeGlobal == "UM Auth") {
        refModule = 'UM';
        $('#spnRequestRejectCommentsRequestFrom').text($('#chkMember_' + referenceId).data('referredbyname'));
        $('#spnRequestRejectCommentsCareMember').text($('#chkMember_' + referenceId).data('patientname'));
        statusId = $('#chkMember_' + referenceId).data('statusid');
    }
    //To Implement UM Activity Reject Functionality
    else if (requestReferTypeGlobal == "UM Activity") {
        refModule = 'UM';
        $('#spnRequestRejectCommentsRequestFrom').text($('#chkUMActivity_' + referenceId).data('referredbyname'));
        $('#spnRequestRejectCommentsCareMember').text($('#chkUMActivity_' + referenceId).data('patientname'));
        statusId = $('#chkUMActivity_' + referenceId).data('statusid');
        $('#hdnRequestReceivedRulePatientId').val($('#chkUMActivity_' + referenceId).data('patientid'));
    }
    else if (requestReferTypeGlobal == "AG Complaint") {
        refModule = 'AG';
        $('#hdnSendRequestRejectCommentsRejectionComplaintRedirect').val($('#referralCompChkId_' + referenceId).data('complaintredirect'));
        $('#hdnRequestReceivedComplaintReferenceIds').val($('#referralCompChkId_' + referenceId).data('referraldetailsid'));
        $('#spnRequestRejectCommentsRequestFrom').text(GetHtmlDecode($.fn.replaceAndEscapeHtmlExt(($('#referralCompChkId_' + referenceId).data('referredbyname')).replace(/&#39;/g, "'").replace(/&amp;/g, "&"))));
        $('#spnRequestRejectCommentsCareMember').text($('#referralCompChkId_' + referenceId).data('patientname'));
        complaintType = $('#referralCompChkId_' + referenceId).data('complainttype');
        statusId = $('#referralCompChkId_' + referenceId).data('statusid');
        $('#trIsConfidential').hide();
        $('#hdnRequestReceivedRulePatientId').val($('#referralCompChkId_' + referenceId).data('patientid'));
    }
    else if (requestReferTypeGlobal == "AG Activity") {
        refModule = 'AG';
        $('#hdnRequestReceivedComplaintRecordIds').val($('#chkAgActivity_' + referenceId).data('complaintid'));
        $('#hdnRequestReceivedComplaintReferenceIds').val($('#chkAgActivity_' + referenceId).data('referraldetailsid'));
        $('#spnRequestRejectCommentsRequestFrom').text($('#chkAgActivity_' + referenceId).data('referredbyname'));
        $('#spnRequestRejectCommentsCareMember').text($('#chkAgActivity_' + referenceId).data('patientname'));
        complaintType = $('#chkAgActivity_' + referenceId).data('complainttype');
        $('#trIsConfidential').hide();
        statusId = $('#chkAgActivity_' + referenceId).data('statusid');
        $('#hdnRequestReceivedRulePatientId').val($('#chkAgActivity_' + referenceId).data('patientid'));
    }
    else if (requestReferTypeGlobal == "MS Activity") {
        refModule = 'MS';
        $('#trIsConfidential').hide();
        $('#spnRequestRejectCommentsRequestFrom').text($('#chkMember_' + referenceId).data('referredbyname') || $('#divMemberMenuRefral_').attr('data-ReferredByName'));
        $('#spnRequestRejectCommentsCareMember').text($('#chkMember_' + referenceId).data('patientname') || $('#divMemberMenuRefral_').attr('data-PatientName'));
    }
    else {
        $('#spnRequestRejectCommentsRequestFrom').text(GetHtmlDecode($.fn.replaceAndEscapeHtmlExt(($('#chkMember_' + referenceId).data('referredbyname') || $('#divMemberMenuRefral_').attr('data-ReferredByName')).replace(/&apos;/g, "'").replace(/&amp;/g, "&"))));
        $('#spnRequestRejectCommentsCareMember').text($('#chkMember_' + referenceId).data('patientname') || $('#divMemberMenuRefral_').attr('data-PatientName'));
        statusId = $('#chkMember_' + referenceId).data('statusid');
        $("#hdnIsExternalActivity").val($('#divMemberMenuRefral_').attr('data-isexternalactivity'));
        $("#hdnIsExternalActivityPatientID").val($('#divMemberMenuRefral_').attr('data-PatientId'));
    }
    $('#divRequestRejectCommentsPopupMsg').html('');
    $('#txtareaRequestRejectComments').val('');
    $('.ContextChkMenu').hide();
    if (statusId == 2) {
        $("#ddlRequestFrom").show();
        $("#spnRequestRejectCommentsRequestFrom").hide();
        if (refModule == 'CM') {
            loadDropDownSync(baseURL + '/Home/LoadCareStaffDdl?userFlag=true', 'ddlRequestFrom');
        }
        else if (refModule == 'UM') {
            BindRequestFromAutoCompleteForReqRec();
            $('#ddlRequestFrom').hide();
        }
        else if (refModule == 'AG') {
            loadDropDownSync(baseURL + '/Complaint/BindComplaintAssignedTo?complaintType=' + complaintType + '&userFlag=true', 'ddlRequestFrom', null, null, null, null, 'CareStaffId', 'CareStaffName');
        }
    }
    else {
        $("#ddlRequestFrom").hide();
        $("#spnRequestRejectCommentsRequestFrom").show();
    }
    addCharacterCountRejectComments();
});
$(document).off('click', '.divClsMemberMenuView').on('click', '.divClsMemberMenuView', function () {
    //requestReferTypeGlobal = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();//Converting Kendo DropDown
    var isPH = ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) ? true : false;
    var referenceId = isPH ? $('#divMemberMenuRefral_').attr('data-Id') : getReferreceId('requestReceived');
    var patientFollowupId = $('#chkMember_' + referenceId).data('patientfollowupid') || $('#divMemberMenuRefral_').attr('data-patientFollowUpId');
    var patientId = $('#chkMember_' + referenceId).data('patientid') || $('#divMemberMenuRefral_').attr('data-patientid');
    var isexternalactivity = $('#divMemberMenuRefral_').attr('data-isexternalactivity') == '1' ? 'External' : '';
    var authId;
    var patId;
    requestModuleNameGlobal = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
    if (requestReferTypeGlobal == "Activity" || requestReferTypeGlobal == "Member") {
        requestModuleNameGlobal = moduleTypeCm;
    }
    if (requestReferTypeGlobal == "Activity") {
        $.ajax({
            type: "GET",
            url: baseURL + "/RequestReceivedDashboard/RequestReceviedShowActivityDetails",
            data: {
                'patientFollowupId': patientFollowupId,
                'module': requestModuleNameGlobal,
                'type': isexternalactivity,
                'isProvider': isProvider,
                'timeDictionaryObj': timeZone,
                'patientid': patientId
            },
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $('#divRequestReceivedViewPopup').CMNPopup({
                        popUpHeader: "Activity Details",
                        onClose: function () {
                            $('#divRequestReceivedViewPopup .lightGrey').removeClass('lightGrey');
                            isPH ? $("#btnRequestReceivedAccept").hide() : $("#btnRequestReceivedAccept").show();
                            $('.GearIconCls').removeAttr("disabled");
                            $('.clsRefralChkMember').prop('checked', false);
                            $('.GearIconClshover').removeClass('GearIconClshover');
                        }
                    });
                    $('#divRequestReceivedViewPopup textarea').val('');
                    $('#lblRRRQM,#lblRRRQMStatus,#lblRRRQMIdentifiedDate').text('');
                    $('#trQM,#trQMStatus,#trQMIdentifiedDate').hide();
                    $('#tblRRActivityDetails', '#divRequestReceivedViewPopup').show();
                    $('#tblRRUMAuthdetails').hide();
                    $('#tblRRMemberDetails').hide();
                    $('#tblRRAGComplaintdetails').hide();
                    $('#tblRRAGActivitydetails').hide();
                    $('#lblRRRActivityType').text(data.activityDtls.CareActivityTypeName == null || data.activityDtls.CareActivityTypeName == '' || data.activityDtls.CareActivityTypeName == 'null' ? 'N/A' : data.activityDtls.CareActivityTypeName);
                    if (data.activityDtls.IsLockNote)
                        $('#lblRRRActivityNotes').html(' Confidential notes').addClass('fa fa-lock lightGrey');
                    else {
                        $('#lblRRRActivityNotes').AhsSetHtml(data.activityDtls.Comments === null || data.activityDtls.Comments === '' || data.activityDtls.Comments === 'null' ? 'N/A' : $.fn.replaceAndEscapeHtmlExt(data.activityDtls.Comments)).removeClass('fa fa-lock lightGrey');
                    }
                    $('#lblRRRScheduledDateTime').text(data.activityDtls.FollowupDateString === null || data.activityDtls.FollowupDateString === '' || data.activityDtls.FollowupDateString === 'null' ? 'N/A' : $.fn.apply12To24hrFormat(data.activityDtls.FollowupDateString));
                    $('#lblRRRMemberName').text(data.activityDtls.PatientFullName == null || data.activityDtls.PatientFullName == '' || data.activityDtls.PatientFullName == 'null' ? 'N/A' : data.activityDtls.PatientFullName);
                    $('#lblRRRHealthCoach').text(data.activityDtls.AssignedTo == null || data.activityDtls.AssignedTo == '' || data.activityDtls.AssignedTo == 'null' ? 'N/A' : data.activityDtls.AssignedTo);
                    $('#lblRRRPriority').text(data.activityDtls.Priority == null || data.activityDtls.Priority == '' || data.activityDtls.Priority == 'null' || data.activityDtls.Priority == '-1' ? 'N/A' : data.activityDtls.Priority);
                    $('#lblRRRScriptName').text(data.activityDtls.ScriptName == null || data.activityDtls.ScriptName == '' || data.activityDtls.ScriptName == 'null' ? 'N/A' : data.activityDtls.ScriptName);
                    $('#lblRRRReferBy').text(data.activityDtls.AssignedBy == null || data.activityDtls.AssignedBy == '' || data.activityDtls.AssignedBy == 'null' ? 'N/A' : data.activityDtls.AssignedBy);
                    $('#lblRRRReassignedBy').text(data.activityDtls.ReassignedBy == null || data.activityDtls.ReassignedBy == '' || data.activityDtls.ReassignedBy == 'null' ? 'N/A' : data.activityDtls.ReassignedBy);
                    $('#lblRRRStatus').text(data.activityDtls.Venue == null || data.activityDtls.Venue == '' || data.activityDtls.Venue == 'null' ? 'N/A' : data.activityDtls.Venue);
                    if (data.activityDtls.IsQmActivity) {
                        $('#trQM,#trQMStatus').show();
                        $('#lblRRRQM').text(data.activityDtls.QualityMeasureName == null || data.activityDtls.QualityMeasureName == '' || data.activityDtls.QualityMeasureName == 'null' ? 'N/A' : data.activityDtls.QualityMeasureName);
                        $('#lblRRRQMStatus').text(data.activityDtls.QualityMeasureStatus == null || data.activityDtls.QualityMeasureStatus == '' || data.activityDtls.QualityMeasureStatus == 'null' ? 'N/A' : data.activityDtls.QualityMeasureStatus);
                        if (data.activityDtls.IdentifiedDateString !== null && data.activityDtls.IdentifiedDateString !== '' && data.activityDtls.IdentifiedDateString !== 'null') {
                            $('#trQMIdentifiedDate').show();
                            $('#lblRRRQMIdentifiedDate').text(data.activityDtls.IdentifiedDateString);
                        }
                    }

                    gridNotAvailableCustomColor('divRequestReceivedViewPopup', null, null, true);
                }
                else
                    CustomAlert(data.msg);
                isPH ? $("#btnRequestReceivedAccept").hide() : $("#btnRequestReceivedAccept").show();
                $('.GearIconCls').removeAttr("disabled");
                $('.clsRefralChkMember').prop('checked', false);
            }
        });
    }
    else if (requestReferTypeGlobal == "Member") {
        $.ajax({
            type: "GET",
            url: baseURL + "/RequestReceivedDashboard/RequestReceviedShowMemberDetails",
            dataType: "json",
            data: {
                'referenceId': referenceId,
                'module': requestModuleNameGlobal,
                'timeDictionaryObj': timeZone,
                'patientid': patientId
            },
            success: function (data) {
                if (data) {
                    $('#divRequestReceivedViewPopup').CMNPopup({
                        popUpHeader: "Member Details",
                        onClose: function () {
                            $('#divRequestReceivedViewPopup .lightGrey').removeClass('lightGrey');
                        }
                    });
                    $('#divRequestReceivedViewPopup textarea').val('');
                    $('#tblRRActivityDetails', '#divRequestReceivedViewPopup').hide();
                    $('#tblRRUMAuthdetails').hide();
                    $('#tblRRAGComplaintdetails').hide();
                    $('#tblRRAGActivitydetails').hide();
                    $('#tblRRMemberDetails').show();
                    $('#lblRRRMemberName1').text(data.memberDtls.PatientFullName == '' || data.memberDtls.PatientFullName == 'null' ? 'N/A' : data.memberDtls.PatientFullName);
                    $('#lblRRRReferredDateTime1').text(data.memberDtls.FollowupDateString === '' || data.memberDtls.FollowupDateString === 'null' ? 'N/A' : $.fn.apply12To24hrFormat(data.memberDtls.FollowupDateString));
                    $('#lblRRRHealthCoach1').text(unescapeHtml(data.memberDtls.AssignedTo == '' || data.memberDtls.AssignedTo == 'null' || data.memberDtls.AssignedTo == null ? 'N/A' : data.memberDtls.AssignedTo));
                    $('#lblRRRReferBy1').text(unescapeHtml(data.memberDtls.AssignedBy == '' || data.memberDtls.AssignedBy == 'null' ? 'N/A' : data.memberDtls.AssignedBy));
                    $('#lblRRRNotes1').text(data.memberDtls.Comments === '' || data.memberDtls.Comments === 'null' || data.memberDtls.Comments === null ? 'N/A' : data.memberDtls.Comments);
                    $('#lblRRRNotes1').css("white-space", "pre-line");
                    $('#lblRRRStatus1').text(data.memberDtls.MemberFlag == '' || data.memberDtls.MemberFlag == 'null' ? 'N/A' : data.memberDtls.MemberFlag);

                    gridNotAvailableCustomColor('divRequestReceivedViewPopup', null, null, true);
                }
            }
        });
    }
    else if (requestReferTypeGlobal == "UM Auth") {
        $('.clsRefralChkMembercol').prop('checked', false);
        authId = $('#chkMember_' + referenceId).data('authredirect').split('|')[3];
        patId = $('#chkMember_' + referenceId).data('authredirect').split('|')[0];
        ViewAuth(authId, 1, false, patId);
    }
    else if (requestReferTypeGlobal == "UM Activity") {
        $('.clsRefralChkMembercol').prop('checked', false);
        var listCheckBox = $('.clsRefralChkMember:checked');
        $(listCheckBox).is(':checked')
        {
            authId = $('#chkUMActivity_' + referenceId).data('authredirect').split('|')[3];
            patId = $('#chkUMActivity_' + referenceId).data('authredirect').split('|')[0];
            ViewAuth(authId, 1, false, patId);
        }
    }

    else if (requestReferTypeGlobal == "AG Complaint") {
        $('#divRequestReceivedViewPopup').CMNPopup({ popUpHeader: "AG Complaint Details" });
        $('#divRequestReceivedViewPopup textarea').val('');
        $('#tblRRActivityDetails', '#divRequestReceivedViewPopup').hide();
        $('#tblRRMemberDetails').hide();
        $('#tblRRUMAuthdetails').hide();
        $('#tblRRAGComplaintdetails').show();
        $('#tblRRAGActivitydetails').hide();


        $('#lblRRAGComplaintComplaintId').text($('#referralCompChkId_' + referenceId).data('complaintrecordno'));
        $('#lblRRAGComplaintComplaintType').text($('#referralCompChkId_' + referenceId).data('complainttype'));
        $('#lblRRAGComplaintPatientName').text($('#referralCompChkId_' + referenceId).data('patientname'));
        $('#lblRRAGComplaintRefReqDate').text($('#referralCompChkId_' + referenceId).data('referreddate'));
        $('#lblRRAGComplaintReferedBy').text(GetHtmlDecode($.fn.replaceAndEscapeHtmlExt(($('#referralCompChkId_' + referenceId).data('referredbyname')).replace(/&#39;/g, "'").replace(/&amp;/g, "&"))));
        $('#lblRRAGComplaintReferedTo').text($('#referralCompChkId_' + referenceId).data('referredtoname').replace(/&#39;/g, "'"));
        $('#lblRRAGComplaintStatus').text($('#referralCompChkId_' + referenceId).data('status'));
        var obj = $('#referralCompChkId_' + referenceId).data('reasonforreference');


        $('#lblRRAGComplaintNotes').html((obj == "null" || obj == "" || obj == null || obj == "undefined") ? "N/A" : $.fn.replaceAndEscapeHtmlExt(obj));
        var Episode = $('#referralCompChkId_' + referenceId).data('episodename');
        $('#lblRRAGEpisodeName').html(Episode);
        $('#lblRRAGComplaintLevel').text($('#referralCompChkId_' + referenceId).data('levelid'));

    }

    else if (requestReferTypeGlobal == "AG Activity") {


        $('#divRequestReceivedViewPopup').CMNPopup({ popUpHeader: "AG Activity Details" });
        $('#divRequestReceivedViewPopup textarea').val('');
        $('#tblRRActivityDetails', '#divRequestReceivedViewPopup').hide();
        $('#tblRRMemberDetails').hide();
        $('#tblRRUMAuthdetails').hide();
        $('#tblRRAGComplaintdetails').hide();
        $('#tblRRAGActivitydetails').show();

        // $('#divRequestReceivedViewPopupHeader').html('UM Auth Details  <a style="float:right;" class="Close" id="closeBtndivRequestReceivedViewPopup"></a>').css("width", "98.3%");
        $('#lblRRAGActivityComplaintId').text($('#chkAgActivity_' + referenceId).data('complaintrecordno'));
        $('#lblRRAGActivityComplaintType').text($('#chkAgActivity_' + referenceId).data('complainttype'));
        $('#lblRRAGActivityType').text($('#chkAgActivity_' + referenceId).data('actiontype'));
        $('#lblRRAGActivityPatientName').text($('#chkAgActivity_' + referenceId).data('patientname'));
        $('#lblRRAGActivityRefReqDate').text($('#chkAgActivity_' + referenceId).data('referreddate'));
        $('#lblRRAGActivityReferedBy').text($('#chkAgActivity_' + referenceId).data('referredbyname'));
        $('#lblRRAGActivityReferedTo').text($('#chkAgActivity_' + referenceId).data('referredtoname'));
        $('#lblRRAGActivityStatus').text($('#chkAgActivity_' + referenceId).data('status'));
        var Notes = $('#chkAgActivity_' + referenceId).data('reasonforrequest');
        $('#lblRRAGActivityNotes').html((Notes == null || Notes === '' || Notes === 'null') ? 'N/A' : $.fn.replaceAndEscapeHtmlExt(Notes));
        var mandatory = $('#chkAgActivity_' + referenceId).data('mandatory')
        $('#lblRRAGActivityMandatory').text((mandatory == null || mandatory == '' || mandatory == 'null') ? 'N/A' : mandatory);
        $('#lblRRAGActivityLevel').text($('#chkAgActivity_' + referenceId).data('levelid'));

    }
    else if (requestReferTypeGlobal == "MS Activity") {
        ViewMSActivityFrmActivityLog(referenceId);
    }
    $('.ContextChkMenu').hide();
});
var html = "";
$(document).off('click', '#btnRequestReceivedAccept,.divClsMemberMenuAccept').on('click', '#btnRequestReceivedAccept,.divClsMemberMenuAccept', function () {
    if (!((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
        if ($(this).attr("id") == 'btnRequestReceivedAccept') { if (!$(this).hasClass("ReqRecAccept")) { return false; } }
    }
    $('#tdTableForBulkActivities').empty();
    var listCheckBox = $('.clsRefralChkMember:checked');
    var listReferenceId = "";
    var listPatientFollowupId = "";
    var listPatientId = "";
    var listIsActTransfer = "";
    var listInternalActivityId = "";
    var listExternalActivityId = "";
    var listExternalPatientId = "";
    var listAllActivityId = "";
    var listReferralId = "";
    if (listCheckBox.length <= 0) {
        if ($('#divMemberMenuRefral_').is(':visible') === true) {
            //--
        }
        else {
            CustomAlert('Please select at least one record');
            $('.clsRefralChkMembercol').prop('checked', false);
            return false;
        }
    }
    html = "";
    if (requestReferTypeGlobal == "Member") {
        loader(1);
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
                listIsActTransfer += $(item).data('isacttransfer') + ",";
            }
        });
        if (listCheckBox.length <= 0 && $('#divMemberMenuRefral_').is(':visible') === true) {
            listReferenceId += $('#divMemberMenuRefral_').attr('data-id') + ",";
            listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
            listIsActTransfer += $('#divMemberMenuRefral_').attr('data-IsActTransfer') + ",";
        }
        if (listIsActTransfer != "")
            listIsActTransfer = listIsActTransfer.substr(0, listIsActTransfer.length - 1);
        $("#hdnReferenceIds").val(listReferenceId);
        $("#hdnPatientIdRR").val(listPatientId);
        $("#hdnIsActTransferValues").val(listIsActTransfer);
        if (isMTMval === true || isMTMval.toLowerCase() === 'true') {
            AcceptMember(true);
        }
        else {
            CheckPrimaryCMExists(listPatientId, "RR");
        }
    }
    else if (requestReferTypeGlobal == "UM Auth") {
        //var listAuthId = "";
        //var lstAuthRedirect = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferralId += $(item).attr('Id').split('_')[1] + ",";
                //listAuthId += $(item).data('authid') + ",";
                //lstAuthRedirect += $(item).data('authredirect') + ",";
            }
        });
        //+ "&listAuthId=" + listAuthId + '&authRedId=' + lstAuthRedirect

        //PROD-19169 // KP
        var AuthRedVals = $(listCheckBox[0]).data('authredirect').split('|');
        if (listCheckBox.length == 1 && IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != AuthRedVals[0]) {
            GetPatientAlertsAndAcknowledge(AuthRedVals[0], 0, listReferralId, 'umauthaccept', listCheckBox);
        }
        else {
            UMAuthAccept(listCheckBox, listReferralId, '');
        }

    }
    //To Implement UM Activity Accept Functionality
    else if (requestReferTypeGlobal == "UM Activity") {
        $('#divUMRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseUMRequestReceivedAcceptComments' });
        $('#divUMRequestAcceptCommentsPopup textarea').val('');
        if (isNewMdrReview) {
            if ($(this).context.id === 'divMemberMenuAcceptandPerform_') {
                $('#btnAcceptUMRequestReceivedAcceptComments').val('Accept and Perform');
            } 
            if ($(this).context.id === 'divMemberMenuAccept_') {
                $('#btnAcceptUMRequestReceivedAcceptComments').val('Accept');
            }
        }
        $('#btnAcceptUMRequestReceivedAcceptComments').prop('disabled', '');
        var listActivityId = "", lstQueueId = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listActivityId += $(item).data('logid') + ",";
                lstQueueId += $(item).data('queueid') + ",";
            }
        });
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listActivityId);
        $('#hdnUMRequestReceivedAcceptQueueIds').val(lstQueueId);
        loadLettersDropDown(baseURL + '/Master/BindConfidentialType', 'selectUMAHNIsConfidential', 2, false, null, null, null, 'ConfidentialTypeId', 'ConfidentialTypeName');
        PrepareAcceptUMActivityGrid(listActivityId);
    }
    else if (requestReferTypeGlobal == "AG Complaint") {
        var patientId = '', complaintTypeId = '';
        var listComplaintId = '';
        var listComplaintRedirect = '';
        var listPatientId='';
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferralId += $(item).attr('Id').split('_')[1] + ",";
                listComplaintId += $(item).data('complaintrecordid') + ",";
                listPatientId += $(item).data('patientid') + ",";
                if (listCheckBox.length == 1) {
                    listComplaintRedirect = $(listCheckBox[0]).data('complaintredirect').split('|');
                    patientId = listComplaintRedirect[0];
                    complaintTypeId = listComplaintRedirect[2];
                }
            }
        });

        if (listCheckBox.length == 1 && IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != patientId) {
            GetAGPatientAlertsAndAcknowledge(patientId, listComplaintId, complaintTypeId, 'complaint_accept', listReferralId);
        }
        else {
            AcceptReqReceivedAGComplaint(listReferralId, listComplaintId, '', listPatientId);
        }
    }

    else if (requestReferTypeGlobal == "AG Activity") {
        $('#divRequestAGAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseRequestReceivedAGAcceptComments' });
        $('#tdTableForAGBulkActivities').html('');
        var listReferenceId = "";
        var listPatientId = "";
        var listComplaintId = "";
        $('#divRequestAGAcceptCommentsPopup textarea').val('');
        $('#selectRequestReceivedAGAcceptConfidential').val('Yes');
        if (isNewAgMdrReview) {        
            if ($(this).context.id === 'divMemberMenuAcceptandPerform_') {
                $('#btnAcceptRequestReceivedAGAcceptComments').val('Accept and Perform');
            }
            if ($(this).context.id === 'divMemberMenuAccept_') {
                $('#btnAcceptRequestReceivedAGAcceptComments').val('Accept');
            }
            if (listCheckBox.length === 1) {
                $('#hdnMdrActivityLevelId').val($(listCheckBox[0]).data('levelid'));
            }
        }
        html = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
                listComplaintId += $(item).data('complaintid') + ",";
                //listReferenceId += $(item).data('refernceid') + ",";
            }
        });
        listReferenceId = listReferenceId.substring(0, listReferenceId.length - 1);
        listPatientId = listPatientId.substring(0, listPatientId.length - 1);
        listComplaintId = listComplaintId.substring(0, listComplaintId.length - 1);
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
        $('#hdnRequestReceivedComplaintRecordIds').val(listComplaintId);
        var dataParams = { "listReferenceId": listReferenceId, "timeDictionaryobj": timeZone };
        $.ajax({
            type: "GET",
            url: baseURL + "/Dashboard/GetBulkAGActivity",
            data: dataParams,
            dataType: "json",
            async: false,
            success: function (data) {
                if (data.success) {
                    if (data.activityList != undefined && data.activityList != null && data.activityList.length > 0) {
                        var Notes = '';
                        $("#hdnTodayDate").val(data.TodayDate);
                        html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">Complaint ID</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Complaint Received Date</th><th scope="col" style="width:190px;">Scheduled Date</th><th align="left" scope="col">Activity Due Date</th><th align="left" scope="col">Notes</th><th align="left" scope="col">Is Mandatory</th></tr>';
                        $.each(data.activityList, function (key, item) {
                            item.ScheduledDateString = changeTimeZone(item.ScheduledDateString, "1", 'h12');
                            item.DueDateString = changeTimeZone(item.DueDateString, "1", 'h12');
                            item.ReceivedDateString = changeTimeZone(item.ReceivedDateString, "1", 'h12');
                            item.ReceivedDateString = (item.ReceivedDateString === null) ? "" : item.ReceivedDateString;
                            if (item.RequestNotes === '' || item.RequestNotes === null || item.RequestNotes === 'null')
                            {
                                Notes = 'N/A';
                            }
                            else {
                                Notes = $.fn.replaceAndEscapeHtmlExt(item.RequestNotes);
                            }
                            html += '<tr><td class="alignVMiddle">' + $.fn.replaceAndEscapeHtmlExt(item.PatientName) + '</td><td class="alignVMiddle">' + item.ComplaintRecordNo + '</td><td class="alignVMiddle">' + $.fn.replaceAndEscapeHtmlExt(item.ActionType) + '</td><td class="alignVMiddle"><input type="text"  class="Acceptdate" disabled="disabled" id="txtAcceptCommentsReceivedDate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.ReceivedDateString) + '"/></td><td class="alignVMiddle">';
                            html += '<input type="text" data-PatientId="' + item.PatientId + '"  class="AcceptCommentsScheduleddate" id="txtAcceptCommentsScheduleddate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.ScheduledDateString) + '"/><span id="ScheduledDate_Valid" class="AgValid_Error" style="display: none;">*</span></td><td class="alignVMiddle"><input type="text"  class="Acceptdate" disabled="disabled" id="txtAcceptCommentsDueDate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.DueDateString) + '"/></td><td class="alignVMiddle" style = "word-break:break-word;">' + Notes + '</td><td class="alignVMiddle">' + item.Mandatory + '</td></tr>';
                            Notes = '';
                        });
                        html += '</table>';
                        $('#tdTableForAGBulkActivities').append(html);
                        $('.AcceptCommentsScheduleddate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 10 });
                        $('.Acceptdate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 10 });
                        $(".Acceptdate").find('span').find('.k-select').remove();
                    }
                    else {
                        $('#closePopUp', '#divRequestAGAcceptCommentsPopup').trigger('click');
                        CustomAlert('Selected activity(s) has been re-referred/deleted.');
                    }
                    readDatasourcefromGrid("ReqRecGrid", false);
                }
            }
        });

    }
    else if (requestReferTypeGlobal == "MS Activity") {

        $('#divMSRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseMSRequestReceivedAcceptComments' });
        $('#divMSRequestAcceptCommentsPopup textarea').val('');
        $('#btnAcceptMSRequestReceivedAcceptComments').prop('disabled', '');
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
            }
        });
        if (listCheckBox.length <= 0 && $('#divMemberMenuRefral_').is(':visible') === true) {
            listReferenceId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
            listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
        }
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
        $('#hdnMSRequestReceivedAcceptCrmQueueIds').val('');
        PrepareAcceptMSActivityGrid(listReferenceId);
    }
    else {
        if (($(this).attr("id") == 'btnRequestReceivedAccept' || $(this).attr("id") == 'divMemberMenuAccept_') && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
            isPHBulkActivity = true;
            $('#divRequestAcceptCommentsPopup').CMNPopup({
                popUpHeader: "Accept Comments",
                closeButton: '#btnCloseRequestReceivedAcceptComments',
                onClose: function () {
                    $("#hdnIsExternalActivity").val('');
                    $("#hdnIsExternalActivityPatientID").val('');
                    $("#hdnRequestReceivedPHBulkAcptCmntExternalIds").val('');
                    $("#hdnRequestReceivedPHBulkAcptCmntInternalIds").val('');
                    $("#hdnRequestReceivedPHBulkAcptExtPatientIds").val('');
                    $("#btnRequestReceivedAccept").css("display", "none");
                    $('.GearIconCls').removeAttr("disabled");
                }
            });
            $('#divRequestAcceptCommentsPopup textarea').val('');
            if (!isProvider && !($("#hdnIsExternalActivity").val())) {
                $('#divRequestAcceptCommentsPopup #divReqAcptIsConfidential').show();
                $('#ReqAcptIsConfidential').html('');
                bindConfidentialTypeRadioButton('ReqAcptIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
            }
            else {
                $('#divReqAcptIsConfidential').hide();
            }
            html = "";
            var isexternalactivity = "";
            if ($(this).hasClass("divClsMemberMenuAccept") && $(this).hasClass("divClsMemberMenuSib") && $('#divMemberMenuRefral_').is(':visible') === true && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
                listAllActivityId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
                isexternalactivity = $('#divMemberMenuRefral_').attr('data-isexternalactivity');
                if (isexternalactivity == 1) {
                    listExternalActivityId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
                    listExternalPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
                }
                else {
                    listInternalActivityId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
                }
            }
            else {
                $.each(listCheckBox, function (key, item) {
                    if ($(item).is(':checked')) {
                        listAllActivityId += $(item).attr('Id').split('_')[1] + ",";
                        if ($(item).data('isexternalactivity')) {
                            listExternalActivityId += $(item).attr('Id').split('_')[1] + ",";
                            listExternalPatientId += $(item).data('patientid') + ",";
                        }
                        else {
                            listInternalActivityId += $(item).attr('Id').split('_')[1] + ",";
                        }
                    }
                });
            }
            $('#hdnRequestReceivedPHBulkAcptCmntExternalIds').val(listExternalActivityId);
            $('#hdnRequestReceivedPHBulkAcptCmntInternalIds').val(listInternalActivityId);
            $('#hdnRequestReceivedPHBulkAcptExtPatientIds').val(listExternalPatientId);
            $('#hdnRequestReceivedPHBulklistAllActivityId').val(listAllActivityId);

            $.ajax({
                type: "GET",
                url: baseURL + "/PopulationHealth/GetPHBulkActivity?listExternalActivityId=" + listExternalActivityId + "&listInternalActivityId=" + listInternalActivityId + "&isProvider=" + isProvider,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">' + GetHtmlDecode(GetHtmlDecode(altruistaIDLabelValue)) + '</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Priority</th><th scope="col" style="width:215px">Follow up Date</th><th align="left" scope="col">Script Name</th><th align="left" scope="col">Referral Notes</th><th align="left" scope="col">Contact Type</th><th align="left" scope="col" style="display: none;">Activity Type</th></tr>';
                        $.each(data.activityList, function (key, item) {
                            var activitytype = item.ActivityType;
                            var prior = item.Priority && item.Priority != 'null' ? $.fn.replaceAndEscapeHtmlExt(item.Priority) : 'N/A';
                            var Comments = item.Comments && item.Comments != 'null' ? item.Comments : 'N/A';
                            var Venue = item.Venue && item.Venue != 'null' ? $.fn.replaceAndEscapeHtmlExt(item.Venue) : 'N/A';
                            var ScriptName = item.ScriptName && item.ScriptName != 'null' ? $.fn.replaceAndEscapeHtmlExt(item.ScriptName) : 'N/A';
                            var strCheck = '<input type="button" style="float:right;margin-right:-5px; margin-top:-2px;" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                            html += '<tr><td>' + $.fn.replaceAndEscapeHtmlExt(item.PatientFullName) + '</td><td>' + item.AltruistaId + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(item.CareActivityTypeName) + '</td><td>' + prior + '</td><td style="width:185px;">';
                            if (item.IsLockNote) {
                                html += '<input type="text" data-Patient_FollowupId="' + item.ActivityLogId + '"  data-PatientId="' + item.PatientId + '" data-duedate="' + item.DueDateString + '"  class="AcceptCommentsFolloUpdate" id="txtAcceptCommentsFolloUpdate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.FollowupDateString) + '"/>' + strCheck + '</td><td>' + ScriptName + '</td><td><span class="fa fa-lock lightGrey"> Confidential notes</span></td><td>' + Venue + '</td></tr>';
                            }
                            else {
                                html += '<input type="text" data-Patient_FollowupId="' + item.ActivityLogId + '"  data-PatientId="' + item.PatientId + '" data-duedate="' + item.DueDateString + '"  class="AcceptCommentsFolloUpdate" id="txtAcceptCommentsFolloUpdate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.FollowupDateString) + '"/>' + strCheck + '</td><td>' + ScriptName + '</td><td>' + replaceNewLine(Comments) + '</td><td>' + Venue + '</td></tr>';
                            }
                        });
                        html += '</table>';
                        $('td#tdTableForBulkActivities').html('').append(html);
                        $('.AcceptCommentsFolloUpdate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
                        gridNotAvailableCustomColor('tdTableForBulkActivities');
                    }
                }
            });
        }
        else {
            isPHBulkActivity = false;
            $('#divRequestAcceptCommentsPopup').CMNPopup({
                popUpHeader: "Accept Comments",
                closeButton: '#btnCloseRequestReceivedAcceptComments',
                onClose: function () {
                    $("#hdnIsExternalActivity").val('');
                    $("#hdnIsExternalActivityPatientID").val('');
                    $("#btnRequestReceivedAccept").show();
                    $('.GearIconCls').removeAttr("disabled");
                }
            });
            $('#divRequestAcceptCommentsPopup textarea').val('');
            if (!isProvider && !($("#hdnIsExternalActivity").val())) {
                $('#divRequestAcceptCommentsPopup #divReqAcptIsConfidential').show();
                $('#ReqAcptIsConfidential').html('');
                bindConfidentialTypeRadioButton('ReqAcptIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
            }
            else{
                $('#divReqAcptIsConfidential').hide();
            }
            html = "";
            var isexternalactivity = "";
            if ($(this).hasClass("divClsMemberMenuAccept") && $(this).hasClass("divClsMemberMenuSib") && $('#divMemberMenuRefral_').is(':visible') === true && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {

                listReferenceId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
                listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
                isexternalactivity = $('#divMemberMenuRefral_').attr('data-isexternalactivity');
            }
            else {
                $.each(listCheckBox, function (key, item) {
                    if ($(item).is(':checked')) {
                        listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                        listPatientId += $(item).data('patientid') + ",";
                    }
                });
            }

            $("#hdnIsExternalActivityPatientID").val($('#divMemberMenuRefral_').attr('data-PatientId'));
            $("#hdnIsExternalActivity").val(isexternalactivity);
            $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
            $.ajax({
                type: "GET",
                url: baseURL + "/CommonDefaultSessionState/GetBulkActivity?listReferenceId=" + listReferenceId + "&isexternalactivity=" + isexternalactivity + "&isProvider=" + isProvider,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">' + GetHtmlDecode(GetHtmlDecode(altruistaIDLabelValue)) + '</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Priority</th><th scope="col" style="width:215px">Follow up Date</th><th align="left" scope="col">Script Name</th><th align="left" scope="col">Referral Notes</th><th align="left" scope="col">Contact Type</th></tr>';
                        $.each(data.activityList, function (key, item) {
                            var prior = item.Priority && item.Priority != 'null' ? item.Priority : 'N/A';
                            var Comments = item.Comments && item.Comments != 'null' ? item.Comments : 'N/A';
                            Comments = GetHtmlDecode($.fn.replaceAndEscapeHtmlExt(Comments));
                            var Venue = item.Venue && item.Venue != 'null' ? item.Venue : 'N/A';
                            var ScriptName = item.ScriptName && item.ScriptName != 'null' ? item.ScriptName : 'N/A';
                            var strCheck = '<input type="button" style="float:right;margin-right:-5px; margin-top:-2px;" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                            html += '<tr><td>' + $.fn.replaceAndEscapeHtmlExt(item.PatientFullName) + '</td><td>' + item.AltruistaId + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(item.CareActivityTypeName) + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(prior) + '</td><td style="width:185px;">';
                            $("#hdnRequestReceivedDueDate").val(item.DueDate);
                            if (item.IsLockNote)
                            { 
                                html += '<input type="text" data-Patient_FollowupId="' + item.ActivityLogId + '" data-PatientId="' + item.PatientId + '" data-duedate="' + item.DueDateString + '"  class="AcceptCommentsFolloUpdate" id="txtAcceptCommentsFolloUpdate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.FollowupDateString) + '"/>' + strCheck + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(ScriptName) + '</td><td><span class="fa fa-lock lightGrey"> Confidential notes</span></td><td>' + Venue + '</td></tr>';
                            }
                            else
                            {
                                html += '<input type="text" data-Patient_FollowupId="' + item.ActivityLogId + '" data-PatientId="' + item.PatientId + '" data-duedate="' + item.DueDateString + '"  class="AcceptCommentsFolloUpdate" id="txtAcceptCommentsFolloUpdate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.FollowupDateString) + '"/>' + strCheck + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(ScriptName) + '</td><td>' + replaceNewLine(Comments) + '</td><td>' + Venue + '</td></tr>';
                            }
                        });
                        html += '</table>';
                        $('td#tdTableForBulkActivities').html('').append(html);
                        $('.AcceptCommentsFolloUpdate').kendoDateTimePicker({ format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 30 });
                        gridNotAvailableCustomColor('tdTableForBulkActivities');
                    }
                }
            });
        }

    }
    if (requestReferTypeGlobal != "AG Complaint" && requestReferTypeGlobal != "UM Auth") {
        listCheckBox.removeAttr('checked');
    }
    $('.clsRefralChkMembercol').prop('checked', false);//prod-1099 - adding condition to clear header check after accepting the activities
    $('.ContextChkMenu').hide();
});

$(document).off('click', '[id=imgbtnMySchedule]').on('click', '[id=imgbtnMySchedule]', function () {
    isFromMySchedule = true;
    loadGlobalMySchedule();
});

$(document).off('click', '#btnAcceptRequestReceivedAcceptComments').on('click', '#btnAcceptRequestReceivedAcceptComments', function () {
    var msgcount1 = 0;
    var confidentialNoteTypeId = 0;
    $('span.validationMessage').remove();
    $(".AcceptCommentsFolloUpdate .k-input").each(function (index, element) {
        var endDateStr1 = $(element).val();
        var endDateStr2 = endDateStr1.split(' ')[0];
        var endDate2 = new Date(endDateStr2);
        var endYear2 = endDate2.getFullYear();
        var d2 = new Date();
        var n2 = d2.getFullYear();
        var endYear210 = n2 + 10;
        var timevalidation = IS_12HRS_FORMAT ? /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/ : /^([0?1][0-9]|2[0-3])(:[0-5]\d)$/;
        if (!date_regex.test(endDateStr2)) {
            $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>Enter valid Date in MM/DD/YYYY format</span>');
            msgcount1 = 1;
        }
        else if (!timevalidation.test(endDateStr1.split(' ')[2] != undefined ? endDateStr1.split(' ')[1] + ' ' + endDateStr1.split(' ')[2] : endDateStr1.split(' ')[1])) {
            $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>Enter valid time</span>');
            msgcount1 = 1;
        }
        else {
            if (endYear2 > endYear210) {
                endYear210 += 1;
                $(this).closest('td').append('<span class="validationMessage" style="color:red"><br class="validationMessage"/>End Date should be less than year ' + endYear210 + '</span>');
                msgcount1 = 1;
            }
        }
        let dueDate2 = $(this).data('duedate');
        if (!$.fn.isNullOrEmpty(dueDate2) && (bulkCMActivityConfig.toLowerCase() === 'false')) {
            let scheduledDate = endDateStr1;
            if (new Date(scheduledDate) > new Date(dueDate2)) {
                $(this).closest('td').append('<span class="validationMessage" style="color:red"><br class="validationMessage"/>Follow up Date should be less than DueDate ' + $.fn.apply12To24hrFormat(dueDate2) + '</span>');
                msgcount1 = 1;
            }
        }
    });
    if (msgcount1 == 0) {
        if (!(isPHBulkActivity)) {
            $('#btnAcceptRequestReceivedAcceptComments').attr('disabled', 'disabled');
            var listReferenceId = $('#hdnRequestReceivedAcceptCommentReferenceIds').val();
            var listFollowupDates = "";
            var postFollowupJsonData = [];
            $.each(listReferenceId.substr(0, listReferenceId.length - 1).split(','), function (key, item) {
                listFollowupDates += $('#txtAcceptCommentsFolloUpdate_' + key).val() + ",";
                var objFollowUpRec = {
                    FollowupDateValue: $('#txtAcceptCommentsFolloUpdate_' + key).val(),
                    Patient_FollowupId: $('#txtAcceptCommentsFolloUpdate_' + key).attr('data-Patient_FollowupId')
                };
                postFollowupJsonData.push(objFollowUpRec);
            });
            if ($('#divReqAcptIsConfidential').is(":visible"))
                confidentialNoteTypeId = $('input[name=rdoReqAcptIsConfidential]:checked').val();
            var dataParams = { "listReferenceId": listReferenceId, "acceptComments": $('#txtareaRequestReceivedAcceptComments').val(), "followupDates": listFollowupDates, "isexternalactivity": $("#hdnIsExternalActivity").val(), "isexternalactivityPatinetId": $("#hdnIsExternalActivityPatientID").val(), "confidentialNoteTypeId": confidentialNoteTypeId, "isphActivity": ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')), "postFollowupJsonData": JSON.stringify(postFollowupJsonData)};

            $.ajax({
                type: "POST",
                url: baseURL + "/CommonDefaultSessionState/CheckMultiAvailability",
                data: dataParams,
                dataType: "json",
                async: false,
                success: function (data) {
                    //if (data == -1) { console.log('sp err'); $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled'); return; }
                    if (data.success) {
                        if (data.message != 0) {
                            $().ConfirmationBox({
                                Title: 'Accept Activity', Top: 180, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                                Content: "An activity is already scheduled for this time. Would you still prefer to accept this activity on this time?"
                            }, function (response) {
                                $("#ConfirmPopup_Div").hide();
                                if (response) {
                                    $('#ReqAcptIsConfidential').html('');
                                    acceptReqRecComments(dataParams);
                                }
                                else { $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled'); return; }
                            });
                        } else acceptReqRecComments(dataParams);
                    }
                    else {
                        CustomAlert('Error. Please try again');
                        $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled');
                    }
                }
            });
        }
        else {
            $('#btnAcceptRequestReceivedAcceptComments').attr('disabled', 'disabled');

            var keyCount = 0;
            var listReferenceIdPH = $('#hdnRequestReceivedPHBulkAcptCmntInternalIds').val();
            var listFollowupDatesPH = "";
            if (listReferenceIdPH !== "") {
                $.each(listReferenceIdPH.substr(0, listReferenceIdPH.length - 1).split(','), function (_key, _item) {
                    listFollowupDatesPH += $('#txtAcceptCommentsFolloUpdate_' + keyCount).val() + ",";
                    keyCount++;
                });
            }
            var listExternalId = $('#hdnRequestReceivedPHBulkAcptCmntExternalIds').val();
            var listExternalFollowupDates = "";
            if (listExternalId != "") {
                $.each(listExternalId.substr(0, listExternalId.length - 1).split(','), function (key, item) {
                    listExternalFollowupDates += $('#txtAcceptCommentsFolloUpdate_' + keyCount).val() + ",";
                    keyCount++;
                });
            }
            var listExternalPatientID = $('#hdnRequestReceivedPHBulkAcptExtPatientIds').val();
            if ($('#divReqAcptIsConfidential').is(":visible")) {
                confidentialNoteTypeId = $('input[name=rdoReqAcptIsConfidential]:checked').val();
            }
            var dataParamsMultiAvailability = { "listReferenceId": listReferenceIdPH, "followupDates": listFollowupDatesPH, "listExternalId": listExternalId, "listExternalFollowupDates": listExternalFollowupDates, "acceptComments": $('#txtareaRequestReceivedAcceptComments').val(), "isexternalactivity": $("#hdnIsExternalActivity").val(), "listExternalPatientID": listExternalPatientID, "confidentialNoteTypeId": confidentialNoteTypeId };

            $.ajax({
                type: "POST",
                url: baseURL + "/CommonDefaultSessionState/CheckMultiAvailability",
                data: dataParamsMultiAvailability,
                dataType: "json",
                async: false,
                success: function (data) {
                    if (data.success) {
                        if (data.message != 0) {
                            $().ConfirmationBox({
                                Title: 'Accept Activity', Top: 180, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                                Content: "An activity is already scheduled for this time. Would you still prefer to accept this activity on this time?"
                            }, function (response) {
                                $("#ConfirmPopup_Div").hide();
                                if (response) {
                                    phBulkActivityAccept(dataParamsMultiAvailability);
                                }
                                else { $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled'); return; }
                            });
                        } else {
                            phBulkActivityAccept(dataParamsMultiAvailability);
                        }
                    }
                    else {
                        CustomAlert('Error. Please try again');
                        $('#btnAcceptRequestReceivedAcceptComments').removeAttr('disabled');
                    }
                }
            });
        }
    }
});

$(document).off('click', '#btnAcceptMSRequestReceivedAcceptComments').on('click', '#btnAcceptMSRequestReceivedAcceptComments', function () {
    var msgcount1 = 0;
    $('span.validationMessage').remove();
    $(".MSAcceptCommentsFolloUpdate .k-input").each(function (index, element) {
        var endDateStr2 = $(element).val();
        endDateStr2 = endDateStr2.split(' ')[0];
        var endDate2 = new Date(endDateStr2);
        var endYear2 = endDate2.getFullYear();
        var d2 = new Date();
        var n2 = d2.getFullYear();
        var endYear210 = n2 + 10;
        if (!date_regex.test(endDateStr2)) {
            $(this).closest('td').append('<br/><span class="validationMessage" style="color:red">Enter valid Date in MM/DD/YYYY format</span>');
            msgcount1 = 1;
        }
        else {
            if (endYear2 > endYear210) {
                endYear210 += 1;
                $(this).closest('td').append('<br class="validationMessage"/><span class="validationMessage" style="color:red">End Date should be less than year ' + endYear210 + '</span>');
                msgcount1 = 1;
            }
        }
    });

    if (msgcount1 == 0) {
        $('#btnAcceptMSRequestReceivedAcceptComments').prop('disabled', 'disabled');
        var listReferenceId = $('#hdnRequestReceivedAcceptCommentReferenceIds').val();
        var listFollowupDates = "";
        var patientId = $('#txtMSAcceptCommentsFolloUpdate_0').data('patientid');
        $.each(listReferenceId.substr(0, listReferenceId.length - 1).split(','), function (key, item) {
            listFollowupDates += $('#txtMSAcceptCommentsFolloUpdate_' + key).val() + ",";
        });

        var dataParams = { "listReferenceId": listReferenceId, "acceptComments": escapeHtml($('#txtareaMSRequestReceivedAcceptComments').val()).replace(/&#39;/g, "'"), "followupDates": listFollowupDates, "crmQueueId": $('#hdnMSRequestReceivedAcceptCrmQueueIds').val(), "careStaffId": getMemberId().MemberId, "timeDictionaryobj": timeZone, "patientId": patientId };
        $.ajax({
            type: "GET",
            url: baseURL + "/Activity/AcceptMsRequestReceivedActivity",
            data: dataParams,
            dataType: "json",
            async: false,
            success: function (data) {
                if (data.success) {
                    $('#btnCloseMSRequestReceivedAcceptComments').trigger('click');
                    CustomAlert('Activity has been accepted successfully!');

                    var isScheduleVisibleDel = $('#popUpGlobalMySchedule').is(':visible');
                    if (isScheduleVisibleDel) {
                        var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                        if (currentView == "Week") {
                            $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                            loadGlobalMySchedule();
                        }
                        else {
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                    }
                    if (!isScheduleVisibleDel && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                    }

                    if ($("#id1frame").contents().find('[id*=btnImgRRec]').length > 0) {
                        $("#id1frame").contents().find('[id*=btnImgRRec]').trigger('click');
                    }
                    if (isMAL) {
                        RefreshGridOnActionPerformed("TCAL", "MS");
                        RefreshGridOnActionPerformed("REQREC", "MS");
                    }
                    else if ($("#btnRequestReceivedSearch").length > 0)
                        $('#btnRequestReceivedSearch').trigger('click');

                }
                else
                    CustomAlert('Error. Please try again');
            }

        });
    }
});


$(document).off('click', '#btnAcceptRequestReceivedAGAcceptComments').on('click', '#btnAcceptRequestReceivedAGAcceptComments', function () {
    $('span.validationMessage').remove();
    var listReferenceId = $('#hdnRequestReceivedAcceptCommentReferenceIds').val();
    $("#hdnAGRequestReferalId").val('');
    $("#hdnAGRequestReferalId").val(listReferenceId);
    var listScheduledDates = "";
    var listActivityDuedate = "";
    var listComplaintRecivedDate = "";
    var listComplaintId = $('#hdnRequestReceivedComplaintRecordIds').val();
    var rfrTyId = "";
    if ($('#hdnIsFromWLMAg').val() == '1') {
        rfrTyId = '7';
    }
    else {
        rfrTyId = $('#selectRequestReceivedReferType' + (isMAL ? 'MAL' : '')).val();
    }
    $.each(listReferenceId.substr(0, listReferenceId.length - 1).split(','), function (key, item) {
        listScheduledDates += $('#txtAcceptCommentsScheduleddate_' + key).val() + ",";
        listActivityDuedate += $('#txtAcceptCommentsDueDate_' + key).val() + ",";
        listComplaintRecivedDate += $('#txtAcceptCommentsReceivedDate_' + key).val() + ",";
    });
    listScheduledDates = listScheduledDates.substring(0, listScheduledDates.length - 1);
    listActivityDuedate = listActivityDuedate.substring(0, listActivityDuedate.length - 1);
    listComplaintRecivedDate = listComplaintRecivedDate.substring(0, listComplaintRecivedDate.length - 1);
    var tmpacceptComments = encodeURIComponent($('#txtareaRequestReceivedAGAcceptComments').val());
    var dataStr = {
        listReferenceId: listReferenceId,
        timeDictionaryobj: timeZone,
        listComplaintId: listComplaintId,
        referTypeId: rfrTyId,
        acceptComments: tmpacceptComments,
        SchedularDates: listScheduledDates
    };

    if (ValidateAcceptAgActivity(listScheduledDates, listActivityDuedate, listComplaintRecivedDate)) {
        $.ajax({
            type: "POST",
            url: baseURL + "/Dashboard/AcceptReferenceForAGActivity/",
            dataType: "json",
            data: dataStr,
            success: function (data) {
                if (data.success) {
                    if ($('#hdnIsFromWLMAg').val() != '1') {
                        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                            onLoadMyCalendar();
                        });
                        $('#btnRequestReceivedSearch' + (isMAL ? 'MAL' : '')).trigger('click');
                        if (isMAL) { RefreshGridOnActionPerformed("TCAL", "AG"); }
                    }

                    if (data.msg == "Success") {
                        CustomAlert("Activity accepted successfully.");
                        $('#closePopUp').trigger('click');
                        if ($('#hdnIsFromWLMAg').val() == '1') { $("#AGPendingActivitiesGrid").data("kendoGrid").dataSource.read(); }
                        else if ($.trim($('#MyMemberHeaderName').html()) == 'Pending Complaint Activities') {
                            $("#PendingComplaintActivities").data("kendoGrid").dataSource.read();
                        }
                    }
                    else { CustomAlert(data.msg); if ($('#hdnIsFromWLMAg').val() == '1') { $("#AGPendingActivitiesGrid").data("kendoGrid").dataSource.read(); } }

                    $('#btnCloseRequestReceivedAGAcceptComments').trigger('click');
                }
                else {
                    CustomAlert(data.msg);
                    if ($('#hdnIsFromWLMAg').val() == '1') {
                        $("#AGPendingActivitiesGrid").data("kendoGrid").dataSource.read();
                    }
                    else {
                        refereshDatasourcefromPager('ReqRecGrid' + (isMAL ? 'MAL' : ''));
                    }
                }
                $('#hdnIsFromWLMAg').val('');
            }
        });
    }
    // FillRequestCount();
    var complaintRecordId=$("#hdnComplaintId").val();
    var patientId=$("#hdnPatientId").val();
    var activityId = $("#hdnActivityId").val();
    var parentactivityId = $("#hdnParentActivityId").val();
    var activitytypename = $("#hdnActivityTypeName").val();
    var activityParentId = activityId + "|" + parentactivityId;
    if (isNewAgMdrReview && $('#btnAcceptRequestReceivedAGAcceptComments').val() === 'Accept and Perform') {
        if (!$.fn.isNullOrEmpty(parentactivityId) && activitytypename.toLowerCase() === "additional information requested") {
            //AIR activity redirect code to implement
            //requestReceviedAgAIRActivity(authredirect, activityId, IsPerform);
            ClickFireComplaintId(complaintRecordId, patientId, activityParentId, activitytypename);
        }
        else {
            ClickFireComplaintId(complaintRecordId, patientId, activityId, activitytypename);
        }
    }
});
$(document).off('click', '.requestRecAuthRedirect').on('click', '.requestRecAuthRedirect', function () {
    parent.top.$('#btnAfterAcceptUMAuth').attr('data-arguments', $(this).data('authredirect'));
    parent.top.$('#btnAfterAcceptUMAuth').trigger('click');
});

$(document).off('click', '.clsRejectedChkMember').on('click', '.clsRejectedChkMember', function () {
    var isMALReqRej = isMAL || reqRecAndRejMAL;
    var $grid = $('#ReqRejGridMAL');
    var chkdchkbxs = $grid.find('input[type="checkbox"]:checked.clsRejectedChkMember');
    var patientId = $(chkdchkbxs[0]).data('patientid');
    if (isMALReqRej) {
        $('.divClsRejectedMemberMenu').hide();
        ClearAllContextMenu('divRequestRejectedGrid');
        var gridid = '#RequestRejectedGridDiv';
        var refTypeGlobal = isMALReqRej ? requestReferTypeMALGlobal : requestReferTypeGlobal;
        if (chkdchkbxs.length == $grid.find('input[type="checkbox"]:checked.clsRejectedChkMember').length) {
            $grid.find('input[type="checkbox"].clsRejectedChkMembercol').prop('checked', true);
        }
        else {
            $grid.find('input[type="checkbox"].clsRejectedChkMembercol').prop('checked', false);
        }
        if (chkdchkbxs.length == 1) {
            var pos = $(chkdchkbxs[0]).offset();
            pos.top = setPstnCntxtMenu(chkdchkbxs[0]);
            if (refTypeGlobal == "Appointment")
                $(gridid + ' #divAppointmentMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            else if (refTypeGlobal == "Care Plan")
                $(gridid + ' #divCarePlanMenuRefral_1').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            else
                $(gridid + ' #divMemberMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            $(gridid + ' #divMemberMenuRejected_ .divClsMemberMenuDelete').attr('data-patientid', patientId);
        }
        else {
            $('.ContextChkMenu').hide();
        }
    } else {
        var chkdchkbxs = $('#ReqRejGrid').find('input[type="checkbox"]:checked.clsRejectedChkMember');
        $('.divClsRejectedMemberMenu').hide();
        if (chkdchkbxs.length == $('#ReqRejGrid').find('input[type="checkbox"].clsRejectedChkMember').length) {
            $('#ReqRejGrid').find('input[type="checkbox"].clsRejectedChkMembercol').prop('checked', true);
        }
        else {
            $('#ReqRejGrid').find('input[type="checkbox"].clsRejectedChkMembercol').prop('checked', false);
        }
        if (chkdchkbxs.length == 1) {
            var pos = $(chkdchkbxs[0]).offset();
            pos.top = setPstnCntxtMenu(chkdchkbxs[0]);
            if (requestReferTypeGlobal == "Appointment") {
                $('#divAppointmentMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            }
            else if (requestReferTypeGlobal == "Care Plan")
                $('#divCarePlanMenuRefral_1').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
            //else if (requestReferTypeGlobal == "Messages")
            //    $('#divMessageMenuRefral_').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            else {
                $('#divMemberMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px");
                $('#divMemberMenuRejected_ .divClsMemberMenuDelete').attr('data-patientid', patientId);
                if ($(this).data("type") == "External") {
                    $('#divMemberMenuRejected_ #divMemberMenuAccept_').hide();
                } else {
                    $('#divMemberMenuRejected_ #divMemberMenuAccept_').show();
                }
            }
        }
        else {
            $('.ContextChkMenu').hide();
        }
    }
});

$(document).off('click', '.clsRejectedChkMembercol').on('click', '.clsRejectedChkMembercol', function () {
    $(".clsRejectedChkMember").prop('checked', $(this).prop('checked'));
    var chkdchkbxs = $('#ReqRejGrid').find('input[type="checkbox"]:checked.clsRejectedChkMember');
    if ($(this).is(':checked') && chkdchkbxs.length == 1) {
        var pos = $(chkdchkbxs[0]).offset();
        pos.top = setPstnCntxtMenu(chkdchkbxs[0]);
        if (requestReferTypeGlobal == "Appointment")
            $('#divAppointmentMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
        else if (requestReferTypeGlobal == "Care Plan")
            $('#divCarePlanMenuRefral_1').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
        //else if (requestReferTypeGlobal == "Messages")
        //    $('#divMessageMenuRefral_').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
        else
            $('#divMemberMenuRejected_').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
    }
    else {
        $('.ContextChkMenu').hide();
    }
});
$(document).off('click', '#btnReferRRejUMAuthRefer').on('click', '#btnReferRRejUMAuthRefer', function () {
    var referTo = (isMAL) ? $('#selectRRejUMAuthReferReferTo').val() : $('#hdnRRejUMAuthReferReferTo').val();
    var isWorkQueue = $("#chkRRUMGroupActivity").is(":checked");
    var deptIds = $('#ddlRRUMDepartmentIdhdn').val();
    var staffIds = $('#ddlRRUMStaffIdsIdhdn').val();
    var referralId = $('#hdn' + (isMAL ? 'MAL' : '') + 'UmAuthReqRejReferReferralId').val();
    var patientId = $('#chkMember_' + referralId).data('patientid');
    var referComments = $('#txtareaRRejUMAuthReferReferComments').val();
    referComments = referComments.replace(/</g, "//&lt;").replace(/>/g, "&gt;//");
    referComments = escapeHtml(referComments);
    if (isWorkQueue == true) {
        if (staffIds == null || staffIds == "") { CustomAlert("Please select atleast one carestaff"); return; }
    }
    else {
        if (referTo < 0 || referTo === undefined || referTo === "") {
            CustomAlert("Please select a carestaff");
            $("#UmRRejUMAuthReferReferTo_Valid").show();
            return;
        }
        else {
            $("#UmRRejUMAuthReferReferTo_Valid").hide();
        }
    }

    $.ajax({
        type: "GET",
        url: baseURL + '/Authorization/ReferAgainUMAuth?referalId=' + referralId + '&referComments=' + referComments + '&ReferTo=' + referTo + '&IsChecked=' + isWorkQueue + '&StaffId=' + staffIds + '&WorkQueueId=' + deptIds + "&PatientId=" + patientId,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                if (isMAL) {
                    $('#btnRequestRejectedSearchMAL').trigger('click');
                    RefreshGridOnActionPerformed("OPENAUTH", '');
                    RefreshGridOnActionPerformed("REQREC", 'UM');
                }
                else
                    $('#btnRequestReceivedSearch').trigger('click');
                $('#btnCloseRRejUMAuthRefer').trigger('click');
                CustomAlert(data.msg);
            }
        }
    });
});

$(document).off('click', '#btnReferRRejAGComplaintRefer').on('click', '#btnReferRRejAGComplaintRefer', function () {
    var referTo = $('#selectRRejAGComplaintReferReferTo').val();
    //var referralId = $('#hdnUmAuthReqRejReferReferralId').val();
    var referComments = $('#txtareaRRejAGComplaintReferReferComments').val();
    referComments = escapeHtml(referComments);
    var actionDetailsId = $('#hdnUmAuthReqRejReferActionDetailsId').val();
    var patientId = $('#hdnReqRejReferPatientId').val();
    var isWorkQueue = $("#chkRRAGGroupActivity").is(":checked");
    var deptIds = isWorkQueue ? $('#ddlRRAGDepartmentIdhdn').val() : "";
    var staffIds = isWorkQueue ? $('#ddlRRAGStaffIdsIdhdn').val() : "";
    var scheduledDate = $('#hdnAgReqRejReferReferralfollowupdate').val();
    var urlData = "";
    var requestReferType = isMAL ? requestReferTypeMALGlobal : requestReferTypeGlobal;
    var datastring = null;
    var referalId = $('#hdnUmAuthReqRejReferReferralId').val();
    var CompType = $('#chkAgActivity_' + referalId).data('complainttype');
    if (requestReferType == "AG Complaint") {
        var complaintRecordId = $('#hdnAgComplaintReqRejReferComplaintRecId').val();
        urlData = baseURL + '/Complaint/PostReferalComplaint?careStaffId=+' + getMemberId().MemberId + '&IsWorkQueue=' + isWorkQueue + "&DeptId=" + deptIds + "&complaintType=" + CompType;
        datastring = { ComplaintRecordId: complaintRecordId, ReferredTo: referTo, ReferrelNotes: referComments, StaffId: staffIds, PatientId: patientId };
    }
    else {
        urlData = baseURL + '/Activity/ReferAgainAGActivity?careStaffId=' + getMemberId().MemberId + "&IsWorkQueue=" + isWorkQueue + "&scheduledDate=" + scheduledDate + "&complaintType=" + CompType;
        datastring = { actionDetailsId: actionDetailsId, deptId: deptIds, staffId: staffIds, referComments: referComments, referTo: referTo, patientId: patientId };
    }
    if (ValidationForRejReferalComplaint()) {
        $.ajax({
            type: "POST",
            url: urlData,
            data: datastring,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $('#hdnAgComplaintReqRejReferComplaintRecId').val("");
                    if (!isMAL) { $('#btnRequestReceivedSearch').trigger('click'); }
                    $('#closePopUp').trigger('click');
                    if (data.msg == "Success") {
                        if (requestReferType == "AG Complaint") { CustomAlert("Complaint referred successfully."); }
                        else { CustomAlert("Activity referred successfully."); }
                    }
                    else
                        CustomAlert(data.msg);
                    $('#btnCloseRRejAGComplaintRefer').trigger('click');
                    if (isMAL) {
                        RefreshGridOnActionPerformed("TCAL", "AG");
                        RefreshGridOnActionPerformed("REQREC", "AG");
                        RefreshGridOnActionPerformed("REQREJ", "AG");
                    }
                }
                else { CustomAlert(data.msg); }
            }
        });
    }
});

$(document).off('click', '#btnReferRequestRejectReferMember').on('click', '#btnReferRequestRejectReferMember', function () {
    if (ValidateReReferdata()) {
        loader(1);
        var CareStaffId = $('#hdnCareStaffRequestRejectReferMember').val();
        var isInActPCTM = (CareStaffId == memberidval) ? $("#chkIsInActPCTMRR").is(":checked") : false;
        // var referalId = $('#hdnUmAuthReqRejReferReferCommentsReferalId').val();
        var patientId = $('#hdnUmAuthReqRejReferReferCommentsPatientId').val();
        var ReasonForReferral = $("#selectReasonForRefRequestRejectReferMember").val();
        var notes = $("#txtNotesRequestRejectReferMember").val();
        var isConfidential = $('#selectIsConfidetialRequestRejectReferMember').val();
        var chkdChkBx = $('#chkRRGroupActivity').is(':checked');
        var staffIds = $('#ddlRRStaffIdsIdhdn').val();
        var deptId = $('#ddlRRDepartmentIdhdn').val();

        var dataStr = {
            // referalId: referalId,
            patientId: patientId,
            CareStaffId: CareStaffId,
            ReasonForReferral: ReasonForReferral,
            notes: notes,
            isConfidential: isConfidential,
            IsChecked: chkdChkBx,
            isActTransfer: $("#chkIsActTransferRR").is(":checked"),
            isInActPCTM: isInActPCTM,
            StaffId: staffIds,
            DeptId: deptId,
            NoteConfidentialTypeId: $('input[name=rdoRFAHNIsConfidential]:checked').val()
        }
        $.ajax({
            type: "POST",
            url: baseURL + "/Home/ReferAgain",
            data: dataStr,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $('#btnRequestReceivedSearch' + (isMAL ? 'MAL' : '')).trigger('click');
                    if (isMAL) {
                        RefreshGridOnActionPerformed("TCAL", "CM");
                        RefreshGridOnActionPerformed("REQREC", "CM");
                        RefreshGridOnActionPerformed("REQREJ", "CM");
                    }
                    $('#closePopUp', '#popUpDialog2').trigger('click');
                    if (data.msg == 'Refer') {
                        CustomAlert('Member has been referred successfully!');
                    }
                    else if (data.msg == 'self Refer') {
                        CustomAlert('Member has been self referred successfully!');
                    }
                }
                else {
                    $('#closePopUp', '#popUpDialog2').trigger('click');
                    CustomAlert(data.msg);
                }
                loader(0);
            }
        });
    }
});

$(document).off('click', '#btnSelfReferRequestRejectReferMember').on('click', '#btnSelfReferRequestRejectReferMember', function () {
    CheckPrimaryCMExists($('#hdnUmAuthReqRejReferReferCommentsPatientId').val(), "SRFRR");
});

$(document).off('click', '.divClsMemberMenuRefer').on('click', '.divClsMemberMenuRefer', function () {
    if (!isMAL) {
        var referalId = getReferalId('ReqRejGrid');
        var patientId = $('#chkMember_' + referalId).data('patientid');
        $('#popUpDialog2').empty();
        //if ($('#selectRequestReceivedModule').val() == 1) {//Converting Kendo DropDown
        if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 1) {//Converting Kendo DropDown
            var rejectReferUrl = "";
            if (requestReferTypeGlobal == 'Member')
                rejectReferUrl = baseURL + '/CommonDefaultSessionState/IsCheckReferAgain?referalId=' + referalId + '&patientId=' + $('#chkMember_' + referalId).data('patientid') +
                    '&patientName=' + $('#chkMember_' + referalId).data('patientname') + '&referType=' + requestReferTypeGlobal;
            else if (requestReferTypeGlobal == "Activity")
                rejectReferUrl = baseURL + "/CommonDefaultSessionState/IsCheckReferAgain?referalId=" + referalId + '&groupId=' + $('#chkMember_' + referalId).data('groupid')
                    + '&patientFollowupId=' + $('#chkMember_' + referalId).data('patientfollowupid') + '&patientId=' + $('#chkMember_' + referalId).data('patientid') + '&referType=' + requestReferTypeGlobal;
            loader(1);
            $.ajax({
                type: "GET",
                url: rejectReferUrl,
                dataType: "json",
                success: function (data) {
                    loader(0);
                    if (data.success) {
                        $('#hdnUmAuthReqRejReferReferCommentsPatientId').val(data.patientID);
                        $('#hdnUmAuthReqRejReferReferCommentsReferalId').val(data.referalId);

                        if (requestReferTypeGlobal == 'Member') {
                            //$('#divRequestRejectReferMember').CMNPopup({ popUpHeader: "Refer Member" });
                            //$('#tblRequestRejectReferMember #RejectMbrAutoCmplt .k-state-default').removeClass('k-input');
                            $("#RFAHNIsConfidential").html('');
                            bindConfidentialTypeRadioButton('RFAHNIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
                            if (isProviderUser)
                                $('#divRFAHNIsConfidential').hide();
                            else
                                $('#divRFAHNIsConfidential').show();
                            $("#popUpDialog2").append($("#divRequestRejectReferMember").html());
                            $('#popUpDialog2').CMNPopup({ popUpHeader: "Refer Member" });
                            $('divRequestRejectReferMember textarea').val('');
                            $('#selectIsConfidetialRequestRejectReferMember').val('Yes');
                            $('#tblRequestRejectReferMember').show();
                            $('#tblReqRejReferUmAuth').hide();
                            $('#tblReqRejReferAGComplaint').hide();
                            $('#lblCareMemberRequestRejectReferMember').text(data.patientName);
                            $('#txtNotesRequestRejectReferMember').val('');
                            $('#tblRequestRejectReferMember #RejectMbrAutoCmplt .k-state-default').removeClass('k-input');
                            loadDropDown(baseURL + '/Home/LoadReasonReferenceSelfRefer', 'selectReasonForRefRequestRejectReferMember');
                            // loadDropDown(baseURL + '/Home/LoadCareStaffDDL/', 'selectCareStaffRequestRejectReferMember');
                            $("#hdnCareStaffRequestRejectReferMember").val("");
                            $('#chkRRGroupActivity').prop("checked", false);
                            $('#trCareStaff').show();
                            $('#trRRWQDepartment').hide();
                            $('#trRRWQCareStaffBydept').hide();

                            $('#chkRRGroupActivity').click(function () {
                                if ($('#chkRRGroupActivity').is(':checked')) {
                                    if ($('#trIsInActPCTMRR').is(':visible')) { $('#trIsInActPCTMRR').hide(); $('#chkIsInActPCTMRR').attr('checked', false); }
                                    $("#hdnCareStaffRequestRejectReferMember").val('');
                                    $('#selectCareStaffRequestRejectReferMember').val('');
                                    $('#trCareStaff').hide();
                                    $('#trRRWQDepartment').show();
                                    $('#trRRWQCareStaffBydept').show();
                                    //PROD-21034 === START
                                    if (requestReferTypeGlobal == 'Member') {
                                        var noteLbl = "";
                                        if (!$('#trReferMemberServiceIntOrDeceased').is(":visible")) {
                                            noteLbl = "Note:";
                                        }

                                        $("#trReferMemRRejctProfileNotMatchInfoMsg").show();
                                        $("#trReferMemRRejctProfileNotMatchInfoMsg").html('');
                                        $("#trReferMemRRejctProfileNotMatchInfoMsg").append('<td colspan="3" class="ItemPB10"><table width="100%"><tr><td valign="top" class="ItemPR5 bold" width="10%">' + noteLbl + '</td><td valign="top">The care staff who are not having the matching profile to the member will not able to access the member from Request Received.</td></tr></table> </td>');
                                    }
                                    //PROD-21034===END
                                    CreateDropCheck('ddlRRDepartment', baseURL + '/Master/BindWorkQueues/', 'ddlRRDepartmentId', null, null, null, isWorkQueueSingle, 'DepartmentName', 'DepartmentId');
                                    CreateDropCheck('ddlRRStaffIds', baseURL + '/CommonDefaultSessionState/GetCmStaffIds', 'ddlRRStaffIdsId', null, null);
                                }
                                else {
                                    $('#trCareStaff').show();
                                    $('#trRRWQDepartment').hide();
                                    $('#trRRWQCareStaffBydept').hide();
                                    //PROD-21034
                                    $("#trReferMemRRejctProfileNotMatchInfoMsg").show();
                                    $("#trReferMemRRejctProfileNotMatchInfoMsg").html('');
                                }
                            });

                            $(document).off('click', '#ddlRRDepartmentId,#ddlRRDepartmentIdspn').on('click', '#ddlRRDepartmentId,#ddlRRDepartmentIdspn', function () {
                                var value = "";
                                var eleid = this.id.replace('spn', '');
                                var chkboxes = $("#" + eleid + "chk").find('input[type="' + ReturnWorkQueueControlType() + '"]:checked');
                                for (var i = 0; i < chkboxes.length; i++) {
                                    value += chkboxes[i].defaultValue + ",";
                                }
                                let CoiPatientId = $.fn.setNumberOnUndefinedOrNull($('#hdnUmAuthReqRejReferReferCommentsPatientId').val());
                                value = value.substring(0, value.length - 1);
                                let configObj = {
                                    url: baseURL + '/CommonDefaultSessionState/GetCmStaffIds?deptId=' + value + '&coiPatientId=' + CoiPatientId,
                                    ddlId: 'ddlRRStaffIdsId',
                                    tbId: 0,
                                    isCheckAll: true
                                };
                                A11yDropcheck.createDropcheck('ddlRRStaffIds', configObj);
                            });

                            if (data.serviceInterruptionName != '' || data.memberDeceasedAlert.toLowerCase() == 'red') {
                                $('#trReferMemberServiceIntOrDeceased').show();
                                if (data.serviceInterruptionName != '') {
                                    $('#spanReferMemberServiceInterruption').show().AhsSetHtml('Member has at least one service interruption - ' + data.serviceInterruptionName + '<br/>');
                                }
                                if (data.memberDeceasedAlert.toLowerCase() == 'red') {
                                    $('#spanReferMemberDeceased').show();
                                }
                            }
                            else {
                                $('#trReferMemberServiceIntOrDeceased').hide();
                                if (data.serviceInterruptionName == '') {
                                    $('#spanReferMemberServiceInterruption').hide().val('');
                                }
                                if (data.AlertStatus != 'Red') {
                                    $('#spanReferMemberDeceased').hide();
                                }
                            }
                        }
                        else {
                            $('#popUpDialog1').CMNPopup({
                                pvUrl: baseURL + "/Home/EditActivity?ActId=" + data.patientFollowupId + "&ActivityRejectionType=true&patientid=" + patientId,
                                onLoad: function () {
                                    onLoadEditActivity();
                                    $('#selectScheduledType').attr('disabled', 'disabled');
                                    $("#rdoEAInternal").attr("disabled", true);
                                    $("#rdoEAExternal").attr("disabled", true);
                                    $("#rdoPharmacist").attr("disabled", true);
                                    $('#btnSubmitActivityForm').hide();
                                    $('#btnCloseActivityForm').removeClass('ah-btn-secondary').addClass('ah-btn-primary').text('Update and Close');
                                    A11yModal.trapFocusInModal('popUpDialog1');
                                },
                                onClose: function () {
                                    ClearActivityHdnCntrls();
                                },
                                popUpHeader: "Edit Activity",
                                modalWidth: MODAL_WIDTH.MEDIUM,
                                closeButton: "#btnCloseEditActivityForm"
                            });
                        }
                    }
                    else
                        CustomAlert(data.msg);
                },
                error: function () {
                    loader(0);
                }
            });
        }
        // else if ($('#selectRequestReceivedModule').val() == 3) {//Converting Kendo DropDown
        else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 3) {//Converting Kendo DropDown            
            //To Implement UM Activity Refer functionality            
            if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Activity") {
                loader(1);
                $('#popUpDialog1').CMNPopup({
                    pvUrl: baseURL + "/Home/OpenAuthAddActivity?ActId=" + $('#chkUMActivity_' + referalId).data('logid') + "&PatientId=" + $('#chkUMActivity_' + referalId).data('patientid'),
                    onLoad: function () {
                        onLoadOpenAuthAddAct();
                        $('#loaderImg').hide();
                        $('#btnSubmitActivityForm').css('display', 'none');
                        $('#btnSubmitCloseActivityForm').css('display', 'none');
                        $('#btnUpdateActivityForm').css('display', 'inline');
                        $('#btnUpdateCloseActivityForm').css('display', 'inline');
                        onUMWorkQueueRefer();
                        A11yModal.trapFocusInModal('popUpDialog1');

                    },
                    popUpHeader: "Edit Activity",
                    closeButton: '#closebutton',
                    modalWidth: MODAL_WIDTH.MEDIUM
                });
                loader(0);
            }
            else {
                let CoiPatientId = $('#chkMember_' + referalId).data('patientid');
                CoiPatientId = (CoiPatientId !== undefined && CoiPatientId !== '') ? CoiPatientId : 0;
                BindReferToSearchValue(CoiPatientId);
                $("#selectRRejUMAuthReferReferTo").hide();
                $('#hdnUmAuthReqRejReferReferralId').val(referalId);
                $('#divRequestRejectReferMember').CMNPopup({
                    popUpHeader: "Refer Authorization",
                    closeButton: '#btnCloseRRejUMAuthRefer',
                    onClose: function () {
                        $("#selectRRejUMAuthReferReferTo").show();
                        let umAuthReferReferToAutoComplete = $("#trUMCareStaff #tdUMCareStaff #txtRRejUMAuthReferReferTo").data("kendoAutoComplete");
                        if (umAuthReferReferToAutoComplete !== undefined && umAuthReferReferToAutoComplete !== null) {
                            umAuthReferReferToAutoComplete.destroy();
                            umAuthReferReferToAutoComplete.wrapper.remove();
                        }
                        $("#txtareaRRejUMAuthReferReferComments").val('');
                    }
                });
                $("#txtRRejUMAuthReferReferTo").val(GetHtmlDecode(careStaffFullName + "-" + rolenameval));
                $("#hdnRRejUMAuthReferReferTo").val(memberidval);
                $("#UmRRejUMAuthReferReferTo_Valid").hide();

                $('divRequestRejectReferMember textarea').val('');
                $('#tblRequestRejectReferMember').hide();
                $('#tblReqRejReferUmAuth').show();
                $('#tblReqRejReferAGComplaint').hide();
                $('#lblRRejUMAuthReferPName').text($('#chkMember_' + referalId).data('patientname'));
                $('#lblRRejUMAuthReferAuthId').text($('#chkMember_' + referalId).data('authid'));
                $('#lblRRejUMAuthReferAuthType').text($('#chkMember_' + referalId).data('authtypename'));
                $('#lblRRejUMAuthReferRefTypeUm').text($('#chkMember_' + referalId).data('refertype'));
                $('#lblRRejUMAuthReferReferedBy').text($('#chkMember_' + referalId).data('referredbyname'));

                $('#chkRRUMGroupActivity').prop('checked', false);
                $('#trUMCareStaff').show();
                $('#trRRUMWQDepartment').hide();
                $('#trRRUMWQCareStaffBydept').hide();
                $('#chkRRUMGroupActivity').click(function () {
                    if ($('#chkRRUMGroupActivity').is(':checked')) {
                        $('#trUMCareStaff').hide();
                        $('#trRRUMWQDepartment').show();
                        $('#trRRUMWQCareStaffBydept').show();
                        CreateDropCheck('ddlRRUMDepartment', baseURL + '/Master/BindWorkQueues/', 'ddlRRUMDepartmentId', null, null, null, isWorkQueueSingle, 'DepartmentName', 'DepartmentId');
                        CreateDropCheck('ddlRRUMStaffIds', baseURL + '/CommonDefaultSessionState/GetCmStaffIds', 'ddlRRUMStaffIdsId', null, null);
                    }
                    else {
                        $('#trUMCareStaff').show();
                        $('#trRRUMWQDepartment').hide();
                        $('#trRRUMWQCareStaffBydept').hide();
                    }
                })
                $(document).off('click', '#ddlRRUMDepartmentId,#ddlRRUMDepartmentIdspn').on('click', '#ddlRRUMDepartmentId,#ddlRRUMDepartmentIdspn', function () {
                    var value = "";
                    var eleid = this.id.replace('spn', '');
                    var chkboxes = $("#" + eleid + "chk").find('input[type=' + ReturnWorkQueueControlType() + ']:checked');
                    for (var i = 0; i < chkboxes.length; i++) {
                        value += chkboxes[i].defaultValue + ",";
                    }
                    value = value.substring(0, value.length - 1);
                    var referAuthPatientId = $('#chkMember_' + referalId).data('patientid');
                    let configObj = {
                        url: baseURL + '/CommonDefaultSessionState/GetStaffIdsNew?deptId=' + value + '&IsWorkQueue=1' + '&patientId=' + referAuthPatientId,
                        ddlId: 'ddlRRUMStaffIdsId',
                        tbId: 0,
                        isCheckAll: true
                    };
                    A11yDropcheck.createDropcheck('ddlRRUMStaffIds', configObj);
                });
                //G8cal-20
            }
        }
        // else if ($('#selectRequestReceivedModule').val() == 5) {//Converting Kendo DropDown
        else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 5) {//Converting Kendo DropDown

            $('#txtareaRRejAGComplaintReferReferComments').val('');
            $('#hdnUmAuthReqRejReferReferralId').val(referalId);

            if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == 'AG Complaint') {
                $('#divRequestRejectReferMember').CMNPopup({ popUpHeader: "Refer Complaint", closeButton: '#btnCloseRRejAGComplaintRefer' });
                $('#lblRRejAGComplaintReferDueDate').show();
                $('#lblRRejAGComplaintReferActivityFollowUpDate').hide();
                $('#lblRRejAGComplaintReferActivityDueDate').hide();
                $('#AgScheduleDate').hide();
                $('#AgDueDate').hide();
                $('#AgComplaintDueDate').show();
            }
            else {
                $('#hdnAgReqRejReferReferralfollowupdate').val($('#chkAgActivity_' + referalId).data('followupdate'));
                $('#divRequestRejectReferMember').CMNPopup({ popUpHeader: "Refer Activity", closeButton: '#btnCloseRRejAGComplaintRefer' })
                $('#lblRRejAGComplaintReferDueDate').hide();
                $('#lblRRejAGComplaintReferActivityFollowUpDate').show();
                $('#lblRRejAGComplaintReferActivityDueDate').show();
                $('#AgScheduleDate').show();
                $('#AgDueDate').show();
                $('#AgComplaintDueDate').hide();
            }
            var CompType = $('#chkAgActivity_' + referalId).data('complainttype');

            $('#selectIsConfidetialRequestRejectReferMember').val('Yes');
            $('divRequestRejectReferMember textarea').val('');
            $('#tblRequestRejectReferMember').hide();
            $('#tblReqRejReferUmAuth').hide();
            $('#tblReqRejReferAGComplaint').show();
            $('#hdnReqRejReferPatientId').val($('#chkAgActivity_' + referalId).data('patientid'));
            $('#hdnUmAuthReqRejReferActionDetailsId').val($('#chkAgActivity_' + referalId).data('actiondetailsid'));
            $('#lblRRejAGComplaintReferPName').text($.fn.replaceAndUnEscapeHtmlExt($('#chkAgActivity_' + referalId).data('patientname')));
            $('#lblRRejAGComplaintReferComplaintId').text($('#chkAgActivity_' + referalId).data('complaintrecordno'));
            $('#hdnAgComplaintReqRejReferComplaintRecId').val($('#chkAgActivity_' + referalId).data('complaintid'));
            $("#hdnAgReqRejActCompId").val($('#chkAgActivity_' + referalId).data('complaintid'));
            $('#lblRRejAGComplaintReferComplaintType').text($.fn.replaceAndUnEscapeHtmlExt(CompType));
            $('#lblRRejAGComplaintReferRefType').text($('#selectRequestReceivedReferType').data("kendoDropDownList").text());
            $('#lblRRejAGComplaintReferReferedBy').text($.fn.replaceAndUnEscapeHtmlExt($('#chkAgActivity_' + referalId).data('referredbyname')));
            $('#lblRRejAGComplaintReferEpisodeName').text($.fn.replaceAndUnEscapeHtmlExt($('#chkAgActivity_' + referalId).data('episodename')));
            $('#lblRRejAGComplaintReferActivityFollowUpDate').text($.fn.apply12To24hrFormat($('#chkAgActivity_' + referalId).data('followupdate')));
            $('#lblRRejAGComplaintReferActivityDueDate').text($.fn.apply12To24hrFormat($('#chkAgActivity_' + referalId).data('activityduedate')));
            $('#lblRRejAGComplaintReferDueDate').text($.fn.apply12To24hrFormat(ToValue($('#chkAgActivity_' + referalId).data('complaintduedate'),"N/A")));
            $('#chkRRAGGroupActivity').prop('checked', false);
            $('#trAGCareStaff').show();
            $('#trRRAGWQDepartment').hide();
            $('#trRRAGWQCareStaffBydept').hide();
            var actionDetailsId = ($('#hdnUmAuthReqRejReferActionDetailsId').val() || "");
            loadDropDown(baseURL + '/Complaint/BindComplaintAssignedTo?ComplaintType=' + CompType + '&ComplaintId=' + $('#chkAgActivity_' + referalId).data('complaintid') + '&ModuleName=AG&ActionDetailsId=' + actionDetailsId, 'selectRRejAGComplaintReferReferTo', null, null, 'CareStaffId', 'CareStaffName');

            $('#chkRRAGGroupActivity').click(function () {
                if ($('#chkRRAGGroupActivity').is(':checked')) {
                    $('#trAGCareStaff').hide();
                    $('#trRRAGWQDepartment').show();
                    $('#trRRAGWQCareStaffBydept').show();
                    CreateDropCheck('ddlRRAGDepartment', baseURL + '/Master/BindWorkQueues/', 'ddlRRAGDepartmentId', null, null, null, isWorkQueueSingle, 'DepartmentName', 'DepartmentId');
                    CreateDropCheck('ddlRRAGStaffIds', baseURL + '/Complaint/GetAGStaffIds?ComplaintId=' + $('#chkAgActivity_' + referalId).data('complaintid') + '&ModuleName=AG', 'ddlRRAGStaffIdsId', null, null, null, null, 'CareStaffName', 'CareStaffId');
                }
                else {
                    $('#trAGCareStaff').show();
                    $('#trRRAGWQDepartment').hide();
                    $('#trRRAGWQCareStaffBydept').hide();
                }
            });

            $(document).off('click', '#ddlRRAGDepartmentId,#ddlRRAGDepartmentIdspn').on('click', '#ddlRRAGDepartmentId,#ddlRRAGDepartmentIdspn', function () {
                var value = "";
                var eleid = this.id.replace('spn', '');
                var chkboxes = $("#" + eleid + "chk").find('input[type=' + ReturnWorkQueueControlType() + ']:checked');
                for (var i = 0; i < chkboxes.length; i++) {
                    value += chkboxes[i].defaultValue + ",";
                }
                value = value.substring(0, value.length - 1);
                var actionDetailsId = ($('#hdnUmAuthReqRejReferActionDetailsId').val() || "");
                let configObj = {
                    url: baseURL + '/Complaint/GetAGStaffIds?WQDeptId=' + value + '&IsWorkQueue=1&ComplaintId=' + $('#chkAgActivity_' + referalId).data('complaintid') + '&ModuleName=AG&ActionDetailsId=' + actionDetailsId,
                    ddlId: 'ddlRRAGStaffIdsId',
                    tbId: 0,
                    isCheckAll: true,
                    textField: 'CareStaffName',
                    textValue: 'CareStaffId'
                };
                A11yDropcheck.createDropcheck('ddlRRAGStaffIds', configObj);
            });
        }
        else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 2) {
            var patientFollowupId = $('#chkMember_' + referalId).data('patientfollowupid');
            EditMSActivityFrmActivityLog(patientFollowupId, 1);
        }
        $('.ContextChkMenu').hide();
    }
});


$(document).off('click', '.divClsMemberMenuDelete').on('click', '.divClsMemberMenuDelete', function () {
    if (!isMAL) {
        var flag1 = CustomConfirm("Are you sure want to delete this item?");
        if (flag1) {
            var id = getReferalId('ReqRejGrid');
            var url = "";
            // if ($('#selectRequestReceivedModule').val() == 3)//Converting Kendo DropDown
            if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 3)//Converting Kendo DropDown
            {
                //To Implement UM Activity Delete functionality
                if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Activity") {
                    url = baseURL + "/Activity/RequestRejectUMActivityDelete?activityLogID=" + $('#chkUMActivity_' + id).data('logid') + "&queueID=" + $('#chkUMActivity_' + id).data('queueid') + "&patientId=" + $('#chkUMActivity_' + id).data('patientid');
                }
                else {
                    var requestRejectRecordPatientId = $('#chkMember_' + id).data('patientid');
                    url = baseURL + "/Authorization/RequestRejectUMAuthDelete?rejectReferalId=" + id + "&patientId=" + requestRejectRecordPatientId;
                }
            }
            // else if ($('#selectRequestReceivedModule').val() == 1)//Converting Kendo DropDown
            else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 1)//Converting Kendo DropDown
            {
                var patientId = $('#chkMember_' + id).data('patientid');
                url = baseURL + "/RequestRejectedDashboard/RequestRejectDelete?rejectReferalId=" + id + "&patientId=" + patientId;
            }
            // else if ($('#selectRequestReceivedModule').val() == 5)//Converting Kendo DropDown
            else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 5)//Converting Kendo DropDown
            {
                var patientId = $('#chkAgActivity_' + id).data('patientid');
                url = baseURL + "/Dashboard/RequestRejectAGComplaintDelete?rejectReferalId=" + id + "&patientId=" + patientId;
            }
            else if ($('#selectRequestReceivedModule').data("kendoDropDownList").value() == 2)//Converting Kendo DropDown
            {
                var patientFollowupId = $('#chkMember_' + id).data('patientfollowupid');
                url = baseURL + "/Activity/DeleteMsRequestRejectedActivity?rejectReferalId=" + patientFollowupId + "&patientId=" + $('#chkMember_' + id).data('patientid');
            }
            if ($('#chkMember_' + id).data('type') == "External") {
                loader(1);
                url = baseURL + "/ActivityRecord/DeleteExtGeneralActivity?ProviderFollowupId=" + $('#chkMember_' + id).data('patientfollowupid') + '&PatientId=' + $('#chkMember_' + id).data('patientid');
                $.ajax({
                    type: "POST",
                    url: url,
                    dataType: "json",
                    success: function (data) {
                        loader(0);
                        if (data.success) {
                            $('#btnRequestReceivedSearch').trigger('click');
                        }
                    },
                    error: function () {
                        loader(0);
                    }
                });
            } else {
                $.ajax({
                    type: "GET",
                    url: url,
                    dataType: "json",
                    success: function (data) {
                        if (data.success) {
                            $('#btnRequestReceivedSearch').trigger('click');
                        }
                    }
                });
            }
        }
        else {
            $('.clsRejectedChkMember').prop('checked', false);
        }
        $('.ContextChkMenu').hide();
    }
    //  FillRequestCount();
});

$(document).off('click', '.divClsAppointmentMenuAcknowledge').on('click', '.divClsAppointmentMenuAcknowledge', function () {
    if (!isMAL) {
        $('#btnReqRejAck').trigger('click');
    } else {
        $('#btnReqRejAckRRjMAL').trigger('click');
    }
});
$(document).off('click', '.divClsMemberMenuRejectView').on('click', '.divClsMemberMenuRejectView', function () {
    var type = $('input[type="checkbox"]:checked.clsRejectedChkMember');
    if (!isMAL) {
        var referalId = getReferalId('ReqRejGrid');
        var authId;
        var patId;
        requestModuleNameGlobal = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
        if (requestReferTypeGlobal == "Activity" || requestReferTypeGlobal == "Member") {
            var patientFollowupId = $('#chkMember_' + referalId).data('patientfollowupid');
            var patientId = $('#chkMember_' + referalId).data('patientid');
            var input = {};
            requestModuleNameGlobal = moduleTypeCm;
            if (requestReferTypeGlobal == "Activity") {
                getURL = baseURL + "/RequestReceivedDashboard/RequestReceviedShowActivityDetails";
                input = {
                    'patientFollowupId': patientFollowupId,
                    'module': requestModuleNameGlobal,
                    'type': $(type[0]).data('type'),
                    'timeDictionaryObj': timeZone,
                    'patientid': patientId
                }
            }
            else if (requestReferTypeGlobal == "Member") {
                getURL = baseURL + "/RequestReceivedDashboard/RequestReceviedShowMemberDetails";
                input = {
                    'referenceId': referalId,
                    'module': requestModuleNameGlobal,
                    'timeDictionaryObj': timeZone,
                    'patientid': patientId
                }
            }

            $.ajax({
                type: "GET",
                url: getURL,
                data: input,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        if (data.activityDtls)
                            det = data.activityDtls
                        else if (data.memberDtls)
                            det = data.memberDtls
                        $('divRequestRejectViewPopup textarea').val('');
                        $('#tblRRejectActivityDetails').show();

                        $("#divReqRejectViewPopUp").css("height", "250px");
                        $('#trRRejectQM,#trRRejectQMStatus,#trRRejectQMIdentifiedDate').hide();
                        $('#lblRRejectQM,#lblRRejectQMStatus').text('');
                        $('#tblReqRejViewUmAuth').hide();
                        $('#tblReqRejViewAgActivity').hide();
                        $('#tblReqRejViewAgComp').hide();
                        $('#lblRRejectReferBy').text(det.AssignedBy && det.AssignedBy != 'null' ? det.AssignedBy : 'N/A');
                        $('#lblRRejectReassignedBy').text(det.ReassignedBy && det.ReassignedBy != 'null' ? det.ReassignedBy : 'N/A');
                        $('#lblRRejectMemberName').text(det.PatientFullName && det.PatientFullName != 'null' ? det.PatientFullName : 'N/A');
                        $('#lblRRejectScheduledDateTime').text(det.FollowupDateString && det.FollowupDateString !== 'null' ? $.fn.apply12To24hrFormat(det.FollowupDateString) : 'N/A');
                        $('#lblRRejectActivityNotes').AhsSetHtml(det.Comments && det.Comments !== 'null' ? $.fn.replaceAndEscapeHtmlExt(det.Comments) : 'N/A');
                        $('#lblRRejectHealthCoach').text(det.AssignedTo && det.AssignedTo != 'null' ? det.AssignedTo : 'N/A');
                        if (requestReferTypeGlobal == "Member") {
                            $('#divRequestRejectViewPopup').CMNPopup({
                                popUpHeader: "Member Details",
                                onClose: function () {
                                    $('#divRequestRejectViewPopup .lightGrey').removeClass('lightGrey');
                                }
                            });
                            $('#lblRRejectHealthCoach').text(det.HealthCoach && det.HealthCoach != 'null' ? det.HealthCoach : 'N/A');
                            $('#lblRRejectReferByToggle').text("Refer By");
                            $('#lblRRejectReassignedBy').closest('tr').hide();
                            $('#lblRRejectPriority').closest('tr').hide();
                            $('#lblRRejectScriptName').closest('tr').hide();
                            $('#lblRRejectStatus').closest('tr').hide();
                            $('#lblRRejectActivityType').closest('tr').hide()
                            $('#lblRejReaForRej').AhsSetHtml(det.RejectionComments && det.RejectionComments !== 'null' ? $.fn.replaceAndEscapeHtmlExt(det.RejectionComments) : 'N/A').closest('tr').show();
                        }
                        else {
                            $('#divRequestRejectViewPopup').CMNPopup({
                                popUpHeader: "Activity Details",
                                onClose: function () {
                                    $('#divRequestRejectViewPopup .lightGrey').removeClass('lightGrey');
                                }
                            });
                            $('#lblRRejectReferByToggle').text("Assigned By");
                            $('#lblRRejectReassignedBy').closest('tr').show();
                            $('#lblRRejectPriority').text(det.Priority && det.Priority != 'null' ? det.Priority : 'N/A').closest('tr').show();
                            $('#lblRRejectScriptName').text(det.ScriptName && det.ScriptName != 'null' ? det.ScriptName : 'N/A').closest('tr').show();
                            $('#lblRRejectActivityType').text(det.CareActivityTypeName && det.CareActivityTypeName != 'null' ? det.CareActivityTypeName : 'N/A').closest('tr').show();
                            $('#lblRRejectStatus').text(det.Venue && det.Venue != 'null' ? det.Venue : 'N/A').closest('tr').show();
                            $('#lblRejReaForRej').AhsSetHtml(det.RiskCategoryName && det.RiskCategoryName !== 'null' ? $.fn.replaceAndEscapeHtmlExt(det.RiskCategoryName) : 'N/A').closest('tr').show();
                            if (det.IsQmActivity) {
                                $("#divReqRejectViewPopUp").css("height", "270px");
                                $('#trRRejectQM,#trRRejectQMStatus').show();
                                $('#lblRRejectQM').text(det.QualityMeasureName == null || det.QualityMeasureName == '' || det.QualityMeasureName == 'null' ? 'N/A' : det.QualityMeasureName);
                                $('#lblRRejectQMStatus').text(det.QualityMeasureStatus == null || det.QualityMeasureStatus == '' || det.QualityMeasureStatus == 'null' ? 'N/A' : det.QualityMeasureStatus);
                                if (data.activityDtls.IdentifiedDateString !== null && data.activityDtls.IdentifiedDateString !== '' && data.activityDtls.IdentifiedDateString !== 'null') {
                                    $('#trRRejectQMIdentifiedDate').show();
                                    $('#lblRRejectQMIdentifiedDate').text(data.activityDtls.IdentifiedDateString);
                                }
                            }

                        }

                        gridNotAvailableCustomColor('divRequestRejectViewPopup', null, null, true);
                    }
                    else
                        CustomAlert(data.msg);
                }
            });
        }
        else if (requestReferTypeGlobal == "UM Auth") {
            authId = $('#chkMember_' + referalId).data('authredirect').split('|')[3];
            patId = $('#chkMember_' + referalId).data('authredirect').split('|')[0];
            ViewAuth(authId, 1, false, patId);
        }
        else if (requestReferTypeGlobal == "UM Activity") {
            authId = $('#chkUMActivity_' + referalId).data('authredirect').split('|')[3];
            patId = $('#chkUMActivity_' + referalId).data('authredirect').split('|')[0];
            ViewAuth(authId, 1, false, patId);
        }
        else if (requestReferTypeGlobal == "AG Complaint") {
            $('#divRequestRejectViewPopup').CMNPopup({ popUpHeader: "AG Complaint Details" });
            $('divRequestRejectViewPopup textarea').val('');
            $('#tblRRejectActivityDetails').hide();
            $('#tblReqRejViewUmAuth').hide();
            $('#tblReqRejViewAgActivity').hide();
            $('#tblReqRejViewAgComp').show();
            $('#lblRRejAgCompPName').text($('#chkAgActivity_' + referalId).data('patientname') === '' || $('#chkAgActivity_' + referalId).data('patientname') === 'null' ? 'N/A' : $.fn.replaceAndUnEscapeHtmlExt($('#chkAgActivity_' + referalId).data('patientname')));
            $('#lblRRejAgCompComplainthId').text($('#chkAgActivity_' + referalId).data('complaintrecordno') == '' || $('#chkAgActivity_' + referalId).data('complaintrecordno') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('complaintrecordno'));
            $('#lblRRejAgCompComplaintType').text($('#chkAgActivity_' + referalId).data('complainttype') === '' || $('#chkAgActivity_' + referalId).data('complainttype') === 'null' ? 'N/A' : $.fn.unEscapeHtmlExt($('#chkAgActivity_' + referalId).data('complainttype')));
            $('#lblRRejAgCompRefType').text($('#chkAgActivity_' + referalId).data('refertype') == '' || $('#chkAgActivity_' + referalId).data('refertype') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('refertype'));
            $('#lblRRejAgCompRefReqDate').text($('#chkAgActivity_' + referalId).data('rejectiondate') == '' || $('#chkAgActivity_' + referalId).data('rejectiondate') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('rejectiondate'));
            $('#lblRRejAgCompRejectedBy').text($('#chkAgActivity_' + referalId).data('referredtoname') === '' || $('#chkAgActivity_' + referalId).data('referredtoname') === 'null' ? 'N/A' : $.fn.replaceAndUnEscapeHtmlExt($('#chkAgActivity_' + referalId).data('referredtoname')));
            $('#lblRRejAgCompStatus').text($('#chkAgActivity_' + referalId).data('status') == '' || $('#chkAgActivity_' + referalId).data('status') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('status'));
            $('#lblRRejAgCompResonforRejection').AhsSetHtml($('#chkAgActivity_' + referalId).data('reasonforrejection') === '' || $('#chkAgActivity_' + referalId).data('reasonforrejection') === 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('reasonforrejection'));
            $('#lblRRejAgCompEpisodeName').text($('#chkAgActivity_' + referalId).data('episodename') == '' || $('#chkAgActivity_' + referalId).data('episodename') == null ? 'N/A' : $('#chkAgActivity_' + referalId).data('episodename'));
            $('#lblRRejAgCompLevel').text($('#chkAgActivity_' + referalId).data('levelid') == '' || $('#chkAgActivity_' + referalId).data('levelid') == null ? 'N/A' : $('#chkAgActivity_' + referalId).data('levelid'));
        }
        else if (requestReferTypeGlobal == "AG Activity") {
            $('#divRequestRejectViewPopup').CMNPopup({ popUpHeader: "AG Activity Details" });
            $('divRequestRejectViewPopup textarea').val('');
            $('#tblRRejectActivityDetails').hide();
            $('#tblReqRejViewUmAuth').hide();
            $('#tblReqRejViewAgComp').hide();
            $('#tblReqRejViewAgActivity').show();
            $('#lblRRejAgActivityPName').text($('#chkAgActivity_' + referalId).data('patientname') == '' || $('#chkAgActivity_' + referalId).data('patientname') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('patientname'));
            $('#lblRRejAgActivityComplainthId').text($('#chkAgActivity_' + referalId).data('complaintrecordno') == '' || $('#chkAgActivity_' + referalId).data('complaintrecordno') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('complaintrecordno'));
            $('#lblRRejAgActivityComplaintType').text($('#chkAgActivity_' + referalId).data('complainttype') == '' || $('#chkAgActivity_' + referalId).data('complainttype') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('complainttype'));
            $('#lblRRejAgActivityActivityType').text($('#chkAgActivity_' + referalId).data('actiontype') == '' || $('#chkAgActivity_' + referalId).data('actiontype') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('actiontype'));
            $('#lblRRejAgActivityRefType').text($('#chkAgActivity_' + referalId).data('refertype') == '' || $('#chkAgActivity_' + referalId).data('refertype') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('refertype'));
            $('#lblRRejAgActivityRefReqDate').text($('#chkAgActivity_' + referalId).data('referralreqdate') == '' || $('#chkAgActivity_' + referalId).data('referralreqdate') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('referralreqdate'));
            $('#lblRRejAgActivityRejectedBy').text($('#chkAgActivity_' + referalId).data('referredtoname') == '' || $('#chkAgActivity_' + referalId).data('referredtoname') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('referredtoname'));
            $('#lblRRejAgActivityStatus').text($('#chkAgActivity_' + referalId).data('status') == '' || $('#chkAgActivity_' + referalId).data('status') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('status'));
            $('#lblRRejAgActivityResonforRejection').text($('#chkAgActivity_' + referalId).data('reasonforrejection') == '' || $('#chkAgActivity_' + referalId).data('reasonforrejection') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('reasonforrejection'));
            $('#lblRRejAgActivityMandatory').text($('#chkAgActivity_' + referalId).data('mandatory') == '' || $('#chkAgActivity_' + referalId).data('mandatory') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('mandatory'));
            $('#lblRRejAgActivityLevel').text($('#chkAgActivity_' + referalId).data('levelid') == '' || $('#chkAgActivity_' + referalId).data('levelid') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('levelid'));
            $('#lblRRejAgActivityLevel').text($('#chkAgActivity_' + referalId).data('levelid') == '' || $('#chkAgActivity_' + referalId).data('levelid') == 'null' ? 'N/A' : $('#chkAgActivity_' + referalId).data('levelid'));
        }
        else if (requestReferTypeGlobal == "MS Activity") {
            ViewMSActivityFrmActivityLog(referalId, true);
        }
        $('.ContextChkMenu').hide();
    }
});
$(document).off('click', '.requestRejAuthRedirect').on('click', '.requestRejAuthRedirect', function () {
    var lstAuthRedVals = $(this).data('authredirect').split('|');
    SetAuthDatanew(lstAuthRedVals[0], lstAuthRedVals[1], lstAuthRedVals[2], lstAuthRedVals[3], lstAuthRedVals[4], lstAuthRedVals[6]);
    //parent.top.$('#btnAfterAcceptUMAuth').attr('data-arguments', $(this).data('authredirect'));
    //parent.top.$('#btnAfterAcceptUMAuth').trigger('click');
});

$(document).off('click', '.clsUndoGraph, .member-filter-clear').on('click', '.clsUndoGraph, .member-filter-clear', function () {

    var gphType = $(this).attr('id').split('_')[0];
    var gphId = $(this).attr('id').split('_')[1];
    var gphKey = $(this).data('keyvalue');
    var gphTxt = $(this).prev().text();
    if (gphType == 'Alert') {
        globalAlertFilter = (jQuery.grep(GetUnique(globalAlertFilter.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globalAlertFilterText = (jQuery.grep(GetUnique(globalAlertFilterText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Alert_' + gphId).hide().prev().hide();
    } else if (gphType == 'Disease') {
        globalDiseaseFilter = (jQuery.grep(GetUnique(globalDiseaseFilter.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globalDiseaseFilterText = (jQuery.grep(GetUnique(globalDiseaseFilterText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Disease_' + gphId).hide().prev().hide();
    } else if (gphType == 'Indicators') {
        globalindcatros = (jQuery.grep(GetUnique(globalindcatros.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globalIndicatorsText = (jQuery.grep(GetUnique(globalIndicatorsText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Indicators_' + gphId).hide().prev().hide();
    } else if (gphType == 'Risk') {
        globalRiskFilter = (jQuery.grep(GetUnique(globalRiskFilter.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globalRiskFilterText = (jQuery.grep(GetUnique(globalRiskFilterText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Risk_' + gphId).hide().prev().hide();
    } else if (gphType == 'Programs') {
        globalprograms = (jQuery.grep(GetUnique(globalprograms.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globalprogramsText = (jQuery.grep(GetUnique(globalprogramsText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Programs_' + gphId).hide().prev().hide();
    } else if (gphType == 'Opportunities') {
        globaloppertunities = (jQuery.grep(GetUnique(globaloppertunities.toString().split(',')), function (n, i) { return (n != gphId); })).join(",");
        globaloppertunitiesText = (jQuery.grep(GetUnique(globaloppertunitiesText.toString().split(',')), function (n, i) { return (n != gphTxt); })).join(",");
        $('#Opportunities_' + gphId).hide().prev().hide();
    } else if (gphType == 'Denom') {
        globalQIndicatorFilterDenom = (jQuery.grep((globalQIndicatorFilterDenom.toString().split(',')), function (n, i) { return (i != gphKey); })).join(",");
        globalQIndicatorFilterDNum = (jQuery.grep((globalQIndicatorFilterDNum.toString().split(',')), function (n, i) { return (i != gphKey); })).join(",");
        globalQIndicatorFilterTextDenom = (jQuery.grep((globalQIndicatorFilterTextDenom.toString().split(',')), function (n, i) { return (i != gphKey); })).join(",");
        $('#Denom_' + gphId).hide().prev().hide();
    } else if (gphType == 'Num') {
        globalQIndicatorFilterNum = (jQuery.grep((globalQIndicatorFilterNum.toString().split(',')), function (n, i) { return (i != gphKey); })).join(",");
        globalQIndicatorFilterTextNum = (jQuery.grep((globalQIndicatorFilterTextNum.toString().split(',')), function (n, i) { return (i != gphKey); })).join(",");
        $('#Num_' + gphId).hide().prev().hide();
    }

    myMembersFilterTooltip.refreshTooltipContent();

    $('#btnMyMemCpRfrs,#btnMyMemRfsh,#btnMyAlrtRfsh,#btnResetMyMember').trigger('click');
    if (globalAlertFilter == "" && globalDiseaseFilter == "" && globalindcatros == "" && globalRiskFilter == "") {

        $('#resetMymembersGrid').hide();
    }
});

$(document).ready(function () {
    $('#decfont').removeClass('fontSizeDec').addClass('fontSizeDecDisabled');
    $('#incfont').click(function () {
        //For MVC Pages
        curSize = parseInt($('#bodyContent').css('font-size')) + 1;
        if (curSize <= 14) {
            $('#bodyContent').css('font-size', curSize);
            $('#decfont').removeClass('fontSizeDecDisabled').addClass('fontSizeDec');
        }
        if (curSize == 14)
            $(this).removeClass('fontSizeInc').addClass('fontSizeIncDisabled');
        //For pages in IFrame
        var iframeCurSize = parseInt($('iframe').contents().find('body').css('font-size')) + 1;
        if (iframeCurSize <= 14) {
            $('iframe').contents().find('body').css('font-size', curSize);
            $('#decfont').removeClass('fontSizeDecDisabled').addClass('fontSizeDec');
        }
        if (iframeCurSize == 14)
            $(this).removeClass('fontSizeInc').addClass('fontSizeIncDisabled');
    });
    $('#decfont').click(function () {
        //For MVC Pages
        curSize = parseInt($('#bodyContent').css('font-size')) - 1;
        if (curSize >= 12) {
            $('#bodyContent').css('font-size', curSize);
            $('#incfont').removeClass('fontSizeIncDisabled').addClass('fontSizeInc');
        }
        if (curSize == 12)
            $(this).removeClass('fontSizeDec').addClass('fontSizeDecDisabled');
        //For pages in IFrame
        var iframeCurSize = parseInt($('iframe').contents().find('body').css('font-size')) + 1;
        if (iframeCurSize >= 12) {
            $('iframe').contents().find('body').css('font-size', curSize);
            $('#incfont').removeClass('fontSizeIncDisabled').addClass('fontSizeInc');
        }
        if (iframeCurSize == 12)
            $(this).removeClass('fontSizeDec').addClass('fontSizeDecDisabled');

    });

});

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

(function ($) {
    "use strict";

    $.extend({
        placeholder: {
            settings: {
                focusClass: 'placeholderFocus',
                activeClass: 'placeholder',
                overrideSupport: false,
                preventRefreshIssues: true
            }
        }

    });

    // check browser support for placeholder
    $.support.placeholder = 'placeholder' in document.createElement('input');

    // Replace the val function to never return placeholders
    $.fn.plVal = $.fn.val;
    $.fn.val = function (value) {
        if (typeof value === 'undefined') {
            return $.fn.plVal.call(this);
        } else {
            var el = $(this[0]);
            var currentValue = el.plVal();
            var returnValue = $(this).plVal(value);
            if (el.hasClass($.placeholder.settings.activeClass) && currentValue === el.attr('placeholder')) {
                el.removeClass($.placeholder.settings.activeClass);
                return returnValue;
            }
            if (el.hasClass($.placeholder.settings.activeClass) && el.plVal() === el.attr('placeholder')) {
                return '';
            }
            if (el[0]?.type === "select-one" && el.find("option:selected").length === 0) {
                return el.prop("selectedIndex", 0);
            }
            return $.fn.plVal.call(this, value);
        }
    };

    // Clear placeholder values upon page reload
    $(window).bind('beforeunload.placeholder', function () {
        var els = $('input.' + $.placeholder.settings.activeClass);
        if (els.length > 0) {
            els.val('').attr('autocomplete', 'off');
        }
    });


    // plugin code
    $.fn.placeholder = function (opts) {
        opts = $.extend({}, $.placeholder.settings, opts);

        // we don't have to do anything if the browser supports placeholder
        if (!opts.overrideSupport && $.support.placeholder) {
            return this;
        }

        return this.each(function () {
            var $el = $(this);

            // skip if we do not have the placeholder attribute
            if (!$el.is('[placeholder]')) {
                return;
            }

            // we cannot do password fields, but supported browsers can
            if ($el.is(':password')) {
                return;
            }

            // Prevent values from being reapplied on refresh
            if (opts.preventRefreshIssues) {
                $el.attr('autocomplete', 'off');
            }

            $el.bind('focus.placeholder', function () {
                var $el = $(this);
                if (this.value === $el.attr('placeholder') && $el.hasClass(opts.activeClass)) {
                    $el.val('').removeClass(opts.activeClass).addClass(opts.focusClass);
                }
            });

            $el.bind('blur.placeholder', function () {
                var $el = $(this);

                $el.removeClass(opts.focusClass);

                if (this.value === '') {
                    $el.val($el.attr('placeholder')).addClass(opts.activeClass);
                }
            });

            $el.triggerHandler('blur');

            // Prevent incorrect form values being posted
            $(document).off('click', $el.parents('body').find('input[type="button"]')).on('click', $el.parents('body').find('input[type="button"]'), function () {
                $el.triggerHandler('focus.placeholder');
            });

        });
    };
}(jQuery));

$(document).off('change', '#ddlCareTeamProv').on('change', '#ddlCareTeamProv', function () {
    var physicianId = $('#ddlCareTeamProv').val();
    if (physicianId > 0)
        FunFetchCareProviderDetails(physicianId)
    if ($('#ddlCareTeamProv option:selected').text() == ' Select ') {
        ClearAddAppointment();
    }
});

$("body").off("click", ".MSEdit").on("click", ".MSEdit", function () {
    var patientFollowUpId = $(this).attr('id').split('_')[1];
    // var activityLogId = $('#btnMSEdit_' + patientFollowUpId).data('activitylogid');
    EditMSActivityFrmActivityLog(patientFollowUpId);
});
$(document).off('click', '#btnAcceptUMRequestReceivedAcceptComments').on('click', '#btnAcceptUMRequestReceivedAcceptComments', function () {    
    var msgcount1 = 0;
    $('span.validationMessage').remove();
    var duedateValidated = false;
    var activityLogID = "";
    $(".UMAcceptCommentsFolloUpdate .k-input").each(function (index, element) {
        var endDateStr2 = $(element).val();
        endDateStr2 = endDateStr2.split(' ')[0];
        var endDate2 = new Date(endDateStr2);
        var endYear2 = endDate2.getFullYear();
        var d2 = new Date();
        var n2 = d2.getFullYear();
        var dueDate = $(element).attr('data-DueDate');
        var endYear210 = n2 + 10;
        if (!date_regex.test(endDateStr2)) {
            $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>Enter valid Date in MM/DD/YYYY format</span>');
            msgcount1 = 1;
        }
        else {
            if (endYear2 > endYear210) {
                endYear210 += 1;
                $(this).closest('td').append('<span class="validationMessage" style="color:red"><br/>End Date should be less than year ' + endYear210 + '</span>');
                msgcount1 = 1;
            }
            else if (!duedateValidated && dueDate != "" && dueDate != "N/A") {
                var duedate1 = new Date(kendo.toString(kendo.parseDate(dueDate), "MM/dd/yyyy hh:mm tt"));
                var followupdate = new Date($(element).val());
                if (duedate1 < followupdate) {
                    duedateValidated = true;
                    var flag1 = CustomConfirm("Scheduled date is greater than due date, click Ok to continue");
                    if (!flag1)
                        msgcount1 = 1;
                }
            }
        }
    });

    if (msgcount1 == 0) {
        $('#btnAcceptUMRequestReceivedAcceptComments').prop('disabled', 'disabled');
        var listReferenceId = $('#hdnRequestReceivedAcceptCommentReferenceIds').val();
        var queueId = "";
        var listFollowupDates = "";       
            $.each(listReferenceId.substr(0, listReferenceId.length - 1).split(','), function (key, item) {
                var listFollowDates = $('#txtUMAcceptCommentsFolloUpdate_' + key).val();
                var activityID = $('#txtUMAcceptCommentsFolloUpdate_' + key).AhsGetAttr('data-ActLogId');
                if (typeof activityID !== 'undefined' && listFollowDates !== 'undefined') {
                    activityLogID += activityID + ",";
                    listFollowupDates += listFollowDates + ",";
                }
                queueId += $('#txtUMAcceptCommentsFolloUpdate_' + key).AhsGetAttr('data-QueueId') + ",";
            });
        var patientID = document.querySelector('input.UMAcceptCommentsFolloUpdate').getAttribute('data-patientid');
        var dataParams = { "activityLogID": activityLogID, "acceptComments": escapeHtml($('#txtareaUMRequestReceivedAcceptComments').val()).replace(/&#39;/g, "'"), "followupDate": listFollowupDates, "patientID": patientID, "queueID": queueId, "confidentialTypeId": $('#selectUMAHNIsConfidential').val(), "timeDictionaryobj": timeZone };

        $.ajax({
            type: "POST",
            url: baseURL + "/Home/CheckUMActivityDateTimeAvailability",
            data: dataParams,
            dataType: "json",
            async: false,
            success: function (data) {
                if (data != 0) {
                    $().ConfirmationBox({
                        Title: 'Accept Activity', Top: 180, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                        Content: "An activity is already scheduled for this time. Would you still prefer to accept this activity on this time?"
                    }, function (response) {
                        $("#ConfirmPopup_Div").hide();
                        if (response) AcceptUMActivity(dataParams);
                        else
                            $('#btnAcceptUMRequestReceivedAcceptComments').prop('disabled', '');
                    });
                } else AcceptUMActivity(dataParams);
            }
        });
    }
    var authId= $("#hdnAuthId").val();
    var patientId = $("#hdnPatientId").val();
    var activityId = $("#hdnActivityId").val();
    var parentactivityId = $("#hdnParentActivityId").val();
    var authredirect = $("#hdnauthredirect").val();
    var activitytypename = $("#hdnActivityTypeName").val();
    var IsPerform = $("#hdnIsPerform").val();
    if (isNewMdrReview && $('#btnAcceptUMRequestReceivedAcceptComments').val()==='Accept and Perform') {
        if (!$.fn.isNullOrEmpty(parentactivityId) && activitytypename.toLowerCase() === "additional information requested") {
            requestReceviedUmAIRActivity(authredirect, activityId, IsPerform);
        } else {
            ClickFireAuthId(authId, patientId, activityId);
        }
    }
});

$("body").off("click", ".MSRun").on("click", ".MSRun", function () {
    var patientFollowUpId = $(this).attr('id').split('_')[1];
    // var activityLogId = $('#btnMSRun_' + patientFollowUpId).data('activitylogid');
    var patientId = $(this).attr('data-patientid');
    CompleteMSActivityFrmActivityLog(patientFollowUpId, patientId);
});

$(document).off('click', '.clsPendingActivitiesComplete').on('click', '.clsPendingActivitiesComplete', function () {
    A11yAlerts.remove();
    var scriptId = $(this).attr('data-scriptid');
    var _patientFollowupId = $(this).attr('id').split('_')[1];
    var pardata = { scriptId: scriptId };
    $.ajax({
        url: baseURL + "/Assessment/GetActiveInactiveScriptDetails",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            if (data === "False") {
                pendingActivityComplete(_patientFollowupId);
            }
            else {
                showInactiveScriptValidation('#divscptActiveInfo', _patientFollowupId);
            }
        },
        error: function () { }
    });
});

$(document).off('click', '.clsWGMPendingActivitiesComplete').on('click', '.clsWGMPendingActivitiesComplete', function () {
    A11yAlerts.remove();
    var scriptId = $(this).attr('data-scriptid');
    var pardata = { patientVal: $(this).data('patientid') };
    var _patientFollowupId = $(this).attr('id').split('_')[1];
    var pardataspt = { scriptId: scriptId };
    $.ajax({
        url: baseURL + "/Assessment/GetActiveInactiveScriptDetails",
        type: "POST",
        datatype: "JSON",
        data: pardataspt,
        success: function (data) {
            if (data === "False") {
                $.ajax({
                    url: baseURL + "/Home/GetProfileConfigureToPatient",
                    type: "POST",
                    datatype: "JSON",
                    data: pardata,
                    success: function (data) {
                        if (data) {
                            pendingActivityComplete(_patientFollowupId);
                        }
                        else {
                            CustomAlert("You Can't Access this Patient");
                        }
                    },
                    error: function (err) {
                        console.log(err);
                    }
                });
            }
            else {
                showInactiveScriptValidation('#divWgmscptActiveInfo', _patientFollowupId);
            }
        },
        error: function () { }
    });

});

$(document).ready(function () {
    jQuery.ajaxSetup({ async: true, cache: false });
    if (typeof (pidforautmem) != 'undefined') { if (pidforautmem != "") { SetControlDisplay(3); } else { SetControlDisplay(1); } }
    //var ht = $(window).height(), htc = ht - 163;
    //$(".bodyht").css("min-height", "");
    //$(".bodyht").css("min-height", htc + "px");
    if (typeof (rolenameval) != 'undefined') {
        if (rolenameval == 'Super Admin' || rolenameval == 'Admin' || rolenameval == 'CO_Admin' || isOnlyCSModule) {
            $('#MemAccessDiv').hide(); $('#DivAddAuthorizationMenu').hide(); $('#divBre').hide(); $('#divalerts').hide();
            $('#memberSearchContainer').hide();
            $('.fResize').hide();
            if (isOnlyCSModule) {
                CallCshtmlCtrls("/ConfigHome/AHSConfigHome");
            }
            else
                CallCshtmlCtrls("/Admin/ManageCareStaff");
        }
    }
    $(document).off('mouseleave', '.dropcheck').on('mouseleave', '.dropcheck', function () {
        $(".dropcheck").hide();

    });
    //dropdowncls
    $(document).off('mouseleave', '.dropdowncls').on('mouseleave', '.dropdowncls', function () {
        $(".dropcheck").hide();
        if ($(this).attr('id') == 'ddlWLMLob') {
            if (isLOBChecked == true) {
                $('#ddlWLMProgramIdval').val("Loading...");
                $('#ddlWLMPlanIdval').val("Loading...");
                if ($('#ddlWLMLobIdhdn').val() == "")
                    $('#ddlWLMLobIdval').val("LOB");
                $("#ddlWLMPlanAC").val('');
                $("#ddlWLMPlanAC").attr('placeholder', 'Type and Select Plan Name');
                $('#hdnddlWLMPlanAC').val('');
                CreateDropCheck('ddlWLMProgram', baseURL + '/AssignCareStaff/GetBenProgramsByPlan?planIds=' + $('#hdnddlWLMPlanAC').val(), 'ddlWLMProgramId');
                $('#ddlWLMProgramIdval').val("Program");
                isPlanChecked = isLOBChecked = false;
            }
        }

        var riskTypeids = "";
        if ($(this).attr('id') === 'ddlFCMBRiskType' && isFCMBRiskTypeChecked === true) {
            riskTypeids = $('#ddlFCMBRiskTypeIdhdn').val();
            CreateDropCheck('ddlFCMBRiskLevel', baseURL + '/AssignCareStaff/BindRiskTypeRiskLevel?riskTypeIds=' + riskTypeids, 'ddlFCMBRiskLevelId', null, null, null,
                null, null, null, null, null, null, 'ddlFCMBRiskLevelInstr');
            isFCMBRiskTypeChecked = false;
        }

        if ($(this).attr('id') === 'ddlACSRiskType' && isACSRiskTypeChecked === true) {
            riskTypeids = $('#ddlACSRiskTypeIdhdn').val();
            CreateDropCheck('ddlACSRiskLevel', baseURL + '/AssignCareStaff/BindRiskTypeRiskLevel?riskTypeIds=' + riskTypeids, 'ddlACSRiskLevelId', null, null,
                null, null, null, null, null, null, null, 'ddlACSRiskLevelInstr');
            isACSRiskTypeChecked = false;
        }

        if ($(this).attr('id') === 'ddlKSRiskType' && isKSRiskTypeChecked === true) {
            riskTypeids = $('#ddlKSRiskTypeIdhdn').val();
            CreateDropCheck('ddlKSRiskLevel', baseURL + '/AssignCareStaff/BindRiskTypeRiskLevel?riskTypeIds=' + riskTypeids, 'ddlKSRiskLevelId', null, null);
            isKSRiskTypeChecked = false;
        }
    });



    //UM Edit Activity
    $(document).off('click', '#ddlDepartmentId').on('click', '#ddlDepartmentId', function () {
        let popupHeaders = [
            $.trim($('#portletHeadHand').text().toUpperCase()),
            $.trim($('#popUpDialog2 #portletHeadHand').text().toUpperCase())
        ];
        let toValidate = ["EDIT ACTIVITY", "RESCHEDULE ACTIVITY"];
        if (popupHeaders.some(text => toValidate.includes(text))) {
            let validationSuccess = checkWorkQueueByActivityType($(this));
            if (!validationSuccess) {
                return;
            }
        }
        var value = "";
        var eleid = this.id.replace('spn', '');
        var chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:checked');
        for (var i = 0; i < chkboxes.length; i++) {
            value += chkboxes[i].defaultValue + ",";
        }
        value = value.substring(0, value.length - 1);
        let configObj = {
            url: baseURL + '/CommonDefaultSessionState/GetStaffIdsNew?deptId=' + value,
            ddlId: 'ddlStaffIdsId',
            tbId: 0,
            isCheckAll: true
        };
        A11yDropcheck.createDropcheck('ddlStaffIds', configObj);
    });
    //11.AllConrolDocumentFunctions.js
    //Member Details add or Edit
    $(document).off('keydown', '.keydown').
        on('keydown', '.keydown', function (e) {
            AllowNumericsFunc(e);
        });

    $(document).off('keydown', '.RestrictSubSym').
        on('keydown', '.RestrictSubSym', function (e) {
            var key = e.keyCode;
            //189 for sub symbol
            if (((key == 189) || (key == 173))) {
                e.preventDefault();
            }
        });


    $(document).off('change', '#selectMymbembersteam').on('change', '#selectMymbembersteam', function () {
        clientPatientIdFromWellframe = "";
        globalCaseLoadFilter = $('#selectMymbembersteam').val();
        if ($('#memberGrid').val() == "") {
            DBMemberDetailsLoad(2, "panelLeft");
        }
        else {
            DBMemberDetailsLoad(1, "blockOne");
            LoadFilterCriteria();
        }
    });
    $(document).off('mouseover', '#ToolTipId').on('mouseover', '#ToolTipId', function () {
        var desc = $(this).data('details');
        if (desc == 'undefined' || desc == 'Undefined' || desc == '') {
            desc = 'N/A';
        }
        var pos1 = $(this).offset();
        var htmlstr = "<table border='0' cellpadding='0' cellspacing='0' style='width:200px; height:30px;'>";
        htmlstr += "<tr><td style='width: 25%; vertical-align: top; text-align: left;font-weight: bold;'><b>Readability Details</b> </br></br> Readability Level:" + desc + "</td></tr>";
        $('#divtooltip').html(htmlstr).show().css('left', (pos1.left) + "px").css('top', (pos1.top - ($('#divtooltip').height())) + "px").css('z-index', 20000);
    });
    $(document).off('mouseout', '#ToolTipId').on('mouseout', '#ToolTipId', function () {
        $('#divtooltip').hide();
    });
    $(document).off('mouseover', '.CrPlSrPlUpdatedByCls').on('mouseover', '.CrPlSrPlUpdatedByCls', function () {
        $(".CrPlSrPlUpdatedByCls").kendoTooltip({
            autoHide: true,
            position: "right",
            width: 150,

            show: function (e) {
                this.popup.wrapper.height("auto");

            }

        });
    });
});


$(document).mouseup(function (e) {
    var container = $("#memberInfoMenu").parent();

    if (!container.is(e.target)
        && container.has(e.target).length === 0) {
        container.find("#memberMenuItems").hide(300);
    }

});
$(document).ready(function () {
    $(document).off('click', '#btnMedicalInfoView').on('click', '#btnMedicalInfoView', function () {
        $("#View").hide();
        $("#Edit").show();
        //$("#View").css("display", "block");
        //$("#Edit").css("display", "none");
        $("#btnMedicalInfoView").css("display", "none");
        $("#btnMedicalInfoEdit").css("display", "block");
        $("#dvPartial").load(baseURL + "/Home/MemberAdditionalInformationView", function () { loader(0); });
    });
    $(document).off('click', '#btnMedicalInfoEdit').on('click', '#btnMedicalInfoEdit', function () {
        $("#View").hide();
        $("#Edit").show();
        //$("#View").css("display", "none");
        //$("#Edit").css("display", "block");
        $("#btnMedicalInfoView").css("display", "block");
        $("#btnMedicalInfoEdit").css("display", "none");
        $("#dvPartial").load(baseURL + "/Home/MemberAdditionalInformationEdit", function () { loader(0); });
    });

});

//Full Care Plan Grid Check box change event
$(document).off('change', '.clschkFullCarePlan').on('change', '.clschkFullCarePlan', function () {
    var chkditems = $(".clschkFullCarePlan:checked");
    var allChkBox = $('#GridFullCarePlan .clschkFullCarePlan');
    var careplanIds = [];
    var unChkdItems = $('#hdnFullCarePlanSelectedIds').val();
    if (unChkdItems != '' && unChkdItems != null && unChkdItems != 'undefined') {
        careplanIds.push(unChkdItems);
    }
    //$('#hdnFullCarePlanSelectedIds').val('');
    if (chkditems.length == 0) {
        //$('#hdnFullCarePlanSelectedIds').val('');
        $('#GridFullCarePlan .clschkFullCarePlanHead').prop('checked', false);
    }
    if ($(this).prop('checked')) {
        var hdncarePlanIds = unChkdItems.split(',');
        for (var i = 0; i < hdncarePlanIds.length; i++)
            if (hdncarePlanIds[i] === $(this).attr('data-cplids')) {
                hdncarePlanIds.splice(i, 1);
                careplanIds = [];
                careplanIds.push(hdncarePlanIds.join(','));
                break;
            }
    }
    else {
        careplanIds.push($(this).attr('data-cplids'));
    }

    //careplanIds = careplanIds.replace(/,(?=[^,]*$)/, '');
    if (allChkBox.length == chkditems.length) {
        $('#GridFullCarePlan .clschkFullCarePlanHead').prop('checked', true);
        //$('#hdnFullCarePlanSelectedIds').val('');
    } else {
        $('#GridFullCarePlan .clschkFullCarePlanHead').prop('checked', false);
    }
    $('#hdnFullCarePlanSelectedIds').val(careplanIds.join(','));

});

//uhg-2936
$('#selectSearch').change(function () {
    var regExprNumber = /^\d*$/;
    var searchType = getSelectedSearchType();

    $(document).off('keydown input', '#txtSearch').on('keydown input', '#txtSearch', function (e) {
        searchType = getSelectedSearchType();
        if (searchType === "DOCUMENT_ID" || searchType === "AUTH_DOCUMENT_ID") {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67 || e.keyCode == 88) && (e.ctrlKey === true || e.metaKey === true)) ||
                (e.keyCode >= 35 && e.keyCode <= 40)) {
                return;
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
                return false;
            }
            else if (!regExprNumber.test($("#txtSearch").val())) {
                $('#txtSearch').val("");
                return false;
            }
        }
    });

    if ((searchType === "DOCUMENT_ID" || searchType === "AUTH_DOCUMENT_ID") && !$.fn.isNullOrEmpty($('#txtSearch').val()) && !regExprNumber.test($("#txtSearch").val())) {
        $('#txtSearch').val("");
        return false;
    }
});


$(document).off('click', '#btnHispSearch').on('click', '#btnHispSearch', function () {
    if (ValidateFrom_ToDateSearch()) {
        $("#HISPSummGrid").data("kendoGrid").dataSource.page(1);       
    } else {
        return false;
    }
});
function ValidateFrom_ToDateSearch() {
    var isValid = true;
    isValid &= A11yForms.validateFormField('txtHISPSummaryFormDate', null, A11yForms.VALIDATIONS.DATE);
    isValid &= A11yForms.validateFormField('txtHISPSummaryToDate', null, A11yForms.VALIDATIONS.DATE);
    if (isValid && new Date($('#txtHISPSummaryFormDate').val()).getTime() > new Date($('#txtHISPSummaryToDate').val()).getTime()) {
        A11yForms.showFormFieldError('txtHISPSummaryToDate', 'To Date should be greater than From Date');
        isValid = false;
    }
    return isValid;
}

$(document).on('change', '#txtHISPSummaryFormDate,#txtHISPSummaryToDate', function () {
    ValidateFrom_ToDateSearch();
    updateMsgDetDefaultCheckbox();
});
$(document).off('click', '.clsChkHISP').on('click', '.clsChkHISP', function () {
    $('.divClsRefralMemberMenu').hide();
    var chkboxes = $('#HISPSummGrid').find('input[type="checkbox"]:checked.clsChkHISP');
    if (chkboxes.length == 1) {
        ShowHoverMenu('HISPSummGrid', 'divHISPMenu_', $(this).attr('Id'));
    }
    else {
        $('.ContextChkMenu').hide();
    }
});

$(document).off('click', '#divHISPMenuView_').on('click', '#divHISPMenuView_', function () {
    var selChkBx = $('#HISPSummGrid').find('input[type="checkbox"]:checked.clsChkHISP')[0];
    msgThdId = $(selChkBx).attr('Id').split('_')[1];
    //uhc-246
    var msgType = $(selChkBx).attr('data-SentType');
    var isEmail = $(selChkBx).attr('data-IsEmail');
    var isRead = $(selChkBx).attr('data-IsRead');
    var patientid = $('#selectPatientAccessed').val();
    if (msgType == "Fax" || msgType == "WORK QUEUE") {
        validateFaxFileNavigateToView(msgThdId, "View", true);
    }
    else if (isEmail === "true")
    {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/Home/CreateMessage?msgId=" + msgThdId + "&type=" + 1,
            modalWidth: MODAL_WIDTH.LARGE,
            onLoad: function () {
                A11yModal.trapFocusInModal('popUpDialog1');
            },
            popUpHeader: "Create Message",
            triggerBtnId: 'actionsMenuBtn',
            closeButton: '#btnCancelMsg',
            popLevel: 0
        });
    }
    else {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/Home/MsgResponse?threadId=" + msgThdId + "&isActive= 1" + "&patientId=" + patientid + "&isRead=" + isRead,
            onLoad: function () {
            },
            onClose: function () {
                $('#HISPSummGrid').data("kendoGrid").dataSource.read();
            },
            popUpHeader: "View Message",
            closeButton: '#btnCancelReply'
        });
    }
    $(selChkBx).prop('checked', false);
    $('.ContextChkMenu').hide();
});

$(document).off('click', '.HISPFiles').on('click', '.HISPFiles', function () {
    loader(1);
    $('#divHISPMenu_').hide();
    var id = $(this).attr("id").split("!");
    var messageId = id[1],
        attachmentPath = id[3],
        attachmentCount = id[4];
    if (attachmentCount == 1) {
        var res = attachmentPath.split(".");
        var len = res.length;
        var ext = res[len - 1];
        if (ext == 'xml') {
            $.ajax({
                type: "GET",
                async: true,
                url: baseURL + "/Common/AttachmentFilesGet?messageId=" + messageId,
                success: function (attachmentsData) {
                    var data = attachmentsData.Data[0];
                    $.ajax({
                        type: "GET",
                        async: true,
                        url: baseURL + "/download/tokenAsync?FileId=" + data.MpMemberMessageAttachmentsId + "&EntityType=CMMessageAttachment",
                        success: function (tokendata) {
                            $('#popUpDialog2').CMNPopup({
                                pvUrl: baseURL + "/Common/ShowCcdaFiles?gc-fd-token=" + tokendata.token + "&is_CCDA=" + true,
                                popUpHeader: "C-CDA File",
                                popLevel: 2
                            });
                        },
                        error: function () {
                            loader(0);
                        }
                    });
                },
                error: function () {
                    loader(0);
                }
            });
        }
        else {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Common/ShowMsgAttachments?messageId=" + messageId,
                popUpHeader: "Attachments",
                popLevel: 1
            });
        }
    }
    else {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/Common/ShowMsgAttachments?messageId=" + messageId,
            popUpHeader: "Attachments",
            popLevel: 1
        });
    }
    loader(0);
});

$(document).off('click', '#btnPatientAuthorizationSearch').on('click', '#btnPatientAuthorizationSearch', function () {
    $("#spnASSearchValue").hide();
    if ($("#ddlASSearchBy").val() == "" || ($("#ddlASSearchBy").val() != "" && $.trim($("#txtASSearchValue").val()) != "")) {
        $("#AuthSummary").data("kendoGrid").dataSource.page(1);
    }
    else { $("#spnASSearchValue").show(); }
});

$(document).off('change', '.txtCrPlAddModifAutoSPProvCls').on('change', '.txtCrPlAddModifAutoSPProvCls', function () {
    if ($(this).val().trim() == '') {
        var idControl = $(this).prop('id').split('_')[1];
        $('#hdnModifierAddCode_' + idControl).val('');
        $('#hdnModifierAddId_' + idControl).val('');
    }
});
$(document).off('change', '.txtCrPEditModifAutoSPProvCls').on('change', '.txtCrPEditModifAutoSPProvCls', function () {
    if ($(this).val().trim() == '') {
        var idControl = $(this).prop('id').split('_')[1];
        $('#hdnModifierEditId_' + idControl).val('');
        $('#hdnModifierEditCode_' + idControl).val('');
    }
});

$(document).off('change', '.clsChkCPSignOff').on('change', '.clsChkCPSignOff', function () {
    var $chk = $(this);
    var CrPlnId = [];
    var CatNameForSignOff = ($chk.data('catname') || '').toUpperCase();
    var dataStr = {};
    var $carePlanId = $chk.data('careplanid');
    CrPlnId.push($carePlanId);

    if (CrPlnId.length >= 1) {
        var patientId = $('#selectPatientAccessed').val();
        dataStr = { crPlIds: CrPlnId.join(","), catName: CatNameForSignOff, patientid: patientId };
        updateSignOffStatus(dataStr, CatNameForSignOff);
    }
});

function updateSignOffStatus(dataStr, $catName) {
    $.ajax({
        type: "POST",
        url: baseURL + "/CarePlan/SignOffCarePlan",
        dataType: "json",
        data: dataStr,
        success: function (data) {
            CmnStatusMessageDisp('crPlTmCrPlUpdStsMsg', data.msg, 'Success');
            var $gridId;
            if ($catName === 'UAS') {
                $gridId = "#UASScript";

            } else {
                var gridName = GetCRPLGrid($catName.trim());
                $gridId = ("#" + gridName);
            }
            gridRefresh($gridId);
        },
        error: function () {
            CmnStatusMessageDisp('crPlTmCrPlUpdStsMsg', data.msg, 'Error');
        }
    });
};

$(document).off('click', '#btnCrPlTmCrPlToggleSignOff').on('click', '#btnCrPlTmCrPlToggleSignOff', function () {
    var CrPlnId = [];

    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase().trim() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase().trim();
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;

    var CatNameForSignOff = '';
    if ($catName === 'SELECT')
        CatNameForSignOff = $(chkBxChd[0]).data('catname');
    else
        CatNameForSignOff = $catName;

    if (chkBxChd.length >= 1) {
        var Flg = CustomConfirm('Are you sure you want to' + (CatNameForSignOff.toUpperCase() === 'CURRENT' ? ' undo' : '') + ' sign off ?');
        if (Flg) {
            var $carePlanId;
            $.each(chkBxChd, function (key,item) {
                var $chk = $(item);
                $carePlanId = $chk.attr('Id').split('_')[1];
                CrPlnId.push($carePlanId);
            });
            if (CrPlnId.length >= 1) {
                var patientId = $('#selectPatientAccessed').val();
                var dataStr = { crPlIds: CrPlnId.join(","), catName: $catName, careStaffId: getMemberId().MemberId, patientid: patientId };
                updateSignOffStatus(dataStr, $catName);
            }
        }
        chkBxChd.attr('checked', false);
        $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
        $('.clsChkCrPlTmCrPlHead:checked').attr('checked', false);
    }
    else CustomAlert('Please select at least one record to sign off.');
});

$(document).off('click', '#btnCrPlTmCrPlMyCarePlan').on('click', '#btnCrPlTmCrPlMyCarePlan', function () {
    arrSignature = [];
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/CarePlan/FullCarePlan?patientid=" + $('#selectPatientAccessed').val(),
        popUpHeader: "Full Care Plan",
        popLevel: 2,
    });

    $('.ContextMenu').hide();
});


$(document).off('click', '#cpltmcrplnlnkbtngg').on('click', '#cpltmcrplnlnkbtngg', function () {

    var id = $(this).closest('tr').find('td:nth-child(2) input[type="checkbox"]').attr('id').split('_')[1];
    $('#hdnTmCrPlActHisId').val(id);
    $('#popUpDialog1').CMNPopup({
        popUpHeader: "Service GoalGroup",
        pvUrl: baseURL + "/CarePlan/ServiceGoalGroup",
        popLevel: 0
    });

});


$(document).off('click', '#btnCrPlTmCrPlVisibleEditCP').on('click', '#btnCrPlTmCrPlVisibleEditCP', function () {
    var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; $('.mtmTabSection').hide(); }
    var chkBxChd = chkChecked().checkBox;
    if (chkBxChd && chkBxChd.length > 0) {
        loader(1);
        try {
            globalTeamCPStatus = $('#selCrPlTmCrPlCat').val();
            $('#TeamCarePlanAddOrEditDiv').html('');
            var checkedId = $(chkBxChd[0]).attr('id').split('_')[1];
            var patientId = $('#selectPatientAccessed').val();
            if (checkedId !== undefined) {
                var checkedIds = [];
                checkedIds.push(checkedId);
                var ruleOgiEditObject = { eventSource: "CMOGIEDIT", moduleName: "CM", eventType: "PRE", carePlanIds: checkedIds };
                var ruleOgiEditResponse = ficoRealTimeValidation(ruleOgiEditObject);
                var isRuleHardValidation = CheckValidationMessages(ruleOgiEditResponse);
                if (isRuleHardValidation) {
                    loader(0);
                    return;
                }
                $('#TeamCarePlanAddOrEditDiv').load(baseURL + "/CarePlan/EditCarePlan?carePlanId=" + checkedId + "&mtmIntervention=" + isMtmIntervention + "&PatientId=" + patientId, function () {
                    $('#divCarePlanOverview').hide();
                    $('#TeamCarePlanAddOrEditDiv').show();
                    $('#TeamCarePlanChildDiv').show();
                    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
                    $('#popUpDialog1').find('#closePopUp').attr('id', 'closePopUp_1');
                    $('#popUpDialog1').find('#closePopUpUM').attr('id', 'closePopUp_1');
                    loader(0);
                });
            }
        } catch (e) {
            loader(0);
        }
    }

});


$(document).off('click', '#btnTmCrPlRRSignOff').on('click', '#btnTmCrPlRRSignOff', function () {
    if ($('#hdnCrPlTmCrPlHisCrPlId').val() > 1) {
        var dataStr = { crPlIds: $('#hdnCrPlTmCrPlHisCrPlId').val() };
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/SignOffCarePlan",
            dataType: "json",
            data: dataStr,
            success: function (data) {
                CmnStatusMessageDisp('crPlTmCrPlUpdStsMsg', data.msg, 'Success');
                var gridId;
                var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
                if ($catName != 'UAS') {
                    var gridName = GetCRPLGrid($catName.trim());
                    gridId = ("#" + gridName);
                }
                else {
                    gridId = ("#UASScript");
                }
                gridRefresh(gridId);

                $('#SignOffDtlsClose').trigger('click');

            },
            error: function (request, status, error) {
                CmnStatusMessageDisp('crPlTmCrPlUpdStsMsg', data.msg, 'Error');
            }
        });
    }
});

$(document).off('click', '#btnCrPlTmCrPlSignOff').on('click', '#btnCrPlTmCrPlSignOff', function () {
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;
    var catName = $(chkBxChd[0]).data('catname').toUpperCase();
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    if (chkBxChd.length == 1) {
        if (catName == 'RECOMMENDED') {
            $('#hdnTmCrPlSignOffId').val($(chkBxChd[0]).data('hiddenval'));
            $('#hdnCrPlTmCrPlHisCrPlId').val($(chkBxChd[0]).attr('id').split('_')[1]);
            $('#popUpDialog2').CMNPopup({
                pvUrl: baseURL + "/CarePlan/SignOffDtls",
                onLoad: function () {
                },
                popUpHeader: "Sign Off Details",
                closeButton: "#SignOffDtlsClose",
                popLevel: 1,
                onClose: function () { $('#hdnTmCrPlSignOffId').val(''); $('#hdnCrPlTmCrPlHisCrPlId').val(''); }
            });
        }
        else $('#btnCrPlTmCrPlToggleSignOff').trigger('click');
    }
});


$(document).off('click', '#btnCrPlTmCrPlSendEmail').on('click', '#btnCrPlTmCrPlSendEmail', function () {
    loader(1);

    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    var gridName = GetCRPLGrid($catName.trim());
    //Need Help
    var dataStr = {
        //roleId: $('#loadRolehdn').val(),
        categoryID: $('#selCrPlTmCrPlCat').val() === "" ? "-1" : $('#selCrPlTmCrPlCat').val(),
        startDate: $('#txtCrPlTmCrPlStDt').val(),
        endDate: $('#txtCrPlTmCrPlEdDt').val(),
        sortField: $("#" + gridName + " th.k-header[data-dir]").attr('data-field'),
        sortOrder: $("#" + gridName + " th.k-header[data-dir]").attr('data-dir'),
        isProvider: isProvider
    }

    $.ajax({
        type: "POST",
        url: baseURL + "/CarePlan/SendEmailCarePlan",
        dataType: "json",
        data: dataStr,
        success: function (data) {
            commonIconStyleStatusMsgDisplay('CarePlanSuccessMessage', data.msg, 3000);
            loader(0);
            if (data.success) {
                AuditLog(1, actionTypeEnum.Email, 'Team Care Plan >> Action >> Email', $('#selectPatientAccessed').val(), memberidval, '');
            }
        },
        error: function (request, status, error) {
            commonIconStyleStatusMsgDisplay('CarePlanErrorMessage', 'Error occurred, please try again.', 3000);
            loader(0);
        }
    });
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    let gridViewName = '#TmCrPlRecAndCurGroupGrid';
    if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
        gridViewName = '#TmCrPlRecAndCurGroupListView';
    }
    $(gridViewName +' .clsChkCrPlTmCrPlGrid,.clsChkCrPlTmCrPlHead').not('.clsChkCPSignOff').prop('checked', false);
});

$(document).off('click', '#btnCrPlTmCrPlAddCP').on('click', '#btnCrPlTmCrPlAddCP', function () {
    addManualCarePlan();
});
function addManualCarePlan() {
    loader(1);
    globalTeamCPStatus = $('#selCrPlTmCrPlCat').val();
    $('#TeamCarePlanAddOrEditDiv').html('');
    $('#TeamCarePlanAddOrEditDiv').load(baseURL + "/CarePlan/AddCarePlan", function () {
        loader(0);
    });
    $('#TeamCarePlanAddOrEditDiv').show();
    $('#TeamCarePlanChildDiv').show();
    $('#SingleClickGrid').hide();
    $('#popUpDialog1').find('#closePopUp').attr('id', 'closePopUp_1');
    $('#popUpDialog1').find('#closePopUpUM').attr('id', 'closePopUp_1');
}

//since we are loading two divs in same pop up changing the close pop up id on add click and triggering the cancel event on close click
$(document).off('click', '#popUpDialog1 #closePopUp_1').on('click', '#popUpDialog1 #closePopUp_1', function () {
    if ($('#btnDtaCancel1').is(':visible'))
        $('#btnDtaCancel1').trigger('click');
    if ($('#btnCrPlTmCrPlSaveCancel').is(':visible'))
        $('#btnCrPlTmCrPlSaveCancel').trigger('click');
    if ($('#btnCrPlTmCrPlAddCancel').is(':visible'))
        $('#btnCrPlTmCrPlAddCancel').trigger('click');
});

$(document).off('click', '#btnCrPlTmCrPlSearch').on('click', '#btnCrPlTmCrPlSearch', function () {
    A11yAlerts.remove();
    A11yForms.clearFormFieldValidation();
    let isValid = true;
    if ($('#cpDateRange').val() === "5") {
        isValid = carePlanDateFilterValidation();
    }

    if (isValid) {
        var gridId;
        var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
        if ($catName != 'UAS') {
            var gridName = GetCRPLGrid($catName.trim());
            gridId = ("#" + gridName);
        }
        else {
            gridId = ("#UASScript");
        }
        gridRefresh(gridId, '', 1);
    }
    else {
        CmnStatusMessageDisp('CarePlanAlertMsg', A11yAlerts.ALERT_MSG.GENERIC_ERROR, 'Error');
    }
})

$(document).off('change', '.clsChkCrPlTmCrPlGrid').on('change', '.clsChkCrPlTmCrPlGrid', function () {
    var $chkBox = $(this);
    var $table = '';
    var catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    if (catName != 'UAS') {
        var gridName = GetCRPLGrid(catName.trim());
        $table = $("#" + gridName);
    } else {
        $table = $('#UASScript');
    }

    var allChkBox = $table.find('input[type="checkbox"]').not('.clsChkCrPlTmCrPlHead').not('.clsChkCPSignOff');

    var chkdChBxCrTm = allChkBox.filter(':checked');
    if (allChkBox.length == chkdChBxCrTm.length) {
        $('.clsChkCrPlTmCrPlHead').prop('checked', true);
    } else {
        $('.clsChkCrPlTmCrPlHead').prop('checked', false);
    }

    if (chkdChBxCrTm.length === 1) {
        $chkBox = $(chkdChBxCrTm[0]);
        var $selchkBoxuid = $chkBox.data('uid');
        $('.clsTmCrPlInlineContextMenu').AhsSetHtml('');
        catName = ($chkBox.data('catname') || '').toUpperCase();
        if (catName != 'UAS') {
            TmCrPlMenuDisEnb(catName, $chkBox.data('hiddenval'));
            var contextMenuHtml = $('#hMenGdCP') !== undefined ? $('#hMenGdCP')[0].innerHTML : '';
            $('#' + $selchkBoxuid + 'idTmCrPlInlineContextMenu').AhsSetHtml(contextMenuHtml).show();
        } else {
            $('#hMenGdCP').hide();
            $('#' + $selchkBoxuid + 'idTmCrPlInlineContextMenu').AhsSetHtml('').hide();
        }
        if (catName === "CURRENT") {
            $('#btnCrPlTargetedIntervention').removeClass('LinkDisabled');
        }  //UHC-4324
        else {
            $('#btnCrPlTargetedIntervention').addClass('LinkDisabled');
        } //UHC-4324
    } else {
        $('#hMenGdCP').hide();
        $('.clsTmCrPlInlineContextMenu').AhsSetHtml('').hide();
    }

    if (chkdChBxCrTm.length > 1 && catName == 'SELECT') {
        var chkCatAll = true;
        catval = 'CURRENT';
        var isRecommendedExists = false; //UHC-4324
        $.each(chkdChBxCrTm, function (index, value) {
            var dataCatVal = ($(value).data('catname') || '').toUpperCase();
            if (catval !== dataCatVal) {
                chkCatAll = false;
                if (dataCatVal === "RECOMMENDED") {
                    isRecommendedExists = true;
                }//UHC-4324
                return false;
            }
        });
        if (chkCatAll) { catName = catval; }
        if (isRecommendedExists === true) {
            $('#btnCrPlTargetedIntervention').addClass('LinkDisabled'); //UHC-4324
            catName = "RECOMMENDED";
        }
    }
    if (chkdChBxCrTm.length > 1 && catName === 'CURRENT') {
        $('#btnCrPlTargetedIntervention').removeClass('LinkDisabled'); //UHC-4324
    }
    TmCrPlShHdBtn(catName, chkdChBxCrTm.length);

    var crplCcatName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    if ($.trim(crplCcatName) === 'SELECT') {
        var $obj = chkChecked();
        var chkBxChd = $obj.checkBox;

        var categoryName = '';
        for (var i = 0; i < chkBxChd.length; i++) {
            var dataCategoryName = ($(chkBxChd[i]).data('catname') || '').toUpperCase();
            if (categoryName === '')
                categoryName = dataCategoryName;
            else {
                if (categoryName.toUpperCase() === dataCategoryName) {
                    $('#btnCrPlTmCrPlToggleSignOff').show();
                }
                else {
                    $('#btnCrPlTmCrPlToggleSignOff').hide();
                    return false;
                }
            }
        }
    }
});

$(document).off('click', '#cplchangeMessage').on('click', '#cplchangeMessage', function () {
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    CarePlanMessage(true);
});

$(document).off('click', '#btncplgencon').on('click', '#btncplgencon', function () {
    var $message = $.trim($('#txtcplgencon').val());
    var pval = $('#selectPatientAccessed').val();
    var pardata = { PatientId: pval, message: $message };
    $.ajax({
        url: baseURL + "/CarePlan/SaveCarePlanMessage",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            if ($message == null || $message == '') {
                $message = 'N/A';
            }
            $('#spngenConsideration').html($message);
            $('#btnTmCrPlnConsiderationClose').trigger('click');
        }
    });

});

$(document).off('click', '.cplPrioritychild').on('click', '.cplPrioritychild', function () {

    var id = $(this).data('details').split('_')[0];
    var Pid = $(this).data('details').split('_')[1];
    $('#hdnCrPlTmCrPlHisCrPlId').val(id);
    $('#hdnCrPlTmCrPlPrId').val(Pid);
    $('#popUpDialog3').CMNPopup({
        modalContent: $('#ManagePriority').html(),
        popUpHeader: "Manage Priority",
        popLevel: 1,
        onLoad: function () {
            loadDropDown(baseApiURL + '/CFGCarePlanAutomationApi/BindCPLPriority', 'ddlManagePriority', null, null, 'PriorityId', 'PriorityName');
        },
        closeButton: '#btnMngePriPopUpclose'
    });
    $('#ddlManagePriority option').each(function (i, e) {
        $('option:selected', e).removeAttr('selected');

    });

    ////var selValue = $('#ddlManagePriority option').filter(function () { return $(this).html() == Pid; }).val();
    $('#ddlManagePriority').val(Pid);

    // $("#ddlManagePriority option:contains(" + this.innerHTML + ")").attr('selected', 'selected');

});

$(document).off('change', '#ddlManagePriority').on('change', '#ddlManagePriority', function () {
    var ddlMemberInvolvementVal = $('#ddlManagePriority').val();
    if (ddlMemberInvolvementVal == -1) {
        return false;
    }
    else {
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/SaveMemInvolvement?ddlMemberInvolvement=" + $("#ddlManagePriority").val() + "&CarePlanId=" + $('#hdnCrPlTmCrPlHisCrPlId').val() + "&section=careplan" + "&PatientId=" + $('#selectPatientAccessed').val(),
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $('#btnMngePriPopUpclose').trigger('click');
                    gridShowHideCarePlan(true, false);
                    $("#hMenGdCP,.clsTmCrPlInlineContextMenu").hide();
                    var selectedCategory = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
                    TmCrPlShHdBtn(selectedCategory, 0);

                }
            }
        });
    }

});

$(document).off('change', '#selCrPlTmCrPlCat').on('change', '#selCrPlTmCrPlCat', function () {
    var catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase()  : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    $("#selCrPlTmCrPlRole :input").attr("disabled", false);
    globalTeamCPStatus = $('#selCrPlTmCrPlCat').val();
    CreateMultiCheckDropdown('selCrPlTmCrPlStatus', baseURL + '/Master/BindCPLCategoryStatus?categoryId=' + $('#selCrPlTmCrPlCat').val(), 'loadStatus', null, null, null, 'StatusId', 'StatusName');
    gridShowHideCarePlan(true, false); DefaultCplCatChecked();

    if (catName == 'DELETED') {
        $('.cplRestore').show();
    }
    else {
        $('.cplRestore').hide();
    }
    if (catName === "CURRENT" || catName.trim() === "SELECT") {
        $('#btnCrPlTargetedIntervention').removeClass('LinkDisabled');
    }
    else {
        $('#btnCrPlTargetedIntervention').addClass('LinkDisabled');
    }
    updateCpSetAsDefaultChkStatus();
});

$(document).off('click', '#btnCrPlTmCrPlRunScript').on('click', '#btnCrPlTmCrPlRunScript', function () {
    chkBxChd = $(".clsChkCrPlTmCrPlGrid:checked").not('.clsChkCPSignOff');
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    if (chkBxChd && chkBxChd.length == 1) {
        if ($(".InComplaintPage").is(":visible")) {
            JsAGRunScript();
        } else {
            globalTeamCPStatus = $('#selCrPlTmCrPlCat').val();
            $('#hdnCrPlTmCrPlHisCrPlId').val($(chkBxChd[0]).attr('id').split('_')[1]);
            $('#popUpDialog2').CMNPopup({
                pvUrl: baseURL + "/Home/RunScript?carePlanId=" + $('#hdnCrPlTmCrPlHisCrPlId').val(),
                popUpHeader: "Run Script",
                popLevel: 1,
                triggerBtnId: $('#popUpDialog1').is(':visible') ? 'popUpDialog1' : undefined,
                onClose: function () {
                    globalTeamCPStatus = "";
                    $('#hdnCrPlTmCrPlHisCrPlId').val('');
                }
            });
        }
    }
});
$(document).off('click', '.clsChkCrPlTmCrPlHead').on('click', '.clsChkCrPlTmCrPlHead', function () {
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    var gridName = GetCRPLGrid($catName.trim());

    if ($(this).is(':checked')) {
        $("#" + gridName + " .clsChkCrPlTmCrPlGrid").not('.clsChkCPSignOff').prop('checked', true);
    }
    else {
        $("#" + gridName + " .clsChkCrPlTmCrPlGrid").not('.clsChkCPSignOff').prop('checked', false);
    }
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    var chkdChBxCrTm = $("#" + gridName + " .clsChkCrPlTmCrPlGrid:checked").not('.clsChkCPSignOff');
    TmCrPlShHdBtn($catName, chkdChBxCrTm.length);
});
$('#document').off('click', '.clsChkCrPlTmCrPlGrid').on('click', '.clsChkCrPlTmCrPlGrid', function () {
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    var gridName = GetCRPLGrid($catName.trim());

    var chkdChBxCrTm = $("#" + gridName + " .clsChkCrPlTmCrPlGrid:checked").not('.clsChkCPSignOff');

    if (chkdChBxCrTm.length == 1) {
        TmCrPlMenuDisEnb($(chkdChBxCrTm[0]).data('catname'));
    }
    TmCrPlShHdBtn($catName, chkdChBxCrTm.length);
});
$(document).off('click', '#btnCrPlTmCrPlDeleteCP').on('click', '#btnCrPlTmCrPlDeleteCP', function () {

    loader(1);
    var status = false;
    var $obj = chkChecked();
    var chkdChkBx = $obj.checkBox;
    if (chkdChkBx.length == 0) {
        CustomAlert('Please select atleast one record to delete.');
        loader(0);
    }
    else {
        loader(1);
        var carePlanIds = [];
        $.each(chkdChkBx, function (index, value) {
            carePlanIds.push($(value).attr('id').split('_')[1]);
        });
        var ruleOgiDeleteObject = { eventSource: "CMOGIDELETE", moduleName: "CM", eventType: "PRE", carePlanIds: carePlanIds };
        var ruleOgiDeleteResponse = ficoRealTimeValidation(ruleOgiDeleteObject);
        var isRuleHardValidation = CheckValidationMessages(ruleOgiDeleteResponse);
        if (isRuleHardValidation) {
            loader(0);
            return;
        }
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/DeleteCarePlan?memberId=" + $('#selectPatientAccessed').val(),
            dataType: "json",
            data: {
                carePlanIDs: carePlanIds
            },
            success: function (data) {
                if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
                    gridRefresh("#TmCrPlRecAndCurGroupListView");
                }
                //gridRefresh("#TmCrPlCarePlanGrid");
                gridShowHideCarePlan(true, false);
                loader(0);
            }
        });
        //$("#TmCrPlCarePlanGrid").data("kendoGrid").dataSource.read();
    }

});
$(document).off('click', '#lnkbtncplIntrType').on('click', '#lnkbtncplIntrType', function () {
    var contextMenu = $('#hMenGdCP,.clsTmCrPlInlineContextMenu');
    if (contextMenu) {
        contextMenu.hide();
    }
    var CarePlanId = $(this).attr('data-CarePlanID');
    if (CarePlanId == null || CarePlanId == 'null') {
        var CarePlanIdTemp = $(this).attr('data-intervention').split('~~');
        if (CarePlanIdTemp.length > 0)
            CarePlanId = CarePlanIdTemp[0];
    }
    $('#popUpDialog2').css({ "margin-left": "0px", "width": "" });
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/CommonDefaultSessionState/AddAppointment?CareplanId=" + CarePlanId,
        popUpHeader: "Add Appointment",
        closeButton: '#closebutton1',
        popLevel: 2,
        onClose: function () {
            ClearTableMenu('_myMemberPartialViewContainer', 'divMemberMenu');
            if ($("#fromAppointment").length == 1)
                $("#fromAppointment").remove();
        }
    });
});

$(document).off('click', '.cpAddActivity').on('click', '.cpAddActivity', function () {
    $('#hdnCrPlTmCrPlHisCrPlId').val('');
    // var chkBxChd = $(".clsChkCrPlTmCrPlGrid:checked");
    var chkBxChd = chkChecked().checkBox;
    var carePlanId = '';
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    if (chkBxChd.length >= 1) {
        if (chkBxChd.length <= 10) {
            $.each(chkBxChd, function (key, item) {
                if ($(item).is(':checked')) {
                    carePlanId += $(item).attr('Id').split('_')[1] + ",";
                }
            });
            carePlanId = carePlanId.replace(/,(?=[^,]*$)/, '');
            $('#hdnCrPlTmCrPlHisCrPlId').val(carePlanId);
            if ($.trim($('#popUpDialog1 #portletHeadHand').text().toUpperCase()) == "ADD ACTIVITY") {
                $('#popUpDialog1').html('');
            }

            $('#popUpDialog2').CMNPopup({
                popUpHeader: "Add Activity",
                pvUrl: baseURL + "/Home/EditActivity?patientId=" + $('#selectPatientAccessed').val() + "&CarePlanId=" + $('#hdnCrPlTmCrPlHisCrPlId').val(),
                onLoad: function () {
                    onLoadEditActivity();
                    $('#divcplgoal').show();
                    A11yModal.trapFocusInModal('popUpDialog2');
                },
                onClose: function () {
                    ClearActivityHdnCntrls();
                },
                popLevel: 2,
                triggerBtnId: $('#popUpDialog1').is(':visible') ? 'popUpDialog1' : undefined,
                closeButton: "#btnCloseEditActivityForm",
                modalWidth: MODAL_WIDTH.MEDIUM
            });
        }
        else {
            CustomAlert('You cannot add activity for more than 10 care plans.');
        }
    }
    else {
        CustomAlert('Please select at least one care plan record to add an activity.');
    }
});


$(document).off('click', '#divlnkGrpGoalIntervention').on('click', '#divlnkGrpGoalIntervention', function () {
    var CareplanId = '';
    CareplanId = $('#hdnCrPlTmCrPlHisCrPlId').val();
    if (CareplanId != null && CareplanId != '' && CareplanId != 'undefined') {
        loader(1);
        $('#popUpDialog3').css("width", "50%");
        //$('#popUpDialog3').css("margin-left", "-333px");
        $('#popUpDialog3').CMNPopup({
            popUpHeader: "Goals & Interventions",
            pvUrl: baseURL + "/CarePlan/CpActivityGoalsInterventions",
            onLoad: function () {
                loader(0);
            },
            onClose: function () {
                $('#popUpDialog3').css("width", "");
                $('#popUpDialog3').css("margin-left", "");
            },
            popLevel: 3,
            closeButton: "#btnCloseGrpGoalIntervention"
        });
    }
    else {
        CmnStatusMessageDisp('validationMessageActivity', 'Error occurred, Please try again', 'Error');
    }
});

//If you select status as Recommended,Current then only assign owner need to enable
$(document).off('change', '#selCrPlTmStatusId').on('change', '#selCrPlTmStatusId', function () {
    var selStatus = $('#selCrPlTmStatusId').val();
    var dropdownlist = $("#selCrPlTmAssignOwner").data("kendoDropDownList");
    if (dropdownlist != null) {
        if (selStatus != '-1' && selStatus != null && selStatus != undefined) {
            $.ajax({
                url: baseURL + '/CarePlan/StatusCategoryCarePlan?StatusId=' + selStatus,
                dataType: "json",
                success: function (data) {
                    //if selected status mapped with Recommended,Current then result will be true other wise false.
                    //if selected other then Recommended,Current if you are adding new record it should set select,if changing in existing record orginal value to set
                    if (data.success) {
                        dropdownlist.enable(true);
                    }
                    else {
                        if ($('#btnCrPlTmCrPlSave').val() == 'Update' && $('#hdnAssignOwner').val() != null && $('#hdnAssignOwner').val() != 'null' && $('#hdnAssignOwner').val() != '') {
                            dropdownlist.value($('#hdnAssignOwner').val());
                        }
                        else {
                            dropdownlist.value('-1');
                        }
                        dropdownlist.enable(false);
                    }
                }

            });
        }
        else {
            dropdownlist.enable(true);
        }
    }
});



//Manually adding Opportunity in Team care plan - click event.
$(document).off('click', '#btnCrPlTmAddOpp').on('click', '#btnCrPlTmAddOpp', function () {
    $('#hdnManualOpportunityName').val('');
    $('#popUpDialog2').HtmlEmpty().CMNPopup({
        pvUrl: baseURL + "/CarePlan/AddOrEditOpportunity",
        onLoad: function () {
            BindOppData();
            $.fn.getCntrl('btnCfgOppAdd').ToggleDisplay(true);
            $.fn.getCntrl('btnCfgOppUpdate').ToggleDisplay(false);
        },
        onClose: function () {
            if ($('#hdnManualOpportunityName').val() != '') {
                $('#btnCrPlTmAddOpp').hide();
                $('#txtCrPlTmOpp').show().val($('#hdnManualOpportunityName').val());
                $('#selCrPlTmOppId').parent().hide();
                $('#btnCrPlTmAddCancelOpp').show();
            }
        },
        popUpHeader: "Add Manual Opportunity <span class='f12 semiBold ItemPL20'>Manual opportunity expands existing library. Please check existing opportunities before customizing. </span>",
        modalWidth: MODAL_WIDTH.SEMI_LARGE,
        popLevel: 2,
        closeButton: "#btnCfgOppCancel"
    });
});
$(document).off('click', '#btnCrPlTmAddInt').on('click', '#btnCrPlTmAddInt', function () {
    //$(this).hide();
    //$('#selCrPlTmInterventionId').hide();
    //$('#txtCrPlTmIntervention').show();
    //$('#btnCrPlTmAddCancelInt').show();
    $(this).hide();
    $('#txtCrPlTmIntervention').show();
    //$('#selCrPlTmInterventionId').parent().hide();//kuhg-746
    $('#InterventionIdAuto').parent().hide();
    $('#btnCrPlTmAddInt').hide();//kuhg-746
    $('#btnAdvSearchIntervention').hide();//kuhg-746
    $('#btnCrPlTmAddCancelInt').show();

});
// Manually adding goal in Team care plan - click event.
$(document).off('click', '#btnCrPlTmAddGoal').on('click', '#btnCrPlTmAddGoal', function () {
    $('#hdnManualGoalName').val('');
    $('#popUpDialog2').HtmlEmpty().CMNPopup({
        pvUrl: baseURL + "/CarePlan/AddOrEditGoal",
        onLoad: function () {
            BindGoalData();
            $.fn.getCntrl('btnCfgGoalAdd').ToggleDisplay(true);
            $.fn.getCntrl('btnCfgGoalUpdate').ToggleDisplay(false);
        },
        onClose: function () {
            if ($('#hdnManualGoalName').val() != '') {
                $('#btnCrPlTmAddGoal').hide();
                $('#txtCrPlTmGoal').show().val($('#hdnManualGoalName').val());
                $('#selCrPlTmGoalId').parent().hide();
                $('#btnCrPlTmAddCancelGoal').show();
            }
        },
        popUpHeader: "Add Manual Goal <span class='f12 semiBold ItemPL20'>Manual goals expand existing library. </span>",
        popLevel: 2,
        closeButton: "#btnCfgGoalCancel"
    });
});
$(document).off('click', '#btnCrPlTmAddCancelInt').on('click', '#btnCrPlTmAddCancelInt', function () {
    //$(this).hide();
    //$('#txtCrPlTmIntervention').hide();
    //$('#selCrPlTmInterventionId').show();
    //$('#btnCrPlTmAddInt').show();

    $(this).hide();
    $('#txtCrPlTmIntervention').hide();
    $('#txtCrPlTmIntervention').val("");
    //$('#selCrPlTmInterventionId').parent().show();//kuhg-746
    $('#InterventionIdAuto').parent().show();
    $('#btnCrPlTmAddInt').show();//kuhg-746
    $('#btnAdvSearchIntervention').show();//kuhg-746
    $('#btnCrPlTmAddInt').show();
});
$(document).off('click', '#btnCrPlTmAddCancelGoal').on('click', '#btnCrPlTmAddCancelGoal', function () {
    //$(this).hide();
    //$('#txtCrPlTmGoal').hide();
    //$('#selCrPlTmGoalId').show();
    //$('#btnCrPlTmAddGoal').show();

    $(this).hide();
    $('#txtCrPlTmGoal').hide();
    $('#txtCrPlTmGoal').val("");
    $('#selCrPlTmGoalId').parent().show();
    $('#btnCrPlTmAddGoal').show();
});

$(document).off('click', '#btnCrPlTmAddCancelOpp').on('click', '#btnCrPlTmAddCancelOpp', function () {
    $(this).hide();
    $('#txtCrPlTmOpp').hide().val("");
    $('#selCrPlTmOppId').parent().show();
    $('#btnCrPlTmAddOpp').show();
});


$(document).off('click', '#btnCrPlTmCrPlSaveCancel').on('click', '#btnCrPlTmCrPlSaveCancel', function () {
    $('#dvViewNotes').html('');
    $('#formCrPlAddTmCrPl #hdnTempInterventionId').val('');
    $('#TeamCarePlanChildDiv').show();
    $('#TeamCarePlanAddOrEditDiv').hide();
    loadCarePlanMenuTab('OverView');
    $('#atlEditCarePlan').remove();
    if ($("#UmAuthTabs").is(":visible")) {
        $('#popUpDialog1').find('#closePopUp_1').attr('id', 'closePopUpUM');
    }
    else {
        $('#popUpDialog1').find('#closePopUp_1').attr('id', 'closePopUp');
    }
    // $('#lnkCarePlanTab').trigger('click');
    $("#hdnCrPlTmCrPlEditCrPlId").val('');
    $('#TmCrPlRecAndCurGroupGrid .clsChkCrPlTmCrPlGrid:checked').not('.clsChkCPSignOff').attr('checked', false);
    $('#TmCrPlCarePlanGrid .clsChkCrPlTmCrPlGrid:checked').not('.clsChkCPSignOff').attr('checked', false);
    $('#TmCrPlRecAndCurGroupGrid .clsChkCrPlTmCrPlHead:checked').attr('checked', false);
    $('#btnCrPlTmCrPlAddCP').show();
    $('#btnCrPlTmCrPlMyCarePlan').show();
    if ($('.mtmTabSection').length > 0) { $('.mtmTabSection').show(); }//to display cmr summary in mtm intervention after cancel click
    if ($('#popUpDialog1').is(':visible')) {
        A11yUtil.setFocus($("#popUpDialog1 #btnTeamCarePlanClose"));
    }
});
$(document).off('click', '#btnCrPlTmCrPlSave').on('click', '#btnCrPlTmCrPlSave', function () {
    submitCrPlTmCrPlFrm();
});

$(document).off('mouseleave', '#divFiltercriteriaMyMembers').on('mouseleave', '#divFiltercriteriaMyMembers', function () {
    $('#divFiltercriteriaMyMembers').hide();
});
$(document).off('click', '#ExCrTmFormId #IsPcp1').on('click', '#ExCrTmFormId #IsPcp1', function () {
    //if ($(this).is(':checked'))
    //    $('#trTxtExtCrTmFromDate,#trTxtExtCrToDate').show();
    //else
    //    $('#trTxtExtCrTmFromDate,#trTxtExtCrToDate').hide();
    $('#ExCrTmFormId #txtExtCrToDate').kendoDatePicker();
    $('#ExCrTmFormId #txtExtCrTmFromDate').kendoDatePicker();
});

$(document).off('focusout', '#ExCrTmFormId #txtExtCrTmEmail').on('focusout', '#ExCrTmFormId #txtExtCrTmEmail', function () {
    ExCrTmEmailBtnShHd();
});

$(document).off('click', '.ScModeRS').on('click', '.ScModeRS', function () {
    var scriptFormId = $('#ddlScriptsmvc option:selected').attr('id');
    var sfmode = $(this).val();
    CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|" + "|" + sfmode);
    // CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|" + sfmode);
    closeAssessmentPopUpWindow();
    $('#tblDecision').hide();
    $('#tblSrMode').hide();
    $('#tblScMode').hide();
});
$(document).off('click', '#btnPrintPharmacyCard').on('click', '#btnPrintPharmacyCard', function () {
    loader(1);
    var url = "";
    if (viewUnifiedMedications === false) {
        url = baseURL + '/Health/ActionOnPharmacyCard?fileAction=Print&PatientID=' + $('#selectPatientAccessed').val()
            + '&MANUAL_MEDI_SEARCH_FIELD=' + $("#PCRddlMedicationType").val()
            + '&MANUAL_MEDI_SEARCH_TEXT=' + $("#PCRtxtMedicationName").val()
            + '&MANUAL_MEDI_START_DATE=' + $('#PCRMedicationStartDate').val()
            + '&MANUAL_MEDI_END_DATE=' + $('#PCRMedicationEndDate').val()
            + '&CLAIM_MEDI_SEARCH_FIELD=' + $('#PCRddlHeaMedClmBsdFldType').val()
            + '&CLAIM_MEDI_SEARCH_TEXT=' + $('#PCRtxtHeaMedClmBsdSrch').val()
            + '&CLAIM_MEDI_START_DATE=' + $('#PCRtxtHeaMedClmBsdStartDate').val()
            + '&CLAIM_MEDI_END_DATE=' + $('#PCRtxtHeaMedClmBsdEndDate').val()
    }
    else {
        url = baseURL + '/Health/ActionOnPharmacyCard?fileAction=Print&PatientID=' + $('#selectPatientAccessed').val()
            + '&MANUAL_MEDI_SEARCH_FIELD=' + $('#ddlMedicationType').val()
            + '&MANUAL_MEDI_SEARCH_TEXT=' + $("#txtMedicationName").val()
            + '&MANUAL_MEDI_START_DATE=' + $('#MedicationStartDate').val()
            + '&MANUAL_MEDI_END_DATE=' + $('#MedicationEndDate').val()
            + '&CLAIM_MEDI_SEARCH_FIELD=' + ""
            + '&CLAIM_MEDI_SEARCH_TEXT=' + ""
            + '&CLAIM_MEDI_START_DATE=' + ""
            + '&CLAIM_MEDI_END_DATE=' + "";
    }
    $.ajax({
        type: "POST",
        url: url,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var jqueryDOM = data.content;
                var windowUrl = '';
                loader(0);
                if (viewUnifiedMedications === false) {
                    jqueryDOM = "<html><head><title>Print</title></head><body>" + jqueryDOM + "</body></html>";
                }
                else {
                    var applyStyles = "<style>.phR_main {width:700px; font-size:12pt;margin-top: 20px;FONT-FAMILY: arial;}.phR_section { margin-bottom:20px; border:1px solid #cccccc; border-radius:4px;}.phR_sec_title{ font-size:13pt; font-weight:700; margin:10px 15px;}.phR_sec_container { border-top:1px solid #cccccc; display:flex; flex-wrap:wrap; padding:5px;}.phR_field_contaner { display:flex; flex-direction:column;}.phr_col1 {width:95%; margin:7px 10px; }.phr_col2 {width:326px; margin:7px 8px; }.phr_col3 {width:210px; margin:7px 8px; }.phr_col4 {width:155px; margin:7px 8px; }.phR_field_contaner label, .phR_sec_container_tbl label  { font-weight:bold; width:95%;}.field_data {word-break: break-word; -ms-word-break: break-all; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto; white-space: inherit;} .phR_footer {display:flex; padding:30px 30px 10px 30px;}.phR_footer div { text-align: center; border-top: 1px solid #ccc; padding: 10px;} .phR_footer-container {margin-top: 50px;} .phR_sec_container_tbl { border-top:1px solid #cccccc; padding:5px;} .phR_sec_container_tbl td{padding:10px 5px; vertical-align:top;} </style>";
                    jqueryDOM = "<html><head><title>Print</title>" + applyStyles + "</head><body>" + jqueryDOM + "</body></html>";
                }
                var printWindow = window.open(windowUrl, (window.browserPopUpName || window.top.browserPopUpName), 'scrollbars = yes,height=400,width=800');
                printWindow.document.write(jqueryDOM);
                printWindow.document.close();
                printWindow.focus();
                // Wait for the content to be fully loaded before printing
                printWindow.onload = function () {
                    printWindow.print();
                };
                AuditLog(1, actionTypeEnum.Print, 'Show Pharmacy Report', $('#selectPatientAccessed').val(), memberidval, 'Pharmacy Report Print');
            }
        }
    });
});


$(document).off('click', '#btnPrintAndSaveDocument').on('click', '#btnPrintAndSaveDocument', function () {
    loader(1);
    var url = baseURL + '/Health/ActionOnPharmacyCard?fileAction=PrintAndSaveDocument&PatientID=' + $('#selectPatientAccessed').val()
            + '&MANUAL_MEDI_SEARCH_FIELD=' + $('#ddlMedicationType').val()
            + '&MANUAL_MEDI_SEARCH_TEXT=' + $("#txtMedicationName").val()
            + '&MANUAL_MEDI_START_DATE=' + $('#MedicationStartDate').val()
            + '&MANUAL_MEDI_END_DATE=' + $('#MedicationEndDate').val()
            + '&CLAIM_MEDI_SEARCH_FIELD=' + ""
            + '&CLAIM_MEDI_SEARCH_TEXT=' + ""
            + '&CLAIM_MEDI_START_DATE=' + ""
        + '&CLAIM_MEDI_END_DATE=' + "";
    $.ajax({
        type: "POST",
        url: url,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var jqueryDOM = data.content;
                var windowUrl = '';
                var printWindow = window.open(windowUrl, (window.browserPopUpName || window.top.browserPopUpName), 'scrollbars = yes,height=400,width=800');
                printWindow.document.write(jqueryDOM);
                if (data.isDocumnetGenerated) {
                    CmnStatusMessageDisp('PharmacyReportStatus', 'Success, you have saved this pharmacy report to documents. Go to activity records to view.', 'Success');
                }
                else {
                    CmnStatusMessageDisp('PharmacyReportStatus', 'Error while saving the Document', 'Error');
                }
                loader(0);
                printWindow.document.close();
                printWindow.focus();
                // Wait for the content to be fully loaded before printing
                printWindow.onload = function () {
                    printWindow.print();
                };
                AuditLog(1, actionTypeEnum.Print, 'Show Pharmacy Report', $('#selectPatientAccessed').val(), memberidval, 'Pharmacy Report Print');
            }
        }
    });
});
$(document).off('click', '#btnCrplSummaryPrint').on('click', '#btnCrplSummaryPrint', function () {

    var url = '';
    if ($('#lnkMTMInterventionsTab').hasClass('select')) {
        url = baseURL + '/MTM/MTMInterventionSummaryPrint?patientId=' + $('#selectPatientAccessed').val()
            + '&carePlanId=' + cpid + '&category=' + globalCplCategory + '&isProvider=' + isProviderUser;
    }
    else {
        url = baseURL + '/CarePlan/CarePlanSummaryPrint?patientId=' + $('#selectPatientAccessed').val()
            + '&carePlanId=' + cpid + '&category=' + globalCplCategory + '&isProvider=' + isProviderUser;
    }
    $.ajax({
        type: "POST",
        url: url,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var jqueryDOM = data.content;
                var windowUrl = '';
                var uniqueName = new Date();
                var windowName = 'Care Plan Summary';
                var keepColors = '<style>body {-webkit-print-color-adjust: exact !important; }</style>';
                jqueryDOM = "<html><head><title></title>" + keepColors + "</head><body>" + jqueryDOM + "</body></html>";
                var printWindow = window.open(windowUrl, (window.browserPopUpName || window.top.browserPopUpName), 'height=400,width=800,location=0,scrollbars=yes');
                printWindow.document.body.innerHTML = jqueryDOM;
                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
                AuditLog(1, actionTypeEnum.Print, 'Care Plan >> Team Care Plan >> Context Menu >> Summary', $("#selectPatientAccessed").val(), memberidval, '');
            }
        }
    });
});


$(document).off('click', '#btnViewScriptSummaryPrint').on('click', '#btnViewScriptSummaryPrint', function () {
    var moduleID = "", patientID = "", sectionName = "", AuthID = "", ComplaintID = "";
    //$('#lblActivitySummaryPrintMemberId').html($('#ViewScriptActivitySummaryForm #lblMemberId').html());
    //$('#lblActivitySummaryPrintAltruistaId').html($('#ViewScriptActivitySummaryForm #lblAltruistaId').html());
    $('#lblActivitySummaryPrintMemIdentifierLabel').html($('#ViewScriptActivitySummaryForm #lblMemberIdentifierLabel').AhsGetHtml());
    $('#lblActivitySummaryPrintMemIdentifierValue').html($('#ViewScriptActivitySummaryForm #lblMemberIdentifierValue').AhsGetHtml());
    $('#lblActivitySummaryPrintMemberDOB').html($('#ViewScriptActivitySummaryForm #lblMemberDOB').AhsGetHtml());
    $('#lblActivitySummaryPrintMemberName').html($('#ViewScriptActivitySummaryForm #lblMemberName').AhsGetHtml());
    $('#lblActivitySummaryPrintScriptName').html($('#ViewScriptActivitySummaryForm #lblScriptName').AhsGetHtml());
    $('#lblActivitySummaryPrintScriptCompletedBy').html($('#ViewScriptActivitySummaryForm #lblScriptCompletedBy').AhsGetHtml());
    $('#lblActivitySummaryPrintScriptCompletedOn').html($('#ViewScriptActivitySummaryForm #lblScriptCompletedOn').AhsGetHtml());
    $('#lblActivitySummaryPrintTotalScoreReceived').html($('#ViewScriptActivitySummaryForm #lblTotalScoreReceived').AhsGetHtml());
    $('#lblActivitySummaryPrintTotalScriptScore').html($('#ViewScriptActivitySummaryForm #lblTotalScriptScore').AhsGetHtml());
    $('#lblActivitySummaryPrintScriptStatus').text($('#ViewScriptActivitySummaryForm #hdfScriptStatus').val());
    $('#lblActivitySummaryPrintCreatedOn').text($('#ViewScriptActivitySummaryForm #hdfScriptStartDate').val());
    $('#lblVSASActivitySummaryPrintEligibility').text($('#ViewScriptActivitySummaryForm #lblVSASEligibilityV').text());
    $('#lblVSASActivitySummaryPrintPrgName').text($('#ViewScriptActivitySummaryForm #lblVSASPrgNameV').text());

    if (window.top.$(".InAuthPage").is(":visible")) {
        var PI = window.top.UmPatient_AuthInfo("", "");
        moduleID = 3;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        AuthID = PI.AuthNo;
    }
    else if (window.top.$(".InComplaintPage").is(":visible")) {
        var PI = window.top.AgPatient_ComplaintInfo("", "");
        moduleID = 5;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        ComplaintID = PI.ComplaintId;
    }
    else if ($('#lnkActivitySummaryTab').hasClass('select')) {
        moduleID = 1;
        patientID = $('#selectPatientAccessed').val();
        sectionName = "Activity Summary >> Script Summary >> View >> Grid layout";
    }
    //uhg-3093
    if ($('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html() != undefined && $('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html() != '') {
        $('#trDownloadedInfo').show();
        $('#lblActivitySummaryPrintScriptDownloadedBy').html($('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html());
        $('#lblActivitySummaryPrintScriptDownloadedOn').html($('#ViewScriptActivitySummaryForm #lblScriptDownloadedOn').html());
    }
    else {
        $('#lblActivitySummaryPrintScriptDownloadedBy').html('');
        $('#lblActivitySummaryPrintScriptDownloadedOn').html('');
        $('#trDownloadedInfo').remove();
    }
    //uhg-3093
    //PROD-14937--- Bind QM Fields--Starts
    BindQualityMeasureFields();
    //PROD-14937--- Bind QM Fields--Ends
    //uhg-3343
    if ($('#hdnScriptID').val() != "0" && $('#hdnScriptID').val() != undefined) {
        scriptId = $('#hdnScriptID').val();
        scriptRunLogId = $('#hdnRunLogId').val();
        baseURL = $('#hdnBaseUrl').val(); //"http://localhost:52447";
    }
    //uhg-3343
    $.ajax({
        type: "POST",
        url: baseURL + "/ActivityRecord/PrintActivitySummaryScript?scriptId=" + scriptId + "&scriptRunLogId=" + scriptRunLogId + "&patientId=" + patientID,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                $('#ViewScriptActivitySummaryPrint').show();
                var datalist = PrintActivitySummaryScriptTbl(data.model);
                var $scriptActivitySummaryTemplate = $("#ViewScriptActivitySummaryPrint").clone();
                $scriptActivitySummaryTemplate.find('#ViewScriptActivitySummaryPrinttbl').html(datalist);
                if (data.LogoImage != "")
                    $scriptActivitySummaryTemplate.find('#imgLogoForScript').prop('src', data.LogoImage);
                else
                    $scriptActivitySummaryTemplate.find('#imgLogoForScript').remove();
                PrintPanelMVC($scriptActivitySummaryTemplate.html(), moduleID, patientID, sectionName, AuthID, ComplaintID);
                $('#ViewScriptActivitySummaryPrint').hide();
            }
        },
        error: function (request, status, error) {

        }
    });
});


$(document).off('click', '#btnViewScriptSummaryGridLayoutExportPDF,#btnViewScriptSummaryGridLayoutExport').on('click', '#btnViewScriptSummaryGridLayoutExportPDF,#btnViewScriptSummaryGridLayoutExport', function () {
    var chkdChBx = $('#ViewScriptSummaryExportCLob .clsRdoMemEligMini:checked');
    var objRootLevelValue = $('.clsViewScriptSummaryRootvalue').html().replace(' :', '');
    if (chkdChBx.length > 0) {
        if (CheckIfLetterTemplateConfigured($(chkdChBx).data('lobbenid'), 'Script Response Summary')) {
            var format = '';
            var clickedbtnId = $(this).attr('id');
            if (clickedbtnId == 'btnViewScriptSummaryGridLayoutExport') {
                ActionType = "EXPDOC";
            } else {
                ActionType = "EXPPDF";
            }
            $('#lblActivitySummaryPrintMemIdentifierLabel').html($('#ViewScriptActivitySummaryForm #lblMemberIdentifierLabel').html());
            $('#lblActivitySummaryPrintMemIdentifierValue').html($('#ViewScriptActivitySummaryForm #lblMemberIdentifierValue').html());
            $('#lblActivitySummaryPrintMemberDOB').html($('#ViewScriptActivitySummaryForm #lblMemberDOB').html());
            $('#lblActivitySummaryPrintMemberName').html($('#ViewScriptActivitySummaryForm #lblMemberName').html());
            $('#lblActivitySummaryPrintScriptName').html($('#ViewScriptActivitySummaryForm #lblScriptName').html());
            $('#lblActivitySummaryPrintScriptCompletedBy').html($('#ViewScriptActivitySummaryForm #lblScriptCompletedBy').html());
            $('#lblActivitySummaryPrintScriptCompletedOn').html($('#ViewScriptActivitySummaryForm #lblScriptCompletedOn').html());
            $('#lblActivitySummaryPrintScriptStatus').text($('#ViewScriptActivitySummaryForm #hdfScriptStatus').val());
            $('#lblActivitySummaryPrintCreatedOn').text($('#ViewScriptActivitySummaryForm #hdfScriptStartDate').val());
            $('#lblVSASActivitySummaryPrintEligibility').text($('#ViewScriptActivitySummaryForm #lblVSASEligibilityV').text());
            $('#lblVSASActivitySummaryPrintPrgName').text($('#ViewScriptActivitySummaryForm #lblVSASPrgNameV').text());

            //uhg-3093
            if ($('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html() != undefined && $('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html() != '') {
                $('#trDownloadedInfo').show();
                $('#lblActivitySummaryPrintScriptDownloadedBy').html($('#ViewScriptActivitySummaryForm #lblScriptDownloadedBy').html());
                $('#lblActivitySummaryPrintScriptDownloadedOn').html($('#ViewScriptActivitySummaryForm #lblScriptDownloadedOn').html());
            }
            else {
                $('#lblActivitySummaryPrintScriptDownloadedBy').html('');
                $('#lblActivitySummaryPrintScriptDownloadedOn').html('');
                $('#trDownloadedInfo').remove();
            }
            //PROD-14937--- Bind QM Fields--Starts
            BindQualityMeasureFields();
            //PROD-14937--- Bind QM Fields--Ends

            $.ajax({
                type: "POST",
                url: baseURL + "/ActivityRecord/PrintActivitySummaryScript?scriptId=" + scriptId + "&scriptRunLogId=" + scriptRunLogId,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        var datalist = PrintActivitySummaryScriptTbl(data.model, true);
                        var $scriptActivitySummaryTemplate = $("#ViewScriptActivitySummaryPrint").clone();
                        $scriptActivitySummaryTemplate.find('#ViewScriptActivitySummaryPrinttbl').html(datalist);
                        if (data.LogoImage != "")
                            $scriptActivitySummaryTemplate.find('#imgLogoForScript').prop('src', data.LogoImage);
                        else
                            $scriptActivitySummaryTemplate.find('#imgLogoForScript').remove();
                        var keepColors = "<style>.srpt-tile-container {padding: 0px;} .is_flex {display:flex; width:100%;} .srpt-inside-tile {display: flex; margin-bottom:8px; flex-wrap: wrap;border: 1px solid #cccccc;border-radius: 4px;padding: 4px;page-break-inside: avoid;} .srpt-tile {width:700px; display: flex; flex-direction: column; margin-bottom:8px; border: 1px solid #cccccc;border-radius: 4px;padding: 4px;} .srpt-field-container { width: 29%; padding: 5px; margin-right: 15px; margin-bottom: 5px;} .srpt-field-container label { font-weight: bold; margin-bottom: 5px; width: 100%; page-break-inside: avoid;} .srpt-field-data .tbl {word-break: normal;} table.tbl th, table.tbl tr, table.tbl td {border:1px solid #cccccc; page-break-inside: avoid;} table.tbl td.thead {word-break: normal;} .srpt-field-data{word-break: break-word; -ms-word-break: break-all; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto; white-space: inherit;} body {-webkit-print-color-adjust: exact !important; } table td div {word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: inherit;} @media print{ table { page-break-after:auto } tr{ page-break-after:auto } td { page-break-after:auto } thead { display:table-header-group }  tfoot { display:table-footer-group } table.scriptTbl td {page-break-inside:avoid} }</style>";
                        format = "<html><head><title></title>"+ keepColors +"</head><body>" + $scriptActivitySummaryTemplate.html() + "</body></html>";
                        var datastring = { content: format };
                        $.ajax({
                            type: "POST",
                            url: baseURL + "/ActivityRecord/GetContent",
                            data: datastring,
                            dataType: "json",
                            success: function (data1) {
                                if (data1.success) {
                                    if (IsSmartCommEnabled === "1") {
                                        AjaxCallInit({
                                            url: baseURL + '/Letter/GenerateSystemTemplate',
                                            PostData: {
                                                SysTempParams: 'UniqueId=' + data1.ActivitySummaryContentId,
                                                saveType: ActionType == "PQ" ? 1 : (ActionType == "SPQ" ? 2 : 0),
                                                templateName: "Script Response Summary",
                                                moduleId: gtModId("CM"),
                                                lobbenId: $(chkdChBx).data('lobbenid'),
                                                fileName: 'Script_Response_Summary'
                                            }
                                        }, function (data2) {
                                            var dataRow = data2.ToJson();
                                            if (dataRow.Success) {
                                                SecureBrowserFileDownload.DownloadFile(baseURL, null, "SmartCommDocument", dataRow.Token, null);
                                                AuditLog(1, actionTypeEnum.FileExport, 'Script Summary >> View >> Flow layout', $('#selectPatientAccessed').val(), memberidval, "Script_Response_Summary.pdf");
                                            }
                                            loader(0);
                                        });
                                    }
                                    else {
                                        var parameters = "ModuleId^1|LobBenId^" + $(chkdChBx).data('lobbenid') + "|Action^" + ActionType + "|SectionName^" + 'Script Response Summary' + "|UniqueId^" + data1.ActivitySummaryContentId + "|PatientId^" + $('#selectPatientAccessed').val() + "|isProvider^" + isProvider;
                                        var DataKey = 'GENERATE_BATCH_LETTER';
                                        var route = "BatchLetter/Create?DATA_KEY=" + DataKey;
                                        OpenLetter_DE_Init(route, parameters, false);
                                        var fileName = '';
                                        if (ActionType == "EXPDOC") { fileName = 'Script_Response_Summary.docx' } else { fileName = 'Script_Response_Summary.pdf' }
                                        AuditLog(1, actionTypeEnum.FileExport, 'Script Summary >> View >> Grid layout', $('#selectPatientAccessed').val(), memberidval, fileName);
                                    }
                                }
                            }
                        });
                    }
                },
                error: function (request, status, error) {
                    CustomAlert('Error in Printing the Document');
                }
            });
        }
        else { CmnStatusMessageDisp('ViewScriptSummaryExportErrorMsg', 'Template for the selected ' + objRootLevelValue + ' is not configured. Please contact your administrator.', 'Error'); }
    }
    else {
        CustomAlert('Please select at least one ' + objRootLevelValue + ' record.');
    }
});

$(document).off('click', '#btnViewScriptSummaryFlowLayoutExport,#btnViewScriptSummaryFlowLayoutExportPDF').on('click', '#btnViewScriptSummaryFlowLayoutExport,#btnViewScriptSummaryFlowLayoutExportPDF', function () {
    var chkdChBx = $('#ViewScriptSummaryExportCLob .clsRdoMemEligMini:checked');
    var objRootLevelValue = $('.clsViewScriptSummaryRootvalue').html().replace(' :', '');
    if (chkdChBx.length > 0) {
        if (CheckIfLetterTemplateConfigured($(chkdChBx).data('lobbenid'), 'Script Response Summary')) {
            var format = '';
            var clickedbtnId = $(this).attr('id');
            if (clickedbtnId == ('btnViewScriptSummaryFlowLayoutExport')) {
                ActionType = "EXPDOC";
            } else {
                ActionType = "EXPPDF";
            }
            $.ajax({
                type: "POST",
                url: baseURL + "/ActivityRecord/PrintActivitySummaryScript?scriptId=" + scriptId + "&scriptRunLogId=" + scriptRunLogId + "&printType=" + 2,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        var MemberDetails = data.memberdata;
                        var ScriptResponse = data.model;
                        var memberhtml = FormatMemberDetails(MemberDetails, data.completedOnDate, data.LogoImage, data.downloadedOnDate, data.createdOn, data.scriptStatus, data.memberDOB);
                        var scptresponsehtml = FormatScriptResponse(ScriptResponse,true);
                        format = memberhtml.replace('{DynamicResponse Content}', scptresponsehtml);
                        format = replaceAll('{DynamicResponse Content}', '$', format);
                        var keepColors = "<style>.srpt-tile-container {padding: 0px;} .srpt-tile { margin-bottom:8px; border: 1px solid red;border-radius: 4px;padding: 4px;} .srpt-field-container { width: 29%; padding: 5px; margin-right: 15px; margin-bottom: 5px;} .srpt-field-container label { font-weight: bold; margin-bottom: 5px; width: 100%; page-break-inside: avoid;} .srpt-field-data .tbl {word-break: normal;} table.tbl th, table.tbl tr, table.tbl td {border:1px solid #cccccc; page-break-inside: avoid;} table.tbl td.thead {word-break: normal;} .srpt-field-data{word-break: break-word; -ms-word-break: break-all; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto; white-space: pre-wrap; padding-bottom:10px;} body {-webkit-print-color-adjust: exact !important; } table td div {word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: pre-wrap;} @media print{ table { page-break-after:auto } tr{ page-break-after:auto } td { page-break-after:auto } thead { display:table-header-group }  tfoot { display:table-footer-group } table.scriptTbl td {page-break-inside:avoid} }</style>";
                        var scriptSaveHtml = "<html><head><title></title>" + keepColors + "</head><body>" + format + "</body></html>";
                        var datastring = { content: scriptSaveHtml };
                        $.ajax({
                            type: "POST",
                            url: baseURL + "/ActivityRecord/GetContent",
                            data: datastring,
                            dataType: "json",
                            success: function (data) {
                                if (data.success) {
                                    if (IsSmartCommEnabled === "1") {
                                        AjaxCallInit({
                                            url: baseURL + '/Letter/GenerateSystemTemplate',
                                            PostData: {
                                                //languageId: languageId,
                                                SysTempParams: 'UniqueId=' + data.ActivitySummaryContentId,
                                                saveType: ActionType == "PQ" ? 1 : (ActionType == "SPQ" ? 2 : 0),
                                                templateName: "Script Response Summary",
                                                moduleId: gtModId("CM"),
                                                lobbenId: $(chkdChBx).data('lobbenid'),
                                                fileName: 'Script_Response_Summary'
                                            }
                                        }, function (data) {
                                            var dataRow = data.ToJson()
                                            if (dataRow.Success) {
                                                SecureBrowserFileDownload.DownloadFile(baseURL, null, "SmartCommDocument", dataRow.Token, null);
                                                AuditLog(1, actionTypeEnum.FileExport, 'Script Summary >> View >> Flow layout', $('#selectPatientAccessed').val(), memberidval, "Script_Response_Summary.pdf");
                                            }
                                            loader(0);
                                        });
                                    }
                                    else {
                                        var parameters = "ModuleId^1|LobBenId^" + $(chkdChBx).data('lobbenid') + "|Action^" + ActionType + "|SectionName^" + 'Script Response Summary' + "|UniqueId^" + data.ActivitySummaryContentId + "|PatientId^" + $('#selectPatientAccessed').val();
                                        var DataKey = 'GENERATE_BATCH_LETTER';
                                        var route = "BatchLetter/Create?DATA_KEY=" + DataKey;
                                        OpenLetter_DE_Init(route, parameters, false);
                                        var fileName = '';
                                        if (ActionType == "EXPDOC") { fileName = 'Script_Response_Summary.docx' } else { fileName = 'Script_Response_Summary.pdf' }
                                        AuditLog(1, actionTypeEnum.FileExport, 'Script Summary >> View >> Flow layout', $('#selectPatientAccessed').val(), memberidval, fileName);
                                    }
                                }
                            }
                        });
                    }
                },
                error: function (request, status, error) {
                    CustomAlert('Error in Printing the Document');
                }
            });
        }
        else {
            CmnStatusMessageDisp('ViewScriptSummaryExportErrorMsg', 'Template for the selected ' + objRootLevelValue + ' is not configured. Please contact your administrator.', 'Error');
        }
    }
    else { CustomAlert('Please select at least one ' + objRootLevelValue + ' record.'); }
});


$(document).off('click', '.CMActDelete').on('click', '.CMActDelete', function () {
    if ($(this).attr("id") != undefined) {
        var activityLogId = $(this).attr("id").split("_")[1];
        var isRecurring = $(this).attr('data-recurringId');
        var scheduledDate = $(this).attr('data-scheduleddate');
        var isExternalActivity = $(this).attr('data-isexternalactivity');
        var meetingGuid = $(this).attr('data-meetingguid');
        var patientId = $(this).attr('data-patientid');
        if (isRecurring > 0) {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Calendar/DeleteCMRecurringActivities?activityIds=" + activityLogId + "," + "&scheduledDate=" + scheduledDate + "&recurringId=" + isRecurring + "&patientId=" + patientId,
                onLoad: function () {
                },
                popUpHeader: "Delete Recurring Activity",
                popLevel: 0,
                closeButton: '#btnCMRecurringActivityCancel',
                onClose: function () {
                    $('#popUpDialog1').html('');
                }
            });
        }
        else {
            deleteCalendarAct("CM", activityLogId, "Calendar", isExternalActivity, meetingGuid, patientId);
        }
    }
});

$(document).off('click', '.UMActDelete').on('click', '.UMActDelete', function () {
    if ($(this).attr("id") != undefined) {
        var activityLogId = $(this).attr("id").split("_")[1];
        deleteCalendarAct("UM", activityLogId, "Calendar");
    }
});

$(document).off('click', '.AGActDelete').on('click', '.AGActDelete', function () {
    if ($(this).attr("id") != undefined) {
        var activityLogId = $(this).attr("id").split("_")[1];
        deleteCalendarAct("AG", activityLogId, "Calendar");
    }
});


$(document).off('click', '.MSActDelete').on('click', '.MSActDelete', function () {
    if ($(this).attr("id") != undefined) {
        var isScheduleVisibleDel = $('#popUpGlobalMySchedule').is(':visible');
        var patientFollowUpId = $(this).attr('Id').split('_')[1];
        var patientid = $(this).attr('data-patientid');
        var datastring = { actId: patientFollowUpId, patientId: patientid, module: "MS" };
        var flag = CustomConfirm('Are you sure you want to delete this activity?');
        if (flag) {
            $.ajax({
                type: "POST",
                url: baseURL + "/Dashboard/DeleteActivity",
                data: datastring,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        CustomAlert('Activity has been deleted successfully');
                        if (isScheduleVisibleDel) {
                            var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                            if (currentView == "Week") {
                                $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                                loadGlobalMySchedule();
                            }
                            else {
                                $("#scheduler").data("kendoScheduler").dataSource.read();
                            }
                        }
                        if (!isScheduleVisibleDel && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103 
                            $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                                onLoadMyCalendar();
                            });
                        }
                    }
                    else
                        CustomAlert('Error Encountered.');
                }
            });
        }
    }
});

$(document).off('click', '#btnViewScriptSummaryFlowLayoutPrint').on('click', '#btnViewScriptSummaryFlowLayoutPrint', function () {
    var moduleID = "", patientID = "", sectionName = "", AuthID = "", ComplaintID = "";
    if ($('#hdnScriptID').val() != "0" && $('#hdnScriptID').val() != undefined) {
        scriptId = $('#hdnScriptID').val();
        scriptRunLogId = $('#hdnRunLogId').val();
        baseURL = $('#hdnBaseUrl').val(); //"http://localhost:52447";
    }
    if (window.top.$(".InAuthPage").is(":visible")) {
        var PI = window.top.UmPatient_AuthInfo("", "");
        moduleID = 3;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        AuthID = PI.AuthNo;
    }
    else if (window.top.$(".InComplaintPage").is(":visible")) {
        var PI = window.top.AgPatient_ComplaintInfo("", "");
        moduleID = 5;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        ComplaintID = PI.ComplaintId;
    }
    else if ($('#lnkActivitySummaryTab').hasClass('select')) {
        moduleID = 1;
        patientID = $('#selectPatientAccessed').val();
        sectionName = "Activity Summary >> Script Summary >> View >> Flow layout";
    }
    var format = '';
    $.ajax({
        type: "POST",
        url: baseURL + "/ActivityRecord/PrintActivitySummaryScript?scriptId=" + scriptId + "&scriptRunLogId=" + scriptRunLogId + "&printType=" + 2 + "&patientId=" + patientID,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var MemberDetails = data.memberdata;
                var ScriptResponse = data.model;
                var memberhtml = FormatMemberDetails(MemberDetails, data.completedOnDate, data.LogoImage, data.downloadedOnDate, data.createdOn, data.scriptStatus, data.memberDOB);
                var scptresponsehtml = FormatScriptResponse(ScriptResponse, false);
                format = memberhtml.replace('{DynamicResponse Content}', scptresponsehtml);
                format = replaceAll('{DynamicResponse Content}', '$', format);
                format = unescapeHtml(format);
                PrintPanelMVC(format, moduleID, patientID, sectionName, AuthID, ComplaintID);
            }
        },
        error: function (request, status, error) {
            CustomAlert('Error in Printing the Document');
        }
    });
});

$(document).off('click', '#btnViewScriptSummaryFormLayoutPrint').on('click', '#btnViewScriptSummaryFormLayoutPrint', function () {
    var val = $('#hdnSfpiId').val();
    var formid = val.split('|')[0];
    var sfpiId = val.split('|')[1];
    var ScriptRunLogId = val.split('|')[2];
    if (isFromUmScriptActivity || isFromAgScriptActivity) {
        $('#popUpDialog2').CMNPopup({
            pvUrl: baseURL + "/ScriptForm/ScriptForm?careActivityTypeID=" + $("#ddlCareActivitymvc").val() + "&additionalinfo=" + formid + "|" + sfpiId + "|" + 1 + "|" + ScriptRunLogId,
            onLoad: function () {
                $('#htmlScptForm').attr('style', 'overflow-y: scroll; height: 500px !important');
            },
            onClose: function () {
                $('#popUpDialog2').html('');
            },
            popLevel: 1,
            popUpHeader: "Member Script Form Response Information"
        });
    }
    else {
        CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', formid + "|" + sfpiId + "|" + 1 + "|" + ScriptRunLogId);
    }
});

$(document).off('click', '.ImgClassRA').on('click', '.ImgClassRA', function () {

    var ProgramWorkflowId = $(this).attr('Id').split('_')[1];
    var CareActivityTypeId = $("#imgAddActivity_" + ProgramWorkflowId).data('careactivitytypeid');
    var ScriptId = $("#imgAddActivity_" + ProgramWorkflowId).data('scriptid');
    var patientId = $('#patientIdForToDoList').val();
    //$.ajax({
    //    type: "POST",
    //    url: baseURL + "/Home/CreatePerformActivity?patientId=" + patientId + "&WorkflowId=" + ProgramWorkflowId + "&ActivityTypeId=" + CareActivityTypeId + "&ScriptId=" + ScriptId,
    //    dataType: "json",
    //    asyns: false,
    //    success: function (data) {
    //        if (data.success) {

    //        }
    //    },

    //});

});
// RUN SCRIPT FROM POPULATION HEALTH ---------------START
$(document).off('click', '.ADTNextActDateCls,.IPNextActDateCls').on('click', '.ADTNextActDateCls,.IPNextActDateCls', function () {
    var scriptId = $(this).attr('Id').split('_')[1];
    var patientid = $(this).attr('Id').split('_')[2];
    var activityTypeId = $(this).attr('Id').split('_')[3];
    var programWorkFlowId = $(this).attr('Id').split('_')[4];
    var runScriptLogId = $(this).attr('Id').split('_')[5];
    var refId = $(this).attr('Id').split('_')[6];
    var refType = $(this).attr('data-reftype');
    var activityName = $(this).attr('data-activityname');
    var patientfollowupId = $(this).attr('data-patientfollowupId');
    var dueDate = $(this).attr('data-dueDate');
    var scriptFormId = 0;
    $('#refIdAndTypeOfAdtorIpGrid').val('');
    if ($('#refIdAndTypeOfAdtorIpGrid').length > 0)
        $('#refIdAndTypeOfAdtorIpGrid').val(refId + ',' + refType + ',' + patientid);

    loader(1);
    $.ajax({ //PROD-12752
        type: "GET",
        url: baseURL + "/Config/CheckIfActivityPerformed?progWorkflowId=" + programWorkFlowId + "&reqActPatientId=" + patientid + "&initiateCheck=1",
        dataType: "json",
        success: function (data) {
            if (data.result == 1) {
                loader(0);
                CustomAlert("You cannot perform this activity as this activity is being performed by another care staff.");
            }
            else {
                if (patientfollowupId > 0) {
                    completesetactivity(patientfollowupId + "_" + scriptId + "_" + scriptFormId + "_" + patientid + "_" + "CM Thumb", 0, 0);
                }
                else {
                    var obj = { patientId: patientid, workflowId: programWorkFlowId, activityTypeId: activityTypeId, dueDate: dueDate, scriptId: scriptId };
                    $.ajax({
                        type: "GET",
                        url: baseURL + "/ClinicalPrograms/InsertCMReqActinPF",
                        data: obj,
                        dataType: "json",
                        success: function (data) {
                            if (data.success) {
                                var patientFollowupId = data.PFID;
                                var scriptFormId = data.SFID;
                                $("#hdnProgramWorkflowId").val(programWorkFlowId);
                                completesetactivity(patientFollowupId + "_" + scriptId + "_" + scriptFormId + "_" + patientid + "_" + "CM Thumb", 0, 0);
                            }
                            loader(0);
                        },
                        error: function (error) {
                            loader(0);
                        }
                    });
                }
            }
        },
        error: function () { loader(0); }
    });

    VarPHIsValid = true;
});

$(document).off('click', '#btnCPMyMemberRefresh').on('click', '#btnCPMyMemberRefresh', function () {
    $('#txtSearchTextCPMyMember').val('');
    $('#selectMymbembersteam').val(buildctrl == "Index" ? 1 : 0);
    globalCaseLoadFilter = $('#selectMymbembersteam').val();
    $("#selectMymbembersteam").prop("disabled", false);
    $('#ddlCPMyMembersSearchBy').val(-1);
    $('#ddlClientCP').val(-1);

    $('#memberGrid .divClsMemberMenu').hide();
    DBMemberDetailsLoad(2, "panelLeft");
});

$(document).off('click', '#btnPrintServicePlan,#btnAppPrintServicePlan').on('click', '#btnPrintServicePlan,#btnAppPrintServicePlan', function () {
    var btnAttrId = $(this).attr('Id'); var chkdChBx = ''; var ServiceId = "";
    if (btnAttrId == 'btnPrintServicePlan') {
        chkdChBx = $('#ServicePlan .clschkServicePlan:checked');
    }
    else {
        chkdChBx = $('#AppServicePlan .clschkAppServicePlan:checked');
    }
    $.each(chkdChBx, function (key, item) {
        if ($(item).is(':checked')) {
            ServiceId += $(item).data('memberserviceidnavvals') + ",";
        }
    });
    if (ServiceId != "") {
        ServiceId = ServiceId.substring(0, ServiceId.length - 1);
        var params = {
            serviceIds: ServiceId,
            MemberId: $('#selectPatientAccessed').val(),
            ddlMembPlanType: ($("#selectEpisodeAccessed").val() == undefined ? "0" : $("#selectEpisodeAccessed").val()),
            TimeDictionaryobj: timeZone
        }
        $.ajax({
            type: "POST",
            url: baseURL + "/CarePlan/PrintServicePlan",
            data: params,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    var ServicePlanPrintData = ServiceplanPrintfunct(data.PrintData, data.DateOfPrint, data.imagePath);
                    var strHeader = " <table style='width: 100%; border-right: none; border-left: none; border-bottom: none; border-top: none;'><thead><tr><td>" + data.imagePath + "</td></tr></thead><tr><td>";
                    var strheaderEnd = "</td></tr></table>";
                    ServicePlanPrintData = strHeader + ServicePlanPrintData + strheaderEnd;
                    $('#ServicePlanDivContent').AhsSetHtml(ServicePlanPrintData);
                    $('#ServicePlanPrintDiv').CMNPopup({
                        onLoad: function () {
                            A11yModal.trapFocusInModal('ServicePlanDivContent');
                        },
                        popUpHeader: "Print Service Plan",
                        popLevel: 1,
                        onClose: function () {
                            $('#ServicePlanDivContent').html('');
                            chkdChBx.prop('checked', false);
                        },
                        closeButton: '#btnServicePlanPrintCancel'
                    });
                }
                else {
                    CustomAlert('Error Occured');
                }
            },
            error: function (request, status, error) {

            }
        });
    }
    else
        CustomAlert("Please select required Service Plan records to print.");
});

$(document).off('click', '#btnSignServicePlan').on('click', '#btnSignServicePlan', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Common/GlobalSignature",
        popUpHeader: "Add Signature",
        onLoad: function () {
            DrawSignOnCanvas('imgSignServicePlan');
            $('#popUpDialog2').width(645);
        },
        onClose: function () {
            if ($('#ServicePlanPrintDiv').is(':visible')) {
                A11yModal.trapFocusInModal('ServicePlanPrintDiv');
            }
        },
        popLevel: 2,
        closeButton: '#btnSignClose',
    });
});

$(document).off('click', '#btnSignServicePlanCS').on('click', '#btnSignServicePlanCS', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Common/GlobalSignature",
        popUpHeader: "Add Signature",
        onLoad: function () {
            $('#hdnSection').val('CareStaff_Signature_Serviceplan');
            DrawSignOnCanvas('imgSignServicePlanCS');
            $('#popUpDialog2').width(645);
        },
        onClose: function () {
        },
        popLevel: 2,
        closeButton: '#btnSignClose',
    });
});

//Remove signature
$(document).off('click', '.RemoveClickCls').on('click', '.RemoveClickCls', function () {
    var carePlanSignatureId = $(this).data('careplansignatureid');
    var url = baseURL + '/CarePlan/DeleteSignature';
    $.ajax({
        type: "POST",
        url: url,
        data: JSON.stringify({ patientId: $('#selectPatientAccessed').val(), carePlanSignatureId: carePlanSignatureId }),
        contentType: "application/json",
        success: function (data) {
            if (data.success) {
                arrSignature = arrSignature.filter(function (item) {
                    return item.CarePlanSignatureId !== carePlanSignatureId.toString();
                });
                SignatureGridBind();
                CustomAlert("Signature removed successfully.");
            }
            else {
                CustomAlert(data.msg);
            }
        }
    });
});

//Add signature popup
$(document).off('click', '#AddClick').on('click', '#AddClick', function () {
    $('#popUpDialog3').CMNPopup({
        pvUrl: baseURL + "/Common/GlobalSignature?FullCarePlan=true",
        popUpHeader: "Add Signature",
        popLevel: 3,
        closeButton: '#btnSignClose',
        modalWidth: MODAL_WIDTH.LARGE,
        onClose: function () {
            if ($('#popUpDialog2').is(':visible')) {
                A11yModal.trapFocusInModal('popUpDialog2');
            }
        }
    });
});
$(document).off('click', '#btnServicePlanPrint').on('click', '#btnServicePlanPrint', function () {
    var imgData = $('#imgSignServicePlan').attr('src');//imgUnitedLogo
    if (imgData != "" && $('#imgSignServicePlanCS').attr('src') != "") {
        imgData += '§' + $('#imgSignServicePlanCS').attr('src');
    }
    else {
        imgData += $('#imgSignServicePlanCS').attr('src');
    }
    var imgDataCS = $('#imgSignServicePlanCS').attr('src');//imgUnitedLogoCS
    var servicePlanHtml = $('#ServicePlanDivContent').html() || "";
    var dataStr = {
        HtmlData: "<html><body>" + servicePlanHtml + "</body></html>",
        ImageData: imgData,
        PatientId: $("#selectPatientAccessed").val()
    };

    $.ajax({
        type: "POST",
        url: baseURL + "/ServicePlan/ServicePlanSavePdf",
        dataType: "json",
        data: dataStr,
        async: false,
        success: function (data) {
            if (data.success) {
                CustomAlert("Service plan saved to documents successfully.");
                $('#btnServicePlanPrintCancel').trigger('click');
            }
            else {
                CustomAlert('Error Occured');
            }
        },
        error: function (request, status, error) {

        }
    });
    PrintPanelMVC(servicePlanHtml, 1, $("#selectPatientAccessed").val(), 'Care Plan >> Service Plan');
});

$(document).off('click', '.cplTermchild').on('click', '.cplTermchild', function () {
    var lblCrplMtmInterName = 'Care Plan'; var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; lblCrplMtmInterName = 'MTM Intervention'; }
    var currentCareplanTermDetails = $(this).data('details');
    var id = '0', carePlanTermId = '0';
    if (currentCareplanTermDetails != null && currentCareplanTermDetails != '') {
        id = currentCareplanTermDetails.split('_')[0];
        carePlanTermId = currentCareplanTermDetails.split('_')[1];
    }
    $('#hMenGdCP, .clsTmCrPlInlineContextMenu').hide();
    $('#popUpDialog3').CMNPopup({
        pvUrl: baseURL + "/CarePlan/ChangeCarePlanTerm/?carePlanIds= " + id + "&isMtmIntervention=" + isMtmIntervention + "&isFrom=" + true + '&carePlanTermId=' + carePlanTermId,
        onLoad: function () {
            $('#hdnstatusCarePlanIds').val(id);
        },
        closeButton: '#btnMngeTermPopUpclose',
        onClose: function () {
            btnCPOExpandAllRowsClick('#btnCPOExpandAllRows');
        },
        popUpHeader: "Change Term",
        popLevel: 3
    });
    $("#ddlManagePriority option:contains(" + this.innerHTML + ")").attr('selected', 'selected');

});

$(document).off('click', '#btnCrPlTerm').on('click', '#btnCrPlTerm', function () {
    var lblCrplMtmInterName = 'Care Plan'; var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; lblCrplMtmInterName = 'MTM Intervention'; }
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;
    var carePlanId = '';
    var carePlanTerm = '';
    var carePlanName = '';
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    $.each(chkBxChd, function (key, item) {
        if ($(item).is(':checked')) {
            carePlanId += $(item).attr('Id').split('_')[1] + ",";
            carePlanTerm += $(item).parent().siblings().children('a#lnkbtncplTerm').text() + ",";
        }
    });
    if (chkBxChd.length >= 1) {
        carePlanId = carePlanId.replace(/,(?=[^,]*$)/, '');
        var customMessage = 'Are you sure you want to change the "term" on the selected ' + chkBxChd.length + ' ' + lblCrplMtmInterName + (chkBxChd.length == 1 ? ' item' : ' items') + '? ';
        var Flg = CustomConfirm(customMessage);
        if (Flg) {
            $('#popUpDialog3').CMNPopup({
                pvUrl: baseURL + "/CarePlan/ChangeCarePlanTerm/?carePlanIds= " + carePlanId + "&isMtmIntervention=" + isMtmIntervention + "&isFrom=" + false + "&carePlanTerm=" + carePlanTerm,
                onLoad: function () {
                    var statusMessage = 'You have selected ' + chkBxChd.length + ' ' + lblCrplMtmInterName + ' records to change the term';
                    $('#statusValidationMessage').html(statusMessage);
                    $('#hdnstatusCarePlanIds').val(carePlanId);
                },
                closeButton: '#btnMngeTermPopUpclose',
                onClose: function () { btnCPOExpandAllRowsClick('#btnCPOExpandAllRows'); },
                popUpHeader: "Change Term",
                popLevel: 3
            });
        }
        else {
            chkBxChd.attr('checked', false);
            if ($('#chkAllCarePlans').is(':checked')) {
                $(".clsChkCrPlTmCrPlGrid").trigger("change");
            }
        }
    }
    else
        CustomAlert('Please select atleast one ' + lblCrplMtmInterName + ' to change term.');
});

$(document).off('click', '#btnCrPlTmCrPlChangeStatus').on('click', '#btnCrPlTmCrPlChangeStatus', function () {
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    var lblCrplMtmInterName = 'Care Plan'; var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; lblCrplMtmInterName = 'MTM Intervention'; }
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;
    var $catName = $.trim($(chkBxChd[0]).data('catname')).toUpperCase();
    var carePlanId = '';
    var oppName = '';
    var Startdates = [];
    $.each(chkBxChd, function (key, item) {
        if ($(item).is(':checked')) {
            carePlanId += $(item).attr('Id').split('_')[1] + ",";
            Startdates.push(new Date($(item).data('startdate')));
        }
    });
    var maxstartDate = new Date(Math.max.apply(null, Startdates)).toLocaleDateString('en-us');
    if (chkBxChd.length >= 1) {
        carePlanId = carePlanId.replace(/,(?=[^,]*$)/, '');
        if (chkBxChd.length == 1) {
            oppName = $.trim($(chkBxChd[0]).data('oppname'));
        }
        var Flg = CustomConfirm('Are you sure you want to change status of selected ' + chkBxChd.length + ' ' + lblCrplMtmInterName + ' item(s)?');
        if (Flg) {
            $('#popUpDialog3').CMNPopup({
                pvUrl: baseURL + "/CarePlan/ChangeStatus/?carePlanIds= " + carePlanId + "&opportunityName=" + oppName + "&isMtmIntervention=" + isMtmIntervention + "&planStartDate=" + maxstartDate,
                onLoad: function () {
                    var statusMessage = 'You have selected ' + chkBxChd.length + ' ' + lblCrplMtmInterName + ' records to change the status';
                    $('#statusValidationMessage').html(statusMessage);
                    $('#statusCarePlanIds').val(carePlanId);
                },
                closeButton: '#btnMngeStatusPopUpclose',
                popUpHeader: "Change Status",
                popLevel: 3,
            });
        }
        else {
            chkBxChd.attr('checked', false);
            $('#chkAllCarePlans').attr('checked', false);
        }
    }
    else
        CustomAlert('Please select atleast one ' + lblCrplMtmInterName + ' to change status.');
});

$(document).off('click', '#btnMngeStatusSave').on('click', '#btnMngeStatusSave', function () {
    var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; }
    var endDate = $('#txtChangeEndDate').val();
    var isEndDateRequired = $('#trEndDate').is(':visible') && window.isOpportunityEndDateMandatory === true;
    var formattedDate = new Date(new Date(endDate).toLocaleDateString('en-us'));
    var startDate = new Date($('#txtChangeStartDate').val());
    var isValid = true;
    if (isEndDateRequired && endDate === '') {
        A11yForms.showFormFieldError('endDateValidationMessage', 'End Date is required to complete this action.');
        isValid = false;
    }
    if (endDate && formattedDate.toString() === "Invalid Date") {
        A11yForms.showFormFieldError('endDateValidationMessage', 'End Date is not valid');
        $('#txtChangeEndDate').val('');
        isValid = false;
    }
    if (endDate !== '' && formattedDate < startDate) {
        A11yForms.showFormFieldError('endDateValidationMessage', 'End Date cannot be less than the Start Date');
        isValid = false;
    }
    if (ValidateChangeCarePlanStatus() && isValid) {
        loader(1);
        $('#btnMngeStatusSave').attr('disabled', true);
        var dataString = { memberId: $('#selectPatientAccessed').val(), carePlanIds: $('#statusCarePlanIds').val(), statusId: $('#ddlManageStatus').val(), Notes: $('#txtChangeStatusNotes').val(), EndDate: $('#txtChangeEndDate').val(), OppName: $('#hdnOpportunityName').val(), NoteConfidentialTypeId: $('input[name=rdoselectChangeStatusConfidentialType]:checked').val() === undefined ? 1 : $('input[name=rdoselectChangeStatusConfidentialType]:checked').val() };
        $.ajax({
            url: baseURL + "/CarePlan/UpdateBulkStatus?isMtmIntervention=" + isMtmIntervention,
            data: JSON.stringify(dataString),
            contentType: "application/json",
            type: "POST",
            success: function (result) {
                loader(0);
                $('#btnMngeStatusSave').removeAttr('disabled');
                if (!result.success) {
                    if (result.Message === 'End Date is required to complete this action.') {
                        A11yForms.showFormFieldError('endDateValidationMessage', result.Message);
                    }
                    return;
                }
                $("#btnMngeStatusPopUpclose").trigger("click");
                if (result.StatusResult > 0) {
                    var url = baseURL + "/CarePlan/ResolveGuidingOpportunityFromTCP?CareOpportunityId=" + result.StatusResult
                    $("#popUpDialog2").html('');
                    $('#popUpDialog2').CMNPopup({
                        pvUrl: url,
                        onLoad: function () {
                        },
                        popUpHeader: "Resolve",
                        popLevel: 1
                    });
                }
                else {
                    commonIconStyleStatusMsgDisplay('CarePlanSuccessMessage', 'Status updated successfully.', 3000);
                }
                gridShowHideCarePlan(true, false);
            },
            error: function () {
                loader(0);
                $('#btnMngeStatusSave').removeAttr('disabled');
            }
        });
    }
});

$(document).off('click', '#btnMngePrioritySave').on('click', '#btnMngePrioritySave', function () {
    if (validateChangeCarePlanPriority()) {
        loader(1);
        $('#btnMngePrioritySave').attr('disabled', true);
        var dataString = { memberId: $('#selectPatientAccessed').val(), carePlanIds: $('#statusCarePlanIds').val(), priorityId: $('#ddlChangePriority').val() };
        $.ajax({
            url: baseURL + "/CarePlan/UpdateBulkPriority",
            data: JSON.stringify(dataString),
            contentType: "application/json",
            type: "POST",
            success: function () {
                loader(0);
                $('#btnMngePrioritySave').removeAttr('disabled');
                $("#btnMngePriorityPopUpclose").trigger("click");
                commonIconStyleStatusMsgDisplay('CarePlanSuccessMessage', 'Priority updated successfully.', 3000);
                gridShowHideCarePlan(true, false);
            },
            error: function () {
                loader(0);
                $('#btnMngePrioritySave').removeAttr('disabled');
            }
        });
    }
});


$(document).off('click', '#btnMemexpndClick').on('click', '#btnMemexpndClick', function () {
    CallCshtmlCtrls("/Dashboard/MyCareMembers");
});

$(document).off('click', '#btnShowcolumns').on('click', '#btnShowcolumns', function () {
    UpdateCareMemberGridColumnDropdown(function (val) {
        if (val) {
            var columns = $("#grdMyTeamMembers").data("kendoGrid").columns;
            var sortField = $("#grdMyTeamMembers").data("kendoGrid").dataSource.sort()[0].field;
            var isDefaultSort = false;
            $.each(columns, function () {
                if (this.field === sortField && this.hidden) {
                    isDefaultSort = true;
                }
            });
            if (isDefaultSort) {
                //Applying default sort if configured column is hidden
                $('#grdMyTeamMembers').data("kendoGrid").dataSource.sort({
                    field: "LastName",
                    dir: "asc"
                });
            }
            else {
                $('#grdMyTeamMembers').data("kendoGrid").dataSource.read();
            }
        }
    });

});

$(document).off('click', '#btnSaveFilter').on('click', '#btnSaveFilter', function () {
    var filterselected = $("#ddlSavedfilters option:selected").val();
    var filtercolums = $('#ddlDynaColumnIdhdn').val();
    $('#txtfilterName').val('');
    if (!filtercolums) {
        CustomAlert("Select columns for filter.");
        return false;
    }
    if (filterselected !== '-1') {
        $('#lblfltrUpdateMessage').text('');
        $('#chkUpdateShowcolumns').prop('checked', true);
        $('#txtUpdatefilterName').val($("#ddlSavedfilters option:selected").text());
        $('#alrtUpdatefilter').CMNPopup({
            popUpHeader: "Update Filter",
            popLevel: 2,
            closeButton: '#btnUpdateFilterPopUpclose',
            onClose: function () {
            }
        });
    }
    else {
        $('#chkSaveShowcolumns').prop('checked', true);
        $('#lblfltrMessage').text('');
        $('#alrtsavefilter').CMNPopup({
            popUpHeader: "Save Filter",
            popLevel: 2,
            closeButton: '#btnSaveFilterPopUpclose',
            onClose: function () {
            }
        });
    }
});

$(document).off('keydown', '.mask').on('keydown', '.mask', function () {
    $('.mask').keydown(function () {
        PhoneNumberBefore = $(this).val();
    });
});

$(document).off('keyup', '.mask').on('keyup', '.mask', function () {
    $('.mask').keyup(function () {
        var PhoneNumber = $(this).val();
        if ((PhoneNumber.length == 3 || PhoneNumber.length == 7)) {
            if (PhoneNumberBefore.length < PhoneNumber.length) {
                PhoneNumber += "-";
                $(this).val(PhoneNumber);
            }
        }
    });
});

$(document).off('keyup propertychange change', '.PhoneFormat').on('keyup propertychange change', '.PhoneFormat', function (e) {
    var obj = $(this);
    var code = e.keyCode || e.which;

    if (code !== 8 && code !== 46) {
        var value = obj.val().replace(/\D/g, '').slice(0, 10);
        obj.val(formatFaxAndPhoneNumber(value));
    }
});


function formatFaxAndPhoneNumber(value) {
    var formatted = '';
    if (value.length > 0) {
        formatted = value.replace(/(\d{3})(\d{0,3})(\d{0,4})/, function (_, p1, p2, p3) {
            return [p1, p2, p3].filter(Boolean).join('-');
        });
    }
    return formatted;
}

/*PROD-162*/
$(document).off('keyup propertychange change', '.ZipFormat').on('keyup propertychange change', '.ZipFormat', function (e) {
    var code = e.keyCode || e.which;

    var obj = $(this);

    var value = obj.val().replace(/\D/g, "");
    var val = "";
    if (code !== 8) {
        if (value.length > 5) {
            val = value.substr(0, 5) + '-';
            val += value.substr(5, 4);
            val = val.length > 10 ? val.substring(0, 10) : val;
        }
        else {
            val = value;
        }
        obj.val(val);
    }
});

$(document).off('keyup propertychange change', '.MilesFormat,.MilesZipFormat').on('keyup propertychange change', '.MilesFormat,.MilesZipFormat', function (e) {
    var code = e.keyCode || e.which;
    var obj = $(this);

    var val = "";
    if (obj.hasClass('MilesZipFormat')) {
        var value = obj.val().replace(/\D/g, "");

        if (value.length > 4) {
            $(".MilesFormat").attr('disabled', false);
        }
        else {
            $(".MilesFormat").attr('disabled', true);
            $(".MilesFormat").val('');
        }
        if (code !== 8) {

            if (value.length > 5) {
                val = value.substr(0, 5) + '-';
                val += value.substr(5,4);
            }
            else {
                val = value;
            }
            obj.val(val);
        }
    }
    else {
        var value = obj.val();
        if (e.keyCode != 8) {
            if (value.indexOf(".") > -1) {
                var intVal = value.split('.');

                if (intVal.length == 3) {
                    val = intVal[0] + '.';
                }
                else {
                    val = value;
                }

                if (intVal[1].length == 2) {
                    $(this).attr('maxlength', (intVal[0].length + intVal[1].length + 1));
                }
            }
            else if (value.length > 2) {
                $(this).attr('maxlength', 5);
                val = value.substr(0, 2) + '.';
                val += value.substr(2);
            }
            else {
                $(this).attr('maxlength', 5);
                val = value;
            }

            val = val.length = 6 ? val.substr(0, 5) : val;
            obj.val(val);
        }
    }
});

//uhc-144
$(document).off('click', '[id=imgbtnAlertMessage]').on('click', '[id=imgbtnAlertMessage]', function () {
    isCountClicked = true;
    var msgData = { ActiveInactiveMemberFilter: (isProvider || PHNavID == "1") ? ActiveInactiveMemberFilter : 2 };
    $.ajax({
        type: "GET",
        url: baseURL + "/Home/RefreshMessageAlert",
        dataType: "json",
        data: msgData,
        success: function (data) {
            //if (Data.success)
            $('#imgbtnAlertMessage').val(data.msgCount).attr('aria-label', data.msgCount + ' unread messages, click to refresh');
            $('#MainDiv #divimgbtnAlertMessage').removeClass('ImgDisable');
            isCountClicked = false;
        },
        error: function () {
            loader(0);
        }
    });
});

/*PROD-162*/
var IconsCount = 0;
var IconsIds = '';
(function ($) {
    $.fn.ApplyRoleConfig = function (opt) {
        var element = this;

        if (roleConfig == null || roleConfig.length == 0) {
            // IsIcon value should be false for all configurations except the icons(Alerts, Indicators, Diseases, Analytics, Search only) in PH My Members section
            if (opt.DefaultHide != undefined && opt.DefaultHide) {
                applyEleAttributes(element, opt);
                if (opt.IsRemoveElement)
                    element.remove();
            }
            if (opt.IsIcon) {
                IconsCount++;
                element.attr('IconNo', IconsCount);
                IconsIds += opt.Id + '|||';
            }
            return;
        }
        else {
            var item = $.greproleext(roleConfig, function (ele, _ind) {
                return ele.UniqueName === opt.UniqueName;
            });
            if (item.length > 0) {
                switch (opt.IsFrom) {
                    case "Add":
                        if (item[0].IsAdd == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Edit":
                        if (item[0].IsEdit == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Delete":
                        if (item[0].IsDelete == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Download":
                        if (item[0].IsExport == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Export":
                        if (item[0].IsExport == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Print":
                        if (item[0].IsPrint == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "Email":
                        if (item[0].IsEmail == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "ActInAct":
                        if (item[0].IsEdit == false) {
                            applyEleAttributes(element, opt);
                        }
                        break;
                    case "View":
                        if (item[0].IsView == false) {
                            if (opt.IsRemoveElement) {
                                element.hide();
                            } else {
                                applyEleAttributes(element, opt)
                            }
                        } else if (opt.IsIcon) {  // IsIcon value should be false for all configurations except the icons(Alerts, Indicators, Diseases, Analytics, Search only) in PH My Members section
                            IconsCount++;
                            element.attr('IconNo', IconsCount);
                            IconsIds += opt.Id + '|||';
                        }
                        break;
                    default:
                        if (item[0].IsView == false && (opt.IsFrom == undefined || opt.IsRemoveElement)) {
                            element.remove();
                        }
                        break;
                }
            }
            else {
                if (opt.DefaultHide != undefined && opt.DefaultHide) {
                    applyEleAttributes(element, opt);
                    if (opt.IsRemoveElement)
                        element.remove();
                }
                // IsIcon value should be false for all configurations except the icons(Alerts, Indicators, Diseases, Analytics, Search only) in PH My Members section
                if (opt.IsIcon) {
                    IconsCount++;
                    element.attr('IconNo', IconsCount);
                    IconsIds += opt.Id + '|||';
                }
            }
        }
    };
})(jQuery);

$('body').on('touchstart', function (e) {
    //ph-184  

    var currentid = e.target.id;
    $('.dropdowncls').each(function () {
        if ($(this).attr('id') != currentid.substring(0, currentid.length - 3)) {
            $(this).find(".dropcheck").hide();
        }
    });
    //if (!e.target.id.startsWith("ddlCareorganization") && !e.target.id.startsWith("ddlQualityMeasureFields") && !e.target.id.startsWith("ddlADTFields")) {
    //    $(".dropcheck").hide();
    //}
    //ph-176
    $('#divFiltercriteriaMyMembers').hide();
    if (e.target.id === "divFiltercriteriaMyMembers" || e.target.id === "divContentFiltercriteriaMyMembers") {
        var pos = $("#hoverFiltercriteria").offset();
        $('#divFiltercriteriaMyMembers').show().css('left', (pos.left) - 8 + "px").css('top', pos.top - 4 + "px");
        FilterCriteriaShow();
    }
    //ph-188
    if (!e.target.id.startsWith("GearIconCls") && !e.target.id.startsWith("divMemberMenuQMViewSummary") && !e.target.id.startsWith("divQMAddActivity") && !e.target.id.startsWith("divQMAddAppointment") && !e.target.id.startsWith("divQMAppointmentHistory") && !e.target.id.startsWith("divQMMenuToDoList") && !e.target.id.startsWith("divQMMenuSendMsg") && !e.target.id.startsWith("divQMViewNotes")) {
        // if (!e.target.id.startsWith("GearIconCls") && !e.target.id.startsWith("divMemberMenuQMViewSummary")) {
        $('#divMemberMenu').fadeOut("slow");
        $('#divQualityMeasureMenu').fadeOut("slow");
        //alert($('#divQualityMeasureMenu'));
        $("#divADTMenu").fadeOut("slow");
        $('#divADTIpMenu').fadeOut("slow");
        $('#gridQM .GearIconClshover').removeClass('GearIconClshover');
        $('.GearIconClshover').removeClass('GearIconClshover');
    }
});

$("body").off("click", ".AGEdit").on("click", ".AGEdit", function () {
    if ($(this).attr("id").split('_')[2] === "Open" || $(this).attr("id").split('_')[2] === "Pending") {
        loader(1);
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/AGComplaint/OpenEditAgActivity?ComplaintNo=" + $(this).attr("id").split('_')[3] + "&ActID=" + $(this).attr("id").split('_')[1],
            onLoad: function () {
                onLoadActivityStatus();
            },
            popUpHeader: "Ag Activity",
            popLevel: 0,
            closeButton: '#closebutton'
        });
        loader(0);
    }
    else { CustomAlert("The Complaint is closed"); }

});

$("body").off("click", ".AGRun").on("click", ".AGRun", function () {
    if (isNewAgMdrReview) {
        let data = $(this).attr("id").split('_');
        let compRecordId = data[3];
        let actId = data[1];
        let parentActId = "";
        let levelId = $(this).data('levelid');
        let patientId = $(this).data('patientid');
        closeGlobalCalenderPopup();
        ClickFireComplaintId(compRecordId, patientId, actId + '|' + parentActId + '|' + levelId);
    } else {
        performComplaintActivity($(this).attr("id").split('_')[1], 1);
    }
});

$(document).off('click', '#btnCrPlTmCrPlAddBarrier').on('click', '#btnCrPlTmCrPlAddBarrier', function () {
    ShowCplMultiView('BARRIER');
});
$(document).off('click', '#btnCrPlTmCrPlAddStrengths').on('click', '#btnCrPlTmCrPlAddStrengths', function () {
    ShowCplMultiView('STRENGTHS');
});
$(document).off('click', '#btnCrPlTmCrPlNotes').on('click', '#btnCrPlTmCrPlNotes', function () {
    $('#hdnCrPlTmCrPlEditCrPlId').val("");
    ShowCplMultiView('CplNotes');
});
$(document).off('click', '#btnCrPlTmCrPlActivityHistory').on('click', '#btnCrPlTmCrPlActivityHistory', function () {
    ShowCplMultiView('ActHistory');
});
$(document).off('click', '#btnCrPlTmCrPlAppointmentDetails').on('click', '#btnCrPlTmCrPlAppointmentDetails', function () {
    ShowCplMultiView('AppDetails');
});
$(document).off('click', '#btnCrPlTmCrPlMultiView').on('click', '#btnCrPlTmCrPlMultiView', function () {
    ShowCplMultiView('View');
});

$(document).off('click', '#btnCrPlTmCrPlCarePlanHistory,#btnCrPlTmCrPlHistoryDetails').on('click', '#btnCrPlTmCrPlCarePlanHistory,#btnCrPlTmCrPlHistoryDetails', function () {
    //chkBxChd = $(".clsChkCrPlTmCrPlGrid:checked");
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    if (chkBxChd.length == 1) {
        $('#hdnCrPlTmCrPlHisCrPlId').val($(chkBxChd[0]).attr('id').split('_')[1]);
        $('#popUpDialog2').CMNPopup({
            pvUrl: baseURL + "/CarePlan/CarePlanHistory",
            popUpHeader: "Care Plan History",
            popLevel: 2,
            triggerBtnId: $('#popUpDialog1').is(':visible') ? 'popUpDialog1' : undefined
        });
    }
    else
        CustomAlert('Please select one record for History.');
});


$(document).off('click', '#btnReqRejAckRRjMAL').on('click', '#btnReqRejAckRRjMAL', function () {
    if (!$(this).hasClass("ReqRecAck")) { return false; }
    var selChkBx = $('#ReqRejGridMAL').find('input[type="checkbox"]:checked.clsRejectedChkMember');
    var appIds = ""
    $.each(selChkBx, function (key, item) {
        if ($(item).is(':checked')) {
            appIds += $(item).attr('Id').split('_')[1] + ",";
        }
    });
    if (appIds == "") {
        CustomAlert('Please select at least one record');
    }

    else {
        appIds = appIds.substr(0, appIds.length - 1);
        $.ajax({
            type: "GET",
            url: baseURL + "/RequestRejectedDashboard/UpdateAppStatusAck",
            dataType: "json",
            data: {
                'careStaffId': getMemberId().MemberId,
                'appIds': appIds,
                'ackFlag': true
            },
            success: function (data) {
                if (data.success) {
                    $('#btnRequestRejectedSearchMAL').trigger('click');
                }
            }
        });
    }
});

$(document).off('click', '#btnOpenAuthorizationSearchMAL').on('click', '#btnOpenAuthorizationSearchMAL', function () {
    if ($("#txtOpenAuthorizationFormDateMAL").val() != "" && $("#txtOpenAuthorizationToDateMAL").val() != "") {
        if (!validateStartEndDates($("#txtOpenAuthorizationFormDateMAL").val(), $("#txtOpenAuthorizationToDateMAL").val()))
            return false;
    }
    //k//var dataParams = OpenAuthorizationMALParameters();
    var grid = $('#OpenAuthorizationMAL').data('kendoGrid');
    grid.dataSource.sort([]);
    grid.dataSource.page(1);
    //grid.refresh();
});
$(document).off('click', '.ReqRecAcceptMAL,.divClsMemberMenuAcceptMAL').on('click', '.ReqRecAcceptMAL,.divClsMemberMenuAcceptMAL', function () {
    loader(1);
    var listCheckBox = $('#ReqRecGridMAL .clsRefralChkMember:checked');
    var listReferenceId = "";
    var listPatientFollowupId = "";
    var listPatientId = "";
    var listIsActTransfer = "";
    if (listCheckBox.length <= 0) {
        CustomAlert('Please select at least one record');
        $('.clsRefralChkMembercol').prop('checked', false);
        loader(0);
        return false;
    }

    if (requestReferTypeMALGlobal == "Member") {
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
                listIsActTransfer += $(item).data('isacttransfer') + ",";
            }
        });
        $('#ReqRecGridMAL .clsRefralChkMember').prop('checked', false);
        if (listCheckBox.length <= 0 && $('#divMemberMenuRefralMAL_').is(':visible') === true) {
            listReferenceId += $('#divMemberMenuRefral_').attr('data-id') + ",";
            listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
            listIsActTransfer += $('#divMemberMenuRefral_').attr('data-IsActTransfer') + ",";
        }
        if (listIsActTransfer != "")
            listIsActTransfer = listIsActTransfer.substr(0, listIsActTransfer.length - 1);
        $("#hdnReferenceIds").val(listReferenceId);
        $("#hdnPatientIdRR").val(listPatientId);
        $("#hdnIsActTransferValues").val(listIsActTransfer);
        if (isMTMval === true || isMTMval.toLowerCase() === 'true') {
            AcceptMember(true);
        }
        else {
            CheckPrimaryCMExists(listPatientId, "RR");
        }
    }

    else if (requestReferTypeMALGlobal == "UM Auth") {
        var listReferralId = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferralId += $(item).attr('Id').split('_')[1] + ",";
            }
        });

        //PROD-19169 // KP
        var AuthRedVals = $(listCheckBox[0]).data('authredirect').split('|');
        if (listCheckBox.length == 1 && IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != AuthRedVals[0]) {
            GetPatientAlertsAndAcknowledge(AuthRedVals[0], 0, listReferralId, 'umauthacceptmal', listCheckBox);
        }
        else {
            UMAuthAccept(listCheckBox, listReferralId, 'mal');
        }
    }
    //To Implement UM Activity Accept Functionality
    else if (requestReferTypeMALGlobal == "UM Activity") {
        $('#divUMRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseUMRequestReceivedAcceptComments' });
        $('#divUMRequestAcceptCommentsPopup textarea').val('');
        $('#btnAcceptUMRequestReceivedAcceptComments').prop('disabled', '');
        if (isNewMdrReview) {
            $('#btnAcceptUMRequestReceivedAcceptComments').val('Accept and Perform');
        }
        var listActivityId = "", lstQueueId = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listActivityId += $(item).data('logid') + ",";
                lstQueueId += $(item).data('queueid') + ",";
            }
        });
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listActivityId);
        $('#hdnUMRequestReceivedAcceptQueueIds').val(lstQueueId);
        loadLettersDropDown(baseURL + '/Master/BindConfidentialType', 'selectUMAHNIsConfidential', 2, false, null, null, null, 'ConfidentialTypeId', 'ConfidentialTypeName');
        PrepareAcceptUMActivityGrid(listActivityId);
    }
    else if (requestReferTypeMALGlobal == "AG Complaint") {
        var listReferralId = '', listComplaintId = '', listComplaintRedirect = '', patientId = '', complaintTypeId = '',listPatientId='';

        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferralId += $(item).attr('Id').split('_')[1] + ",";
                listComplaintId += $(item).data('complaintrecordid') + ",";
                listPatientId += $(item).data('patientid') + ",";
                if (listCheckBox.length == 1) {
                    listComplaintRedirect = $(listCheckBox[0]).data('complaintredirect').split('|');
                    patientId = listComplaintRedirect[0];
                    complaintTypeId = listComplaintRedirect[2];
                }
            }
        });

        if (listCheckBox.length == 1 && IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != patientId) {
            GetAGPatientAlertsAndAcknowledge(patientId, listComplaintId, complaintTypeId, 'complaint_accept_MAL', listReferralId);
        }
        else {
            AcceptReqReceivedAGComplaint(listReferralId, listComplaintId, 'MAL', listPatientId);
        }
    }

    else if (requestReferTypeMALGlobal == "AG Activity") {
        $('#divRequestAGAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseRequestReceivedAGAcceptComments' });
        $('#tdTableForAGBulkActivities').html('');
        var listReferenceId = "";
        var listPatientId = "";
        var listComplaintId = "";
        $('#divRequestAGAcceptCommentsPopup textarea').val('');
        $('#selectRequestReceivedAGAcceptConfidential').val('Yes');
        if (isNewAgMdrReview) {          
            if ($(this).context.id === 'divMemberMenuMALAcceptandPerform_') {
                $('#btnAcceptRequestReceivedAGAcceptComments').val('Accept and Perform');
            }
            if ($(this).context.id === 'divMemberMenuAccept_') {
                $('#btnAcceptRequestReceivedAGAcceptComments').val('Accept');
            }
            if (listCheckBox.length === 1) {
                $('#hdnMdrActivityLevelId').val($(listCheckBox[0]).data('levelid'));
            }
        }
        html = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
                listComplaintId += $(item).data('complaintid') + ",";
                //listReferenceId += $(item).data('refernceid') + ",";
            }
        });
        listReferenceId = listReferenceId.substring(0, listReferenceId.length - 1);
        listPatientId = listPatientId.substring(0, listPatientId.length - 1);
        listComplaintId = listComplaintId.substring(0, listComplaintId.length - 1);
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
        $('#hdnRequestReceivedComplaintRecordIds').val(listComplaintId);
        $.ajax({
            type: "GET",
            url: baseURL + "/Dashboard/GetBulkAGActivity?listReferenceId=" + listReferenceId + '&timeDictionaryobj=' + timeZone,
            dataType: "json",
            success: function (data) {

                if (data.success) {
                    var Notes = '';
                    $("#hdnTodayDate").val(data.TodayDate);
                    html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">Complaint ID</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Complaint Received Date</th><th scope="col" style="width:190px;">Scheduled Date</th><th align="left" scope="col">Activity Due Date</th><th align="left" scope="col">Notes</th><th align="left" scope="col">Is Mandatory</th></tr>';
                    $.each(data.activityList, function (key, item) {
                        item.ScheduledDateString = changeTimeZone(item.ScheduledDateString, "1", 'h12');
                        item.DueDateString = changeTimeZone(item.DueDateString, "1", 'h12');
                        item.ReceivedDateString = changeTimeZone(item.ReceivedDateString, "1", 'h12');
                        item.ReceivedDateString = (item.ReceivedDateString === null) ? "" : item.ReceivedDateString;
                        if (item.RequestNotes == '' || item.RequestNotes == null || item.RequestNotes == 'null') { Notes = 'N/A'; } else { Notes = $.fn.replaceAndEscapeHtmlExt(item.RequestNotes); }
                        var strCheck = '<input type="button" style="float:right;margin-right:-5px" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnAGCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                        html += '<tr><td class="alignVMiddle">' + $.fn.replaceAndEscapeHtmlExt(item.PatientName) + '</td><td class="alignVMiddle">' + item.ComplaintRecordNo + '</td><td class="alignVMiddle">' + $.fn.replaceAndEscapeHtmlExt(item.ActionType) + '</td><td class="alignVMiddle"><input type="text"  class="Acceptdate" disabled="disabled" id="txtAcceptCommentsReceivedDate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.ReceivedDateString) + '"/></td><td style="width:205px;">';
                        html += '<input type="text" data-PatientId="' + item.PatientId + '"  class="AcceptCommentsScheduleddate" id="txtAcceptCommentsScheduleddate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.ScheduledDateString) + '"/><span id="ScheduledDate_Valid" class="AgValid_Error" style="display: none;">*</span>' + strCheck + '</td><td class="alignVMiddle"><input type="text"  class="Acceptdate" disabled="disabled" id="txtAcceptCommentsDueDate_' + key + '" value="' + $.fn.apply12To24hrFormat(item.DueDateString) + '"/></td><td class="alignVMiddle">' + Notes + '</td><td class="alignVMiddle">' + item.Mandatory + '</td></tr>';
                        Notes = '';
                    });
                    html += '</table>';
                    $('#tdTableForAGBulkActivities').html('').append(html);
                    $('.AcceptCommentsScheduleddate').kendoDateTimePicker({
                        format: getDateWithoutSecondFormat(),
                        timeFormat: getTimeWithOutSecondFormat(),
                        interval: 10
                    });
                    $('.Acceptdate').kendoDateTimePicker({
                        format: getDateWithoutSecondFormat(),
                        timeFormat: getTimeWithOutSecondFormat(),
                        interval: 10
                    });
                    $(".Acceptdate").find('span').find('.k-select').remove();

                }
            }
        });

    } else if (requestReferTypeMALGlobal == "MS Activity") {

        $('#divMSRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseMSRequestReceivedAcceptComments' });
        $('#divMSRequestAcceptCommentsPopup textarea').val('');
        $('#btnAcceptMSRequestReceivedAcceptComments').prop('disabled', '');
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
            }
        });
        if (listCheckBox.length <= 0 && $('#divMemberMenuRefral_').is(':visible') === true) {
            listReferenceId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
            listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
        }
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
        $('#hdnMSRequestReceivedAcceptCrmQueueIds').val('');
        PrepareAcceptMSActivityGrid(listReferenceId);
    }
    else {
        $('#divRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseRequestReceivedAcceptComments' });
        $('#divRequestAcceptCommentsPopup textarea').val('');
        if (!isProvider && !($("#hdnIsExternalActivity").val())) {
            $('#divRequestAcceptCommentsPopup #divReqAcptIsConfidential').show();
            $('#ReqAcptIsConfidential').html('');
            bindConfidentialTypeRadioButton('ReqAcptIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
        }
        else {
            $('#divReqAcptIsConfidential').hide();
        }
        $('#selectRequestReceivedAcceptConfidential').val('Yes');
        html = "";
        $.each(listCheckBox, function (key, item) {
            if ($(item).is(':checked')) {
                listReferenceId += $(item).attr('Id').split('_')[1] + ",";
                listPatientId += $(item).data('patientid') + ",";
            }
        });
        if (listCheckBox.length <= 0 && $('#divMemberMenuRefral_').is(':visible') === true) {
            listReferenceId += $('#divMemberMenuRefral_').attr('data-Id') + ",";
            listPatientId += $('#divMemberMenuRefral_').attr('data-PatientId') + ",";
        }
        $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
        $.ajax({
            type: "GET",
            url: baseURL + "/CommonDefaultSessionState/GetBulkActivity?listReferenceId=" + listReferenceId,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    html += '<table class="DBGrid" style="width:100%;"><tr><th align="left" scope="col">Member Name</th><th align="left" scope="col">' + GetHtmlDecode(GetHtmlDecode(altruistaIDLabelValue)) + '</th><th align="left" scope="col">Activity Type</th><th align="left" scope="col">Priority</th><th scope="col">Follow up Date</th><th align="left" scope="col">Script Name</th><th align="left" scope="col">Referral Notes</th><th align="left" scope="col">Contact Type</th></tr>';
                    $.each(data.activityList, function (key, item) {
                        var prior = item.Priority && item.Priority != 'null' ? item.Priority : 'N/A';
                        var Comments = item.Comments && item.Comments != 'null' ? item.Comments : 'N/A';
                        Comments = unescapeHtml(Comments);
                        var Venue = item.Venue && item.Venue != 'null' ? item.Venue : 'N/A';
                        var ScriptName = item.ScriptName && item.ScriptName != 'null' ? item.ScriptName : 'N/A';
                        var strCheck = '<input type="button" style="float:right;margin-right:-5px" class="chkAvailability" onclick="loadGlobalCalendar(\'reqrec\',' + key + ')" id="btnCheckActivityAcceptComments_' + key + '" title="Go to My Schedule">';
                        html += '<tr><td>' + $.fn.replaceAndEscapeHtmlExt(item.PatientFullName) + '</td><td>' + item.AltruistaId + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(item.CareActivityTypeName) + '</td><td>' + prior + '</td><td style="width:205px;">';
                        html += '<input type="text" data-Patient_FollowupId="' + item.ActivityLogId + '" data-PatientId="' + item.PatientId + '" data-duedate="' + item.DueDateString + '"  class="AcceptCommentsFolloUpdate" id="txtAcceptCommentsFolloUpdate_' + key + '" value="' + item.FollowupDateString + '"/>' + strCheck + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(ScriptName) + '</td><td>' + $.fn.replaceAndEscapeHtmlExt(Comments) + '</td><td>' + Venue + '</td></tr>';
                    });
                    html += '</table>';
                    $('td#tdTableForBulkActivities').html('').append(html);
                    $('.AcceptCommentsFolloUpdate').kendoDateTimePicker({
                        format: getDateWithoutSecondFormat(),
                        timeFormat: getTimeWithOutSecondFormat(),
                        interval: timeInterval10
                    });
                    gridNotAvailableCustomColor('tdTableForBulkActivities');
                }
            }
        });

    }
    if (requestReferTypeMALGlobal != 'AG Complaint') {
        listCheckBox.removeAttr('checked');
    }
    $('.clsRefralChkMembercol').prop('checked', false);
    $('.ContextChkMenu').hide();
});
$(document).off('change', '#selectActiveInactiveCMMem').on('change', '#selectActiveInactiveCMMem', function () {
    clientPatientIdFromWellframe = "";
    if ($('#memberGrid').val() == "") {
        DBMemberDetailsLoad(2, "panelLeft");
    }
    else {
        DBMemberDetailsLoad(1, "blockOne");
        LoadFilterCriteria();
    }
});


$(document).off('click', '#btnFldClear').on('click', '#btnFldClear', function () {
    ClearAllMedicationControls();
    $("#ACMedicationCodeName").focus();
});

let isFirstMedication = true;
$(document).off('click', '#btnFldAddNext').on('click', '#btnFldAddNext', function () {
    $("#btnFldCancel").show();
    ClearAllMedicationControls();
    $("#divAddEditMedMessage").hide();
    $('#MedicationAddEditFormId').css({ "z-index": "103", "position": "relative" });
    $("#ManuallyEnteredMedications").data("kendoGrid").dataSource.read();
    var isFromUM = $(".InAuthPage").is(":visible");
    var isFromAG = $(".InComplaintPage").is(":visible");
    openAddEditMedicationDialog(baseURL + "/Health/AddEditManualMedications/" + "?isFromUM=" + isFromUM + "&isFromAG=" + isFromAG, 'Add Medication', false);

    if ($('#hdnUMQuickLink').val() === '1') {
        $('#dvOverlayMedication').hide();
    }

    unlockMedicationScreen();
});

$(document).off('click', '#btnFldLeaveSessionNo').on('click', '#btnFldLeaveSessionNo', function () {
    $('#MedicationAddEditFormId').css({ "z-index": "103", "position": "relative" });
    $('#divLeaveMedSessionMessage').hide();
    $("#ACMedicationCodeName").focus();
    if ($('#hdnUMQuickLink').val() === '1') {
        $('#dvOverlayMedication').hide();
    }
});

$(document).off('click', '#btnFldFinish, #btnFldLeaveSessionYes').on('click', '#btnFldFinish, #btnFldLeaveSessionYes', function () {
    ClearAllMedicationControls();
    CancelMedication();
    $("#divAddEditMedMessage").hide();
    $("#divLeaveMedSessionMessage").hide();
    ValidateMedCheck();
    isFirstMedication = true;
    $('#btnFldCancel').trigger('click');
    $('#closePopUp').show();
});


//Medication Add/Edit logic for Medications and MTM - Drug Interactions tab//
$(document).off('click', '#btnFldSave').on('click', '#btnFldSave', function () {
    loader(1)
    $('#btnFldSave').prop("disabled", true);
    var isRouteManualAdd = $("#txtManualMedicationRoute").is(":visible");
    $('#spnMedCodeNameVd').text('');
    if ($('#txtDtaStartDate').val() == "") {
        removeDisableSaveUpdateButtonsForMedication();
    }
    if (validationForMedicationDetails()) {
        var MedCode = $('#hdnAcMedicationCode').val();
        var valFlag = $.trim($('#hdnAcMedicationCodeName').val()) == $.trim($('#ACMedicationCodeName').val());
        if (valFlag == false) {
            $('#spnMedCodeNameVd').text('Invalid Medication Name');
            removeDisableSaveUpdateButtonsForMedication();
            loader(0);
            return false;
        }
        replaceLessThan('1');
        var datastring = $("#MedicationForm").serialize();
        var isNoteUpd = $('#txtDtaComments').length > 0 ? true : false;
        var notesConTypeId = $('input[name=rdonoteUsers]').length > 0 ? $('input[name=rdonoteUsers]:checked').val() : 0;

        $.ajax({
            type: "POST",
            url: baseURL + "/Medication/AddEditManualMedication?memberId=" + memberidval + "&patientId=" + $('#selectPatientAccessed').val() + "&dosageText=" + encodeURIComponent($('#ddlDosage option:selected').text()) + "&medicationCode=" + MedCode + "&isRouteManual=" + isRouteManualAdd + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd,
            data: datastring,
            dataType: "json",
            success: function (data) {
                var result = data.success;
                if (!result) {
                    A11yAlerts.createErrorAlert('#medicationAlertMsg', data.msg ? data.msg : 'Error occurred, please try again.');
                    removeDisableSaveUpdateButtonsForMedication();
                }
                else {
                    if (data.msg === "Saved") {
                        if ($('#lnkDrugInteractionsTab').is(':visible')) {
                            ClearAllMedicationControls();
                            CancelMedication();
                            CmnStatusMessageDisp('spnMTMStatusMsg', 'Record saved successfully.', 'Success');
                            $('#btnMTMManualBasedMed').trigger('click');
                        }
                        else {
                            isFirstMedication = false;
                            $("#lblMedAddEditMessage").text("Success! " + $.trim($('#hdnAcMedicationCodeName').val()) + " is saved.");
                            $("#divAddEditMedMessage").show();
                            $('#btnFldCancel').hide();
                            $('#MedicationAddEditFormId').removeAttr("style");
                            ClearAllMedicationControls();
                            $("#ManuallyEnteredMedications").data("kendoGrid").dataSource.read();
                            A11yUtil.setFocus('btnFldAddNext');
                            lockMedicationScreen();
                        }
                    }
                    else {
                        removeDisableSaveUpdateButtonsForMedication();
                        A11yAlerts.createErrorAlert('#medicationAlertMsg',data.msg);

                    }
                }
                loader(0);
            },
            error: function () {
                removeDisableSaveUpdateButtonsForMedication();
                replaceLessThan('0');
                loader(0);
            }
        });
    }
    else {
        removeDisableSaveUpdateButtonsForMedication();
        loader(0);
    }

});

function lockMedicationScreen() {
    $('#closePopUp').hide();
    $('#divMedFormFields').hide();
    $('#divMedButtons').hide();
}

function unlockMedicationScreen() {
    $('#closePopUp').show();
    $('#divMedFormFields').show();
    $('#divMedButtons').show();
}

function GotoMedication(patientId) {
    if ((ValidateChangesExistsInAccordions() || ValidateChangesByEditLabel() || ValidateNonAccordionChanges() || ValidateAnyEditedAuthExists())) {
        var pagename = "Medications";
        var IsVisible = ConfirmOnAutoDraftWhileExit(pagename);
        if (IsVisible) {
            $("#closePopUpUM").trigger('click');
            return;
        }
    }
    RemoveLocalStorage(1);
    ClickFire(patientId, 'Medications');
    if ($('#popUpDialog1 #MedicationParentDivId').is(':visible')) {
        $('#popUpDialog1').find('#closePopUpUM').trigger('click');
    }
}

function ValidateMedCheck() {
    var isMedCheck = ($('#IsMedCheckConfig').val() == "1" ? true : false);
    if (isMedCheck) {
        $('#divInteractionsCheckStartedMessage').show();
        setTimeout(function () {
            $('#divInteractionsCheckStartedMessage').fadeOut();
        }, 5000);
        $.getJSON(baseURL + "/Medication/MedCheckManualMedication?memberId=" + $('#selectPatientAccessed').val()
        ).done(function (data) {
            if (data.success) {
                if ($("#CMModalPopupDivMessage").length > 0) {
                    setTimeout(function () {
                        if (data.IsInteraction) {
                            if (viewUnifiedMedications === false) {
                                legacyModalAlert("Message Alert on GuidingMedCheck", "Interactions found. Please <a href='javascript:void(0)' onclick=\"GotoMedication('" + data.patientId + "')\"> click here</a> to go to the Medications page. You can then click on the activated \"Drug - Disease Interaction\", \"Drug - Drug Interaction\", or \"Duplicate Therapy\" buttons to view the details.", true, null, true, 10000);
                            } else {
                                legacyModalAlert("Message Alert on GuidingMedCheck", " \"Interactions found. Review the details in the  <a href='javascript:void(0)' onclick=\"GotoMedication('" + data.patientId + "')\"> member’s medications </a> by selecting the active button, either <b>Drug - Disease Interaction</b>, <b>Drug - Drug Interaction</b>, or <b>Duplicate Therapy.\"</b>", true, null, true, 10000);
                            }
                        } else {
                            legacyModalAlert("Message Alert on GuidingMedCheck", "No Interactions found.", true, null, true, 10000);
                        }
                        if ($('#btnALLFIDMedCheck').is(':visible')) {
                            InteractionCount();
                        }
                    }, 4000);
                } else {
                    CustomAlert("Sorry, it seems that an error has occurred and GuidingMedCheck was interrupted. Please try adding an medication to initiate it again.");
                }
            }
        }).fail(function () {
            CustomAlert("Sorry, it seems that an error has occurred and GuidingMedCheck was interrupted. Please try adding an medication to initiate it again.");
        });
    }
}

$(document).off('click', '#btnMedicationDetailsView').on('click', '#btnMedicationDetailsView', function () {
    InteractionCount();
});

$(document).off('click', '#btnSearchMedCodes').on('click', '#btnSearchMedCodes', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Health/SearchMedication",
        popUpHeader: "Search Medications",
        popLevel: 1,
        closeButton: '#btnMedicationPopUpClose',
        modalWidth: MODAL_WIDTH.MEDIUM
    });
});

$(document).off('click', '#btnFldUpdate').on('click', '#btnFldUpdate', function () {
    $('#btnFldUpdate').prop("disabled", true);
    var isRouteManualUpdate = $("#txtManualMedicationRoute").is(":visible");
    if (validationForMedicationDetails()) {
        replaceLessThan('1');
        var datastring = $("#MedicationForm").serialize();
        var isNoteUpd = $('#txtDtaComments').length > 0 ? true : false;
        //changes as per new radio button
        var notesConTypeId = $('input[name=rdonoteUsers]').length > 0 ? $('input[name=rdonoteUsers]:checked').val() : 0;
        $.ajax({
            type: "POST",
            url: baseURL + "/Medication/AddEditManualMedication?memberId=" + memberidval + "&patientID=" + $('#selectPatientAccessed').val() + "&dosageText=" + encodeURIComponent($("#ddlDosage").data("kendoDropDownList").text()) + "&isRouteManual=" + isRouteManualUpdate + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd,
            data: datastring,
            dataType: "json",
            success: function (data) {
                var result = data.success;
                if (!result) {
                    ClearAllMedicationControls();
                    CancelMedication();
                    A11yAlerts.createErrorAlert('#medicationAlertMsg', data.msg ? data.msg : 'Error occurred, please try again.');
                }
                else {
                    if (data.msg === "Update") {
                        if ($('#lnkDrugInteractionsTab').is(':visible')) {
                            ClearAllMedicationControls();
                            CancelMedication();
                            CmnStatusMessageDisp('spnMTMStatusMsg', 'Record updated successfully.', 'Success');
                            $('#btnMTMManualBasedMed').trigger('click');
                        }
                        else {
                            $("#ManuallyEnteredMedications").data("kendoGrid").dataSource.read();
                            A11yAlerts.createSuccessAlert('#manualMedsMsg', 'Record updated successfully.');
                            $('#btnFldCancel').trigger('click');
                        }
                        ValidateMedCheck();
                    }
                    else {
                        removeDisableSaveUpdateButtonsForMedication();
                        A11yAlerts.createErrorAlert('#medicationAlertMsg', data.msg);
                    }
                }
            },
            error: function () {
                removeDisableSaveUpdateButtonsForMedication();
                replaceLessThan('0');
            }
        });
    } else {
        removeDisableSaveUpdateButtonsForMedication();
    }
});

$(document).off('click', '#btnFldForceblyUpdate').on('click', '#btnFldForceblyUpdate', function () {
    $('#btnFldForceblyUpdate').prop("disabled", true);
    var isRouteManualForceUpdate = $("#txtManualMedicationRoute").is(":visible");
    if (validationForMedicationDetails()) {
        var datastring = $("#MedicationForm").serialize();
        var isNoteUpd = $('#txtDtaComments').length > 0 ? true : false;
        var notesConTypeId = $('#MedicationForm input[name=noteUsers]:checked').val() !== undefined ? $('#MedicationForm input[name=noteUsers]:checked').val() : 0;
        var lobBenId = $.trim($("#hdnAEM_MedicationId").val());
        var uniqEligibilityId = $.trim($("#hdnAEM_UniqEligibilityId").val());
        $.ajax({
            type: "POST",
            url: baseURL + "/Medication/UpdateMedicationDetailsForcebly?memberId=" + memberidval + "&PatientID=" + $('#selectPatientAccessed').val() + "&DosageText=" + encodeURIComponent($("#ddlDosage").data("kendoDropDownList").text()) + "&isRouteManual=" + isRouteManualForceUpdate + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&LobBenId=" + lobBenId + "&uniqueEligibilityId=" + uniqEligibilityId,
            data: datastring,
            dataType: "json",
            success: function (data) {
                var result = data.success;
                if (result === "" || result === "undefined" || result === undefined) {
                    CmnStatusMessageDisp('spnHeaMedUpdMsg', 'Record could not be updated.', 'Error');
                }
                if (result === "Update") {
                    if ($('#lnkDrugInteractionsTab').is(':visible')) {
                        ClearAllMedicationControls();
                        CancelMedication();
                        CmnStatusMessageDisp('spnMTMStatusMsg', 'Record updated successfully.', 'Success');
                        $('#btnMTMManualBasedMed').trigger('click');
                    }
                    else {
                        ClearAllMedicationControls();
                        CancelMedication();
                        CmnStatusMessageDisp('spnHeaMedUpdMsg', 'Record updated successfully.', 'Success');
                        $("#ManuallyEnteredMedications").data("kendoGrid").dataSource.read();
                        InteractionCount();
                    }
                }
            },
            error: function () {
                removeDisableSaveUpdateButtonsForMedication();
            }
        });
    }
});


$(document).off('click', '#btnFldForceblySave').on('click', '#btnFldForceblySave', function () {
    $('#btnFldForceblySave').prop("disabled", true);
    var isRouteManualForceAdd = $("#txtManualMedicationRoute").is(":visible");
    if (validationForMedicationDetails()) {
        replaceLessThan('1');
        var datastring = $("#MedicationForm").serialize();
        var MedCode = $('#hdnAcMedicationCode').val();
        var isNoteUpd = $('#txtDtaComments').length > 0 ? true : false;
        var notesConTypeId = $('#MedicationForm input[name=noteUsers]:checked').val() !== undefined ? $('#MedicationForm input[name=noteUsers]:checked').val() : 0;
        var lobBenId = $('#ddlMedicationLob .clsRdoMemEligMini:checked').data('lobbenid');
        var uniqEligibilityId = $('#ddlMedicationLob .clsRdoMemEligMini:checked').data('uniqeligibilityid');
        $.ajax({
            type: "POST",
            url: baseURL + "/Medication/AddMedicationDetailsForcebly?memberId=" + memberidval + "&PatientID=" + $('#selectPatientAccessed').val() + "&DosageText=" + encodeURIComponent($('#ddlDosage option:selected').text()) + "&MedicationCode=" + MedCode + "&isRouteManual=" + isRouteManualForceAdd + "&noteConfidetialTypeId=" + notesConTypeId + "&isNoteUpdate=" + isNoteUpd + "&LobBenId=" + lobBenId + "&uniqueEligibilityId=" + uniqEligibilityId,
            data: datastring,
            dataType: "json",
            success: function (data) {
                var result = data.success;
                if (result == "Saved") {
                    if ($('#lnkDrugInteractionsTab').is(':visible')) {
                        ClearAllMedicationControls();
                        CancelMedication();
                        CmnStatusMessageDisp('spnMTMStatusMsg', 'Record saved successfully.', 'Success');
                        $('#btnMTMManualBasedMed').trigger('click');
                    }
                    else {
                        ClearAllMedicationControls();
                        CancelMedication();
                        CmnStatusMessageDisp('spnHeaMedUpdMsg', 'Record saved successfully.', 'Success');
                        $("#ManuallyEnteredMedications").data("kendoGrid").dataSource.read();
                        InteractionCount();
                    }
                }
            },
            error: function () {
                removeDisableSaveUpdateButtonsForMedication();
                replaceLessThan('0');
            }
        });
    }
});
$(document).off('click', '#btnCarePlanReviewExport').on('click', '#btnCarePlanReviewExport', function () {
    loader(1);
    if ($('.btnTargetedAcknowledge:visible').length <= 0) {
        var url = baseURL + '/PopulationHealth/FullCarePlanPrint?patientIds=' + selectedRCPAck.split('~')[0] + '&carePlanReviewIds=' + selectedRCPAck.split('~')[1]
            + '&status=' + selectedRCPAck.split('~')[4] + '&printSections=Conditions,Medications,Care Team,Targeted Interventions,Clinical Interventions,Care Plan Notes' + '&isDisplay=' + false + '&baseURL=' + baseURL;
        $.ajax({
            type: "POST",
            url: url,
            dataType: "json",
            success: function (data) {
                if (data.fileName != undefined && data.fileName != '') {
                    loader(0);
                    DisableCPRAcknowledgeButton();
                    setTimeout(function () { $('#ReqRecGrid').data('kendoGrid').dataSource.read(); }, 50);
                    window.location.href = encodeURI(baseURL + "/populationhealth/downloadfile?filename=" + data.fileName);
                }
                loader(0);
            }
        });
    } else {
        loader(0);
        //CustomAlert('Please acknowledge the targeted intervention(s)'); 
        CmnStatusMessageDisp('divCarePlanAckValidationMessage', 'Please acknowledge the targeted intervention(s)', 'Error');
    }
});

//Muliplte member Export
$(document).off('click', '#btnCPRExportToPDF').on('click', '#btnCPRExportToPDF', function () {
    A11yAlerts.remove();
    var selectedPatients = $('#ReqRecGrid').find('td input[type="checkbox"]:checked');
    if (selectedPatients.length > 0) {
        loader(1);
        var carePlanReviewIds = '';
        var patIds = '';
        var CPRstatus = '';
        $.each(selectedPatients, function (key, item) {
            if ($(item).is(':checked')) {
                patIds += (key == 0 ? "" : ",") + $(item).attr('data-patientid');
                carePlanReviewIds += (key == 0 ? "" : ",") + $(item).attr('data-referenceid');
                CPRstatus += (key == 0 ? "" : ",") + $(item).attr('data-cprstatus');
            }
        });
        var isTargetedInterventions = false;
        if (CPRstatus.indexOf('Pending') != "-1" || CPRstatus.indexOf('Closed') != "-1") {
            isTargetedInterventions = CheckMemberHasTargetCarePlans(patIds);
        }
        if (!isTargetedInterventions) {
            var processedPatients = "";
            var distinct = [];
            $.each(CPRPatients, function (i, v) {
                if ($.inArray(v.split(',')[0], distinct) == -1)
                    distinct.push(v.split(',')[0]);
            });
            $.each(distinct, function (i, v) {
                var indexes = $.map(CPRPatients, function (obj, index) {
                    if (obj.split(',')[0] == v) {
                        return obj.split(',')[1];
                    }
                });
                processedPatients += v + "~" + indexes.join(",") + "|";
            });
            CPRPatients = [];
            var url = baseURL + '/PopulationHealth/FullCarePlanPrint?patientIds=' + patIds + '&carePlanReviewIds=' + carePlanReviewIds
                + '&status=' + CPRstatus + '&printSections=Conditions,Medications,Care Team,Targeted Interventions,Clinical Interventions,Care Plan Notes' + '&isDisplay=' + false + '&processedPatients=' + processedPatients + '&baseURL=' + baseURL;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                success: function (data) {
                    if (data.fileName != undefined && data.fileName != '') {
                        loader(0);
                        setTimeout(function () { $('#ReqRecGrid').data('kendoGrid').dataSource.read(); }, 50);
                        window.location.href = encodeURI(baseURL + "/populationhealth/downloadfile?filename=" + data.fileName);

                    }
                    loader(0);
                }
            });

        } else {
            loader(0);
            //CustomAlert('Please acknowledge the targeted intervention(s) for the selected care plan review record');
            CmnStatusMessageDisp('divReqRecMessage', 'Please acknowledge the targeted intervention(s) for the selected care plan review record', 'Error');

        }
    }
    else {
        //CustomAlert('Please select at least one record and click on Export to PDF.');
        CmnStatusMessageDisp('divReqRecMessage', 'Please select at least one record and click on Export to PDF.', 'Error');
    }

});

$(document).off('click', '.btnTargetedAcknowledge').on('click', '.btnTargetedAcknowledge', function () {
    if (!$(this).is(':disabled')) {
        var todayDate = kendo.toString(kendo.parseDate(new Date()), 'MM/dd/yyyy');
        $('#tdTargetedInterventionDate,#tdTargetedInterventionNotes,#tdddlTargetedInterventionResponse').find('.validationMessage').remove();
        loadDropDownSync(baseURL + '/PopulationHealth/BindDDLTargetedStatus', 'ddlTargetedInterventionResponse');
        $('#txtTargetedInterventionDate').val(' ');
        $('#ddlTargetedInterventionResponse').val('-1');
        $('#targetedInterventionNotes').val('');
        $("#txtTargetedInterventionDate").kendoDatePicker({
            value: todayDate,
            max: todayDate
        });
        $("#txtTargetedInterventionDate").attr("readonly", "readonly");
        $('#selectedCarePlanId').val('');
        $('#selectedCarePlanId').val($(this).attr('class').split(' ')[2]);
        $('#divTargetedInterventionPopup').CMNPopup({
            popUpHeader: "Targeted Intervention Acknowledgement",
            closeButton: '#btnPHCloseTargetedInterventions',
            popLevel: 3,
            onLoad: function () {
                if (enableDomLogs) {
                    DomUtils.logDomData("Member Info>>Care Plan>>Care Plan Review>>View Targeted Intervention>>Click on Thumb icon");
                }
            }
        });
    }
});

$(document).off('click', '#btnPHSaveTargetedIntervention').on('click', '#btnPHSaveTargetedIntervention', function () {
    //Validate mandatory fileds
    $('#tdTargetedInterventionDate,#tdTargetedInterventionNotes,#tdddlTargetedInterventionResponse').find('.validationMessage').remove();
    var tarDate = $('#txtTargetedInterventionDate').val();
    if ($('#ddlTargetedInterventionResponse').val() != "-1" && tarDate != '' && funisValidDate(tarDate, 0) && $('#targetedInterventionNotes').val() != '') {
        loader(1);
        var selectedCarePlanId = $('#selectedCarePlanId').val().replace('btn_', '');
        var datastring = {
            PatientId: selectedRCPAck.split('~')[0],
            Notes: $('#targetedInterventionNotes').val(),
            CarePlanId: selectedCarePlanId,
            TargetedStatusId: $('#ddlTargetedInterventionResponse').val(),
            CarePlanReviewId: selectedRCPAck.split('~')[1],
            ResolvedOn: tarDate
        }
        $.ajax({
            type: "POST",
            url: baseURL + '/PopulationHealth/UpdateCarePlanReviewTargetedIntervention',
            dataType: "json",
            data: datastring,
            success: function (data) {
                if (data) {
                    if (data.alertCountResult != undefined && data.alertCountResult != null)
                        $('.btnPatientCount').val(data.alertCountResult);

                    $('.btn_' + selectedCarePlanId).hide();
                    $('#lbl_' + selectedCarePlanId).show();
                    $('#lbl_' + selectedCarePlanId).text($('#ddlTargetedInterventionResponse option:selected').text());
                    $('#btnPHCloseTargetedInterventions').trigger('click');
                    if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) {
                        CmnStatusMessageDisp('divTgtInterValidationMsg', 'Targeted intervention has been updated successfully!', 'Success');
                        $('#divTgtInterValidationMsg')[0].focus();
                    }
                    else
                        CustomAlert('Targeted intervention has been updated successfully!');
                    EnableCPRAcknowledgeButton();
                } else {
                    if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) {
                        CmnStatusMessageDisp('divTgtInterValidationMsg', 'Error Occured...', 'Error');
                        $('#divTgtInterValidationMsg')[0].focus();
                    }
                    else
                        CustomAlert('Error Occured...');
                }
                loader(0);
            }, error: function () {
                if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) {
                    CmnStatusMessageDisp('divTgtInterValidationMsg', 'Error Occured...', 'Error');
                    $('#divTgtInterValidationMsg')[0].focus();
                }
                else
                    CustomAlert('Error Occured...');
                loader(0);
            }
        });
    }
    else {
        if ($('#ddlTargetedInterventionResponse').val() == "-1")
            $('#tdddlTargetedInterventionResponse').append('<span class="validationMessage"  style="color:red">*</span>');
        if (tarDate == '' || !funisValidDate(tarDate, 0))
            $('#tdTargetedInterventionDate').append('<span class="validationMessage"  style="color:red">*</span>');
        if ($('#targetedInterventionNotes').val() == '')
            $('#tdTargetedInterventionNotes').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }

})

$(document).off('click', '#btnCPRExportToXML,#btnSingleCPRExportToXML').on('click', '#btnCPRExportToXML,#btnSingleCPRExportToXML', function () {
    var elementId = $(this).attr('id');
    var selectedPatients = $('#ReqRecGrid').find('td input[type="checkbox"]:checked');
    if (selectedPatients.length > 0 || $(this).attr('id') == 'btnSingleCPRExportToXML') {

        var carePlanReviewIds = '';
        var patIds = '';
        var CPRstatus = '';
        if (elementId == 'btnSingleCPRExportToXML') {
            patIds = selectedRCPAck.split('~')[0];
            carePlanReviewIds = selectedRCPAck.split('~')[1];
            CPRstatus = selectedRCPAck.split('~')[4];
        }
        else {
            $.each(selectedPatients, function (key, item) {
                if ($(item).is(':checked')) {
                    patIds += (key == 0 ? "" : ",") + $(item).attr('data-patientid');
                    carePlanReviewIds += (key == 0 ? "" : ",") + $(item).attr('data-referenceid');
                    CPRstatus += (key == 0 ? "" : ",") + $(item).attr('data-cprstatus');
                }
            });
        }

        var isTargetedInterventions = false;
        if (CPRstatus.indexOf('Pending') != "-1" || CPRstatus.indexOf('Closed') != "-1") {
            isTargetedInterventions = CheckMemberHasTargetCarePlans(patIds);
        }
        if (!isTargetedInterventions) {

            var processedPatients = "";
            if (elementId != 'btnSingleCPRExportToXML') {
                var distinct = [];
                $.each(CPRPatients, function (i, v) {
                    if ($.inArray(v.split(',')[0], distinct) == -1)
                        distinct.push(v.split(',')[0]);
                });
                $.each(distinct, function (i, v) {
                    var indexes = $.map(CPRPatients, function (obj, index) {
                        if (obj.split(',')[0] == v) {
                            return obj.split(',')[1];
                        }
                    });
                    processedPatients += v + "~" + indexes.join(",") + "|";
                });
                CPRPatients = [];
            }

            loader(1);
            var url = baseURL + '/PopulationHealth/FullCarePlanExportToXML?patientIds=' + patIds + '&carePlanReviewIds=' + carePlanReviewIds
                + '&printSections=Conditions,Medications,Care Team,Clinical Interventions,Care Plan Notes,Targeted Interventions' + '&status=' + CPRstatus + '&processedPatients=' + processedPatients;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                success: function (data) {
                    if (data.fileName != undefined && data.fileName != '') {
                        loader(0);
                        if (elementId == 'btnSingleCPRExportToXML')
                            DisableCPRAcknowledgeButton();
                        setTimeout(function () { $('#ReqRecGrid').data('kendoGrid').dataSource.read(); }, 50);
                        window.location.href = encodeURI(baseURL + "/populationhealth/DownloadZipFile?filename=" + data.fileName + "&filesCount=" + data.files);
                    }
                    loader(0);
                },
                error: function (error) {
                    loader(0);
                }
            });

        }
        else {
            //CustomAlert('Please acknowledge the targeted intervention(s) for the selected care plan review record');
            if ($(this).attr('ID') == 'btnSingleCPRExportToXML')
                CmnStatusMessageDisp('divCarePlanAckValidationMessage', 'Please acknowledge the targeted intervention(s)', 'Error');
            else
                CmnStatusMessageDisp('divReqRecMessage', 'Please acknowledge the targeted intervention(s) for the selected care plan review record', 'Error');
        }
    }
    else {
        //CustomAlert("Please select at least one record and click on Export Full Care Plan");
        CmnStatusMessageDisp('divReqRecMessage', 'Please select at least one record and click on Export Full Care Plan', 'Error');
    }

});


$(document).off('click', '.CPRCheckBox').on('click', '.CPRCheckBox', function () {
    var item = $(this).attr('data-patientId') + "," + $(this).attr('data-referenceId');
    if ($(this).is(':checked'))
        CPRPatients.push(item);
    else
        CPRPatients.splice($.inArray(item, CPRPatients), 1);
});
$(document).off('click', '#btnSendAcknowledge').on('click', '#btnSendAcknowledge', function () {
    loader(1);
    $('#btnAckClose').trigger('click');
    var isFrom = selectedRCPAck.split('~')[2];
    var datastring = {
        patientId: selectedRCPAck.split('~')[0],
        carePlanProviderReviewId: selectedRCPAck.split('~')[1],
        Comments: $('#AckNotesId').val(),
        CarePlanIds: selectedRCPAck.split('~')[3],
        IsFrom: isFrom,
        PrintSections: 'Conditions,Medications,Care Team,Targeted Interventions,Clinical Interventions,Care Plan Notes',
    }
    $.ajax({
        type: "POST",
        url: baseURL + '/PopulationHealth/SendAcknowledgeReviewCarePlan',
        dataType: "json",
        data: datastring,
        success: function (data) {
            if ($('#AckNotesId').val() != '' && data.alertCountResult != undefined && data.alertCountResult != null)
                $('.btnPatientCount').val(data.alertCountResult);
            if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))
                CmnStatusMessageDisp('divReqRecMessage', 'Care Plan has been Acknowledged successfully!', 'Success');
            else
                CustomAlert('Care Plan has been Acknowledged successfully!');
            if (isFrom == 'PH') {
                ClearPopulationFilter();
                $('#ddlCPRStatus').val('-1');
                $('#ddlCPRSearchByDates').val('REFER_DATE');
                $('#ReqRecGrid .k-pager-refresh').trigger('click');
            } else {
                if (!$(".InAuthPage").is(":visible")) {
                    var grdCarePlanReview = $("#CarePlanReviewGrid").data("kendoGrid");
                if (grdCarePlanReview !==null)
                        grdCarePlanReview.dataSource.read();
                }
                else {
                    loader(0);
                }
            }
            loader(0);
        }, error: function () {
            if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))
                CmnStatusMessageDisp('divReqRecMessage', 'Error Occured...', 'Error');
            else
                CustomAlert('Error Occured...');
            loader(0);
        }
    });
});

$(document).off('click', '.btnClsReviewCarePlanNotesView').on('click', '.btnClsReviewCarePlanNotesView', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/CarePlan/ViewReviewCarePlanNotes?CarePlanReviewId=" + $(this).data("referenceid") + "&PatientId=" + $(this).data("patientid") + "&CarePlanReviewStatus=" + $(this).attr('data-cprstatus'),
        popUpHeader: "View Notes",
        popLevel: 1,
        onLoad: function () {
            $("#ViewReviewCarePlanNotesGrid").data("kendoGrid").dataSource.read();
        }
    });
});

$(document).off('click', '.btnClsActivityViewNotes').on('click', '.btnClsActivityViewNotes', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/PopulationHealth/ViewPhActivityNotes?ActivityReviewId=" + $(this).data("patientfollowupid") + "&PatientId=" + $(this).data("patientid") + "&ActivityReviewStatus=" + $(this).attr('data-cprstatus') + "&IsExternalActivity=" + $(this).data("isexternalactivity") + "&IsProvider=" + isProvider,
        popUpHeader: "View Notes",
        popLevel: 1,
        onLoad: function () {
            $("#ViewReviewActivityNotesGrid").data("kendoGrid").dataSource.read();
        },
        onClose: function () {
            $('#popUpDialog2').html('');
            $("#btnRequestReceivedAccept").css("display", "none");
            $('.GearIconCls').removeAttr("disabled");
            $('.clsRefralChkMember').prop('checked', false);
        }
    });
});
$(document).off('click', '.divClsMemberMenuViewCalendar,.divClsCarePlanReviewMenuViewCalendar').on('click', '.divClsMemberMenuViewCalendar,.divClsCarePlanReviewMenuViewCalendar', function () {
    var calendarURL = getCalendarURL();
    var patientId = '';
    if ($(this).hasClass('divClsCarePlanReviewMenuViewCalendar')) {
        patientId = $(this).parent().attr('data-patientid');
    } else {
        patientId = ($('#divMemberMenu').parent().find("input[type='hidden']").val() || $(this).parent().attr("data-patientid") || $('#divMemberMenu').attr("data-patientid"));
    }

    isPHSensitiveMember = $(this).parent().attr('data-issensitivemember');
    calPatientId = patientId;
    calAuthnum = 0;
    calComplaintnum = 0;
    $('#hdnMemberName,#hdnPHCalMemberName').val('');
    var ele = "";
    if ($("#_myCalendarPartialViewContainer").length > 0) {
        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(calendarURL, function () {
            onLoadMyCalendar();
        });
        ele = '_myMemberPartialViewContainer';
    }
    else if ($("#CalendarViewDiv").length) {
        ISPHMembers = true;
        $("#CalendarViewDiv").load(calendarURL, function () {
            onLoadMyCalendar();
        });
        ele = 'memberGrid';
        //
        $("#panelRight").show();
        $("#panelLeft").hide();
        $(".dBLeftBar a").attr("class", "TabbedPanelsTab");
        $("#dBCal").attr("class", "TabbedPanelsTab TabbedPanelsTabSelected");
        //
    }
    $('#spanMyCalendarHeaderName').html('').append('<span id="spanSwitchtoCalendar" href="#">Switch To My Calendar</span>');
    $.getJSON(baseURL + "/Common/GetPatientName?patientId=" + patientId, function (data) {
        $('#divMyCalendarRightButtons span#memberName,#spanMyCalendarPatientName span').remove();

        // when showing a member calendar, we need to tighten things up b/c it's too crowded
        $('#careActivityLogText').hide();
        $('#divMyCalendarRightButtons .ah-widget-link-container').addClass('compact');

        //prod-838 - adjusting member name display in expand and collapse
        $('#divMyCalendarRightButtons > span').remove();
        $('#divMyCalendarRightButtons,#spanMyCalendarPatientName').AhsPrepend('<span id="memberName" class="clsmembernamecollapse ItemMT2" title="Member: ' + $.fn.replaceAndEscapeHtmlExt(data) + '" style="overflow: hidden; text-align:right;white-space: nowrap;text-overflow: ellipsis;width: 240px;display:inline-block;">Member: ' + $.fn.replaceAndEscapeHtmlExt(data) + '</span>');
        if (data != undefined && data != '' && data.length > 24) {
            $('.clsmembernamecollapse').text('Member : ' + data.substring(0, 21) + '...').AhsSetAttr('title', data);
        }
        $('#hdnMemberName').val(data);
        myCalendarMemberName = data;
        $('#hdnPHCalMemberName').val(data);
    })

    if ($(this).attr('class').split(' ')[0] == 'divClsMemberMenuViewCalendar') { ClearTableMenu(ele, 'divMemberMenu'); }
});

(function ($) {
    // Ahs Prepend Extention function
    $.fn.AhsPrepend = function (value) {
        $(this).prepend(function () { return ahsSerialize(value, { unsafescripttag: true, unsafe: true }) });
        return this;
    };

    $.fn.AhsAppend = function (value) {
        $(this).append(function () { return ahsSerialize(value, { unsafescripttag: true, unsafe: true }) });
        return this;
    };
    // Ahs AppendChild Extention function
    $.fn.AhsAppendChild = function (value) {
        $(this).append(function () { return ahsSerialize(value, { unsafescripttag: true, unsafe: true }) });
        return this;
    };

    // Ahs Get Html Extention function
    $.fn.AhsGetHtml = function () {
        return $(this).html();
    };

    // Ahs Get Attr Extention function
    $.fn.AhsGetAttr = function (key) {
        return (key) ? $(this).attr(key) : undefined;
    }

    // Ahs Set Attr Extention function
    $.fn.AhsSetAttr = function (key, value, callback) {
        if (key) {
            value = value || '';
            callback = (callback && typeof (callback) === "function") ? callback : undefined;
            $(this).attr(key, ahsSerialize(value, { unsafescripttag: true, unsafe: true }), callback);
        }

        return this;
    };
    // Ahs Get Prop Extention function
    $.fn.AhsGetProp = function (key) {
        return (key) ? $(this).prop(key) : undefined;
    }

    // Ahs Set Prop Extention function
    $.fn.AhsSetProp = function (key, value, callback) {
        if (key) {
            value = value || '';
            callback = (callback && typeof (callback) === "function") ? callback : undefined;
            $(this).prop(key, ahsSerialize(value, { unsafescripttag: true, unsafe: true }), callback);
        }

        return this;
    };

    // Generate an uniqueId to make the regexp pattern harder to guess.
    var uniqueId = Math.floor(Math.random() * 0x10000000000).toString(16);
    var placeHolderRegex = new RegExp('"@@__(F|R|D)-' + uniqueId + '-(\\d+)__@@"', 'g');

    var isNativeCodeRegExp = /\{\s*\[native code\]\s*\}/g;
    var unsafeCharsRegExp = /[<>\/\u2028\u2029]/g;
    var unsafeCharsRegExp1 = /<\s*\/?\s*script\b[^>]*>/gi;

    var scriptStartTag = '<' + 'script' + '>';
    var scriptEndTag = ('</' + 'script' + '>');
    // Mapping of unsafe HTML and invalid JavaScript line terminator chars to their
    // Unicode char counterparts which are safe to use in JavaScript strings.
    var CharsToBeEscaped = {
        '<': '\\u003C',
        '>': '\\u003E',
        '/': '\\u002F',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029',
    };

    // Mapping of unsafe HTML and invalid JavaScript line terminator chars to their
    // Unicode char counterparts which are safe to use in JavaScript strings.

    var scriptTagToBeEscaped = {
        '<script>': '\\u003Cscript\\u003E',
        '<\/script>': '\\u003C\\u002Fscript\\u003E'
    };

    function escapeUnsafeChars(unsafeChar) {
        return CharsToBeEscaped[unsafeChar];
    };

    function escapeUnsafeScriptTag(unsafeChar) {
        return scriptTagToBeEscaped[unsafeChar];
    };

})(jQuery);

$(document).off('change', '.unManagelettempchildcheckbox').on('change', '.unManagelettempchildcheckbox', function () {
    var count = $(".unManagelettempchildcheckbox:checked").length;
    if (count > 1) { $('#btnScLetterEdit').hide(); }
    else { $('#btnScLetterEdit').show(); }
});

$(document).off('change', '.unmanagelettempparentcheckbox').on('change', '.unmanagelettempparentcheckbox', function () {
    if ($('.unmanagelettempparentcheckbox').is(':checked')) {
        $(".unManagelettempchildcheckbox").prop('checked', true); $('#btnScLetterEdit').hide();
        if ($(".unManagelettempchildcheckbox").length > 1) { $('#btnScLetterEdit').hide(); }
    }
    else { $(".unManagelettempchildcheckbox").prop('checked', false); $('#btnScLetterEdit').show(); }
});
$(document).off('change', '#txtStDt').on('change', '#txtStDt', function () {
    validateDates();
});
$(document).off('change', '#txtEdDt').on('change', '#txtEdDt', function () {
    validateDates();
});

//Xdr C-CDA context menu Action icon grid
$(document).off('click', '.clsChkXDRCCDADetails').on('click', '.clsChkXDRCCDADetails', function () {
    $('.divClsRefralMemberMenu').hide();
    var chkboxes = $('#XDRCCDADetailsGrid').find('input[type="checkbox"]:checked.clsChkXDRCCDADetails');
    if (chkboxes.length == 1) {
        $table = $('#XDRCCDADetailsGrid');
        var $chkBox = $(chkboxes[0]);
        var pos = $(chkboxes[0]).offset();
        pos.top = setPstnCntxtMenu(chkboxes[0]);
        //Recalculation of top when page is scrolled
        var pageScrollTop = $(document).scrollTop();
        pos.top = pos.top - pageScrollTop;
        var menuName = (chkboxes.data('details').split('@!@')[11]).toUpperCase();
        if (menuName == "GENERATED") {
            $('.divXdrCcdaMenu').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            $('.XdrCcdaDetailsSend').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px").html("Send");
            $('.XdrCcdaDetailsUpdate').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            $('.XdrCcdaDetailsReply').hide();
        }
        else if (menuName == "SENDING QUEUE" || menuName == "SENT") {
            $('.divXdrCcdaMenu').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            $('.XdrCcdaDetailsSend').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px").html("ReSend");
            $('.XdrCcdaDetailsUpdate').hide();
            $('.XdrCcdaDetailsReply').hide();
        }
        else if (menuName == "LEVEL 1 REQUESTED") {
            $('.divXdrCcdaMenu').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            $('.XdrCcdaDetailsReply').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px").html("Reply");
            $('.XdrCcdaDetailsUpdate').hide();
            $('.XdrCcdaDetailsSend').hide();
        }
        else if (menuName == "REPLIED") {
            $('.divXdrCcdaMenu').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px");
            $('.XdrCcdaDetailsSend').show().css('left', (pos.left + 15) + "px").css('top', pos.top + "px").html("ReSend");
            $('.XdrCcdaDetailsUpdate').hide();
            $('.XdrCcdaDetailsResend').hide();
            $('.XdrCcdaDetailsReply').hide();
        }
        else {
            $('.ContextChkMenu').hide();
        }
    }
    else {
        $('.ContextChkMenu').hide();
    }
});
//Xdr C-CDA context menu click send or resend
$(document).off('click', '.XdrCcdaDetailsSend').on('click', '.XdrCcdaDetailsSend', function () {
    loader(1);
    var selChkBx = $('#XDRCCDADetailsGrid').find('input[type="checkbox"]:checked')[0];
    var dataArray = $(selChkBx).data('details').split('@!@');
    var SentFromDetailId = dataArray[1];
    var StatusId = dataArray[2];
    var StatusName = dataArray[11];
    var SpecificationId = dataArray[3];
    var IdentifierId = dataArray[4];
    var StartDate = dataArray[5];
    var EndDate = dataArray[6];
    var HeaderId = dataArray[7];
    var DocumentName = dataArray[8];
    var requestData = {
        SentFromDetailId: SentFromDetailId,
        StatusId: StatusId,
        SpecificationId: SpecificationId,
        IdentifierId: IdentifierId,
        StartDate: StartDate,
        EndDate: EndDate,
        HeaderId: HeaderId,
        DocumentName: DocumentName,
        StatusName: StatusName
    };
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/XdrCcda/NewXdrCCDA",
        method: 'POST',
        data: requestData,
        popUpHeader: "Send C-CDA",
        closeButton: '#btnCloseCcda',
        onLoad: function () {
            $('#popUpDialog2').css('width', '700px');
            $('#popUpDialog2').css('height', '250px');
            $('#rowccdanotes').hide();
        },
        onClose: function () {
            $('#popUpDialog2').css('width', '');
            $('#popUpDialog2').css('height', '');
            $(selChkBx).attr('checked', false);
            $('.divXdrCcdaMenu').hide();
        },
        popLevel: 1
    });
    loader(0);
});

//Xdr C-CDA context menu click update
$(document).off('click', '.XdrCcdaDetailsUpdate,.XdrCcdaDetailsReply').on('click', '.XdrCcdaDetailsUpdate,.XdrCcdaDetailsReply', function () {
    loader(1);
    var popHeader = "Update C-CDA";
    var IsUpdate = 1;
    var selChkBx = $('#XDRCCDADetailsGrid').find('input[type="checkbox"]:checked')[0];
    var recordNumber = ($(selChkBx).data('recordnumber'));
    if (recordNumber != null) {
        $('#hdnCCDARecordNumber').val(recordNumber);
    }
    else
        $('#hdnCCDARecordNumber').val(null);
    if ($(this).hasClass('XdrCcdaDetailsReply')) {
        popHeader = "Reply C-CDA"
        var IsUpdate = 2;
    }
    var dataArray = $(selChkBx).data('details').split('@!@');
    var SentFromDetailId = dataArray[1];
    var StatusId = dataArray[2];
    var StatusName = dataArray[11];
    var SpecificationId = dataArray[3];
    var IdentifierId = dataArray[4];
    var StartDate = dataArray[5];
    var EndDate = dataArray[6];
    var HeaderId = dataArray[7];
    var DocumentName = dataArray[8];
    var ClinicalSummary = dataArray[9];
    var MedicationSummary = dataArray[10];
    var documentGuid = dataArray[12];
    if (ClinicalSummary != null && ClinicalSummary != "") {
        ClinicalSummary = unescapeHtml(ClinicalSummary.replace(/&#92;/g, "\\\\").replace(/&#8804;/g, "≤").replace(/&#8805;/g, "≥"));
    }
    if (MedicationSummary != null && MedicationSummary != "") {
        MedicationSummary = unescapeHtml(MedicationSummary.replace(/&#92;/g, "\\\\").replace(/&#8804;/g, "≤").replace(/&#8805;/g, "≥"));
    }
    var requestData = {
        SentFromDetailId: SentFromDetailId,
        StatusId: StatusId,
        SpecificationId: SpecificationId,
        IdentifierId: IdentifierId,
        StartDate: StartDate, EndDate: EndDate,
        ClinicalSummary: ClinicalSummary,
        HeaderId: HeaderId,
        DocumentName: DocumentName,
        IsUpdate: IsUpdate,
        StatusName: StatusName,
        MedicationSummary: MedicationSummary,
        documentGuid: documentGuid
    };
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/XdrCcda/NewXdrCCDA",
        method: 'POST',
        data: requestData,
        popUpHeader: popHeader,
        closeButton: '#btnCloseCcda',
        onClose: function () {
            $(selChkBx).attr('checked', false);
            $('.divXdrCcdaMenu').hide();
        },
        onLoad: function () { },
        popLevel: 1
    });
    loader(0);
});
$(document).off('click', '.btnClsReviewAssessmentNotesView').on('click', '.btnClsReviewAssessmentNotesView', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Activity/ViewReviewAssessmentNotes?AssessmentReviewId=" + $(this).data("referenceid") + "&patientId=" + $(this).data("patientid"),
        popUpHeader: "View Acknowledgement",
        popLevel: 1,
        onLoad: function () {
            $("#ViewReviewAssessmentNotesGrid").data("kendoGrid").dataSource.read();
        }
    });
});
$(document).off('click', '#imgAssessmentReviewSignature').on('click', '#imgAssessmentReviewSignature', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/ScriptForm/AssessmentReviewSignature",
        onLoad: function () {
        },
        popLevel: 1,
        popUpHeader: "Signature",
        closeButton: '#btnAssmntReviewSignClose'
    });
});
$(document).off('click', '#btnUmDocumentDynamicColumns').on('click', '#btnUmDocumentDynamicColumns', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Common/DinamicColumns?section=" + "UM DOCUMENTS",
        popUpHeader: "Config Columns",
        popLevel: 1,
        closeButton: '#btnCancel',
        onClose: function () {
            $("#btnUploadDoc").show();
            $('#popUpDialog2').html('');
        }
    });
});
$(document).off('change', '.clschkPatientDocs').on('change', '.clschkPatientDocs', function () {
    var $documentGrid = $(this).closest('#electronicDocsGrid, #AuthDocumentsGrid, #Grid_ComplaintDocument');
    if ($documentGrid.length == 0) {
        return;
    }
    var count = $documentGrid.find(".clschkPatientDocs").length;
    var chkcount = $documentGrid.find(".clschkPatientDocs:checked").length;
    if (isDocumentUrlConfigured === "True") {
        var downloadEnabled = false;
        var hasUrlDocument = false;

        $documentGrid.find(".clschkPatientDocs:checked").each(function () {
            var detailsAttr = $(this).attr("data-details");
            if (!detailsAttr) {
                return true;
            }
            var details = detailsAttr.split("|");
            var docName = details[0];
            if (docName && isDocumentUrl(docName)) {
                hasUrlDocument = true;
            }
            else {
                downloadEnabled = true;
            }
        });
        if (hasUrlDocument && !downloadEnabled) {
            $('.clsUmAgMultiDocsDownload').addClass("disabled").attr({ disabled: 'disabled', title: 'Documents with URL cannot be downloaded' }).css({ 'cursor': 'not-allowed', 'pointer-events': 'none' });
        } else {
            $('.clsUmAgMultiDocsDownload').removeClass("disabled").removeAttr('disabled title').css({ 'cursor': 'pointer', 'pointer-events': 'auto' });
        }
    }

    if (chkcount == 0) {
        $('#btnUploadDoc').show();
    }
    else if (chkcount >= 1) {
        $('#btnUploadDoc').hide();
    }

    if (chkcount < count)
        $documentGrid.find('#chkAllPatientDocs').prop('checked', false);
    else if (chkcount == count)
        $documentGrid.find('#chkAllPatientDocs').prop('checked', true);
});
$(document).off('click', '.clschkPatientDocsHeadAuth').on('click', '.clschkPatientDocsHeadAuth', function () {
    var $documentGrid = $(this).closest('#AuthDocumentsGrid');
    $documentGrid.find('.clschkPatientDocs').prop('checked', $(this).is(':checked'));
    $documentGrid.find('.clschkPatientDocs').trigger('change');
});
$(document).off('click', '.clschkPatientDocsHeadAG').on('click', '.clschkPatientDocsHeadAG', function () {
    var $documentGrid = $(this).closest('#Grid_ComplaintDocument');
    $documentGrid.find('.clschkPatientDocs').prop('checked', $(this).is(':checked'));
    $documentGrid.find('.clschkPatientDocs').trigger('change');
});
$(document).off('click', '.clsUmAgMultiDocsDownload').on('click', '.clsUmAgMultiDocsDownload', function (e) {
    if ($(this).attr("disabled") === "disabled") {
        CustomAlert('Documents with external URLs cannot be downloaded. Please deselect URL-only documents.');
        e.preventDefault(); // Prevent the default action
        return false; // Stop further propagation
    }
    var $documentContainer = $(this).closest('#AuthInit_5_1, #ComplaintInit_5_1');
    if ($documentContainer.length == 0) {
        $documentContainer = $(this).attr("data-from") == "Auth" ? $(UmPatient_AuthInfo('').AuthDivId) : $(AgPatient_ComplaintInfo("", "").ComplaintDivId);
    }
    var selectedDocs = $documentContainer.find(".clschkPatientDocs:checked");
    var isHavingDraftDoc = false;
    if (selectedDocs.length == 0) {
        CustomAlert('Please select a document to download.');
        return;
    }
    var fileData = [];
    var fileNames = "";
    var documentId = "";
    var documentGuid = "";
    $.each(selectedDocs, function (index, element) {
        var path = $(element).attr("data-details");
        var details = path ? path.split("|") : [];
        var docName = details[0];
        if (docName && isDocumentUrl(docName)) { return true; }

        if ($(element).attr("data-documenttype") == "1") {
            isHavingDraftDoc = true;
            return;
        }
        else {
            var path = $(element).attr("data-details");
            fileNames += path.split("|")[0] + ",";
            documentId += path.split("|")[3] + ",";
            documentGuid += path.split("|")[4] + ",";
            var filemodel = {
                FileName: path.split("|")[0],
                DocumentId: path.split("|")[3],
                DocumentGuid: path.split("|")[4],
                LetterQueueID: path.split("|")[1]
            };
            fileData.push(filemodel);
        }
    });
    if (isHavingDraftDoc) {
        CustomAlert('Draft documents cannot be downloaded.');
        return;
    }
    var apiurl = baseURL + "/ActivityRecord/DownloadAsZip?entityType=";
    if ($(e.currentTarget).attr("data-from") == "Auth") {
        var PI = UmPatient_AuthInfo('');
        AuditLog(3, actionTypeEnum.Download, "Auth Documents", PI.PatientId, $("#Session_LoggedInUserID").val(), fileNames.substr(0, fileNames.lastIndexOf(',')), PI.AuthNo);
        moduleId = 3;
        apiurl = apiurl + "UMDoc";

    } else if ($(e.currentTarget).attr("data-from") == "Complaint") {
        var PI = AgPatient_ComplaintInfo("", "");
        AuditLog(5, actionTypeEnum.Download, "Letters and Documents", PI.PatientId, memberidval, fileNames.substr(0, fileNames.lastIndexOf(',')), '', PI.ComplaintId, '');
        moduleId = 5;
        apiurl = apiurl + "ComplaintLetterDoc";
    }
    var model = {
        FilesData: fileData
    };

    var rvtoken = $('[name=__RequestVerificationToken]').val();
    downloadFileToBrowserViaPostRequest(apiurl, rvtoken, model);
});

function downloadFileToBrowserViaPostRequest(apiurl, rvtoken, model) {
    const fetchDocOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            '__RequestVerificationToken': rvtoken
        },
        body:
            JSON.stringify(model)
    };

    let fetchFilename = '';
    loader(1);
    fetch(apiurl, fetchDocOptions)
        .then((res) => {
            const header = res.headers.get('Content-Disposition');
            const parts = header.split(';');
            fetchFilename = parts[1].split('=')[1];
            return res.blob();
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fetchFilename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Download Failed!'))
        .finally(() => loader(0));
}

$(document).off('click', '#btnAgDocumentDynamicColumns').on('click', '#btnAgDocumentDynamicColumns', function () {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Common/DinamicColumns?section=" + "AG DOCUMENTS",
        popUpHeader: "Config Columns",
        popLevel: 1,
        closeButton: '#btnCancel',
        onClose: function () { $("#btnUploadDoc").show(); }
    });
});

function CancelMedication() {
    $('#dvOverlayMedication').hide();
    var gridId = "#ManuallyEnteredMedications";
    if (viewUnifiedMedications) {
        gridId = $('#divMedicationsDetailsGrid').is(':visible') ? '#UnifiedMedicationsDetailsGrid' : '#UnifiedMedicationsList';
        $(gridId).data("kendoGrid").dataSource.read();
    }
    else {
        $(gridId).data("kendoGrid").dataSource.page(1);
    }
    $('#spnMedCodeNameVd').text('');
    $('#ManualMadicationId').show();
    $('#ClaimMedicationId').show();
    $('#divShowAllMedications').show();
    $('#MedicationAddEditFormId').hide();
    $('#MedicationPharmacyAuditTrail').hide();
    $('#btnALLFID').show();
    $('#btnFldForceblySave').hide();
    $('#btnMedicationDetailsAdd, #btnUnifiedMedDetailsAdd').show();
    clearCheckedRows();
    if (!$('#lnkDrugInteractionsTab').is(':visible')) {
        if (viewUnifiedMedications) {
            clearAllUnifiedMedControls();
        }
        else {
            ClearAllMedicationControls();
        }
    }
    $('#MedicationPharmacyAuditTrail').html('');
}

(function ($) {
    $.getScript = function (url, callback, cache) {
        $.ajax({
            type: "GET",
            url: url,
            async: false,
            success: callback,
            dataType: "script",
            cache: cache||true
        });
    };

    /*
     * Function to change one element type to another, preserving everything inside the element
     *
     * USAGE: $('strong').changeElementType('h2');
     */
    $.fn.changeElementType = function (newType) {
        var attrs = {};

        if (this[0] && this[0].attributes && this[0].attributes.length > 0) {
            $.each(this[0].attributes, function (idx, attr) {
                attrs[attr.nodeName] = attr.nodeValue;
            });
        }

        this.replaceWith(function () {
            return $("<" + newType + "/>", attrs).append($(this).contents());
        });
    };
})(jQuery);

function resizePopupKendoGrid(popupId) {
    if ($(popupId).find('.k-grid').length > 0) {
        kendo.resize($(popupId).find('.k-grid'));

    }
}
function formatBytes(bytes) {
    var str = "";
    if (bytes < 1024) {
        str = bytes + " Bytes";
    }
    else if (bytes < 1048576) {
        str = (bytes / 1024).toFixed(0) + " KB";
    }
    else if (bytes < 1073741824) {
        str = (bytes / 1048576).toFixed(0) + " MB";
    }
    else {
        //sonar
    }
    return str;
}
$(document).off('click', '#btnCloseRequestReceivedAcceptComments').on('click', '#btnCloseRequestReceivedAcceptComments', function () {
    $('#ReqAcptIsConfidential').html('');
});

$(document).off('click', '#btnCloseRequestRejectComments').on('click', '#btnCloseRequestRejectComments', function () {
    $('#RequestRejectIsConfidential').html('');
});

/**
 * Handles the export flow for grids with a warning when the record count exceeds 1,000.
 * @param {string} gridId - The Kendo grid element ID.
 * @param {string} containerId - The parent container ID for scoping alert selectors.
 * @param {string} alertDivId - The alert div ID where the warning banner renders.
 * @param {function} exportFn - The export function to call.
 */
function handleExportWithWarning(gridId, containerId, alertDivId, exportFn) {
    var gridCount = $('#' + gridId).data('kendoGrid').dataSource.total();
    var containerSel = '#' + containerId;
    var alertSel = containerSel + ' #' + alertDivId;
    if (gridCount > 1000) {
        A11yAlerts.create(alertSel, 'This grid has over 1,000 records. Exports include only the 1,000 most recent. Add filters for a complete export.',
            {
                alertType: A11yAlerts.ALERT_TYPE.WARNING, isModal: false, keepOpen: true, btnObject: [{ btnId: 'btnExportAnyway', btnText: 'Export Anyway' },
                { btnId: 'btnRefineFilter', btnText: 'Refine Filters' }]
            });

        $(alertSel + ' .ah-alert-banner').addClass('ah-multi-alert');
        $(containerSel + ' #btnAlertClose').unbind("click").bind("click", function () {
            $('.ah-alert-banner', alertSel).remove();
        });

        $(document).off('click', containerSel + ' #btnExportAnyway').on('click', containerSel + ' #btnExportAnyway', function () {
            exportFn();
            $(containerSel + ' #btnAlertClose').trigger('click');
        });

        $(containerSel + ' #btnRefineFilter').unbind("click").bind("click", function () {
            $(containerSel + ' #btnAlertClose').trigger('click');
        });

        $(containerSel + ' #btnAlertClose').removeAttr("onclick");
    }
    else {
        exportFn();
    }
}
